(() => {
//working bundle - With CDN Links.
//import kendo from '@progress/kendo-ui';
//import { isDate } from 'util';
let $254a84bc556d8bd3$export$8e0397c03d8b0af5 = new WeakMap();
class $254a84bc556d8bd3$var$Utilities {
    constructor(){
        $(document).on('change', 'input', function(e) {
            var currentInput = $(e.target);
            var errorSign = currentInput.closest('div').find('.fa-exclamation-circle.text-danger');
            if (errorSign !== undefined && errorSign.length > 0) errorSign.remove();
        });
        $(document).on('focus', 'textarea', function(e) {
            var currentInput = $(e.target);
            var errorSign = currentInput.closest('.row').find('label .fa-exclamation-circle.text-danger');
            if (errorSign !== undefined && errorSign.length > 0) errorSign.remove();
        });
    }
    IsInternetExplorer() {
        let ua = window.navigator.userAgent;
        let oldIE = ua.indexOf('MSIE ');
        let newIE = ua.indexOf('Trident/');
        return oldIE > -1 || newIE > -1;
    }
    IsEdgeBrowser() {
        return /Edge\/\d./i.test(navigator.userAgent);
    }
    LoadHtmlTemplate(path, options, callback) {
        $.get(path, {
            'partialViewPath': options.viewName,
            'tyrePosition': options.positionLabel
        }).done(function(template) {
            var $template = $(template);
            callback($template);
        });
    }
    isDate(date) {
        return date instanceof Date && !isNaN(date.valueOf());
    }
    IsInArray(date, dates) {
        for(let idx = 0, length = dates.length; idx < length; idx++){
            let d = dates[idx];
            if (this.isDate(d)) {
                if (date.getFullYear() === d.getFullYear() && date.getMonth() === d.getMonth() && date.getDate() === d.getDate()) return true;
            }
        }
        return false;
    }
    previousDaysInCurrentMonth() {
        let today = new Date();
        let previousDays = [];
        for(let i = 0; i <= moment().daysInMonth(); i++)if (i < today.getUTCDate()) previousDays.push(new Date(today.getFullYear(), today.getMonth(), i));
        return previousDays;
    }
    IsEven(n) {
        return n % 2 === 0;
    }
    GetMonthNames() {
        return [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
    }
    ShowNextRow(currentDomElement, nextXrows, targetClass) {
        $(currentDomElement).parents('.' + targetClass).nextAll(':lt(' + nextXrows + ')').show();
    }
    CheckIfMobilePhoneProvided(inputList) {
        var regex = /^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/;
        if (inputList !== undefined && inputList.length > 0) for(var index = 0; index < inputList.length; index++){
            var currentInput = inputList[index];
            var phoneNumber = $(currentInput).val();
            if (regex.test(phoneNumber) === true) return true;
        }
        return false;
    }
    GetVisibleCount() {
        // Left-align the breadcrumbs to simplify the calculation
        var offsetWidth = $('.mobile-breadcrumb-nav')[0].offsetWidth;
        var justifyContent = $('.mobile-breadcrumb-nav').css('justify-content');
        var visibleItemCount = 0;
        $('.mobile-breadcrumb-nav').css('justify-content', 'left');
        $('.mobile-breadcrumb-nav li').each(function(index) {
            var right = $(this).position().left + $(this).outerWidth();
            if (right > offsetWidth) {
                // Exit, because our breadcrumb is not completely visible
                visibleItemCount = index;
                return false;
            }
        });
        // Restore alignment, as soon as we know how many breadcrumbs are visible
        $('.mobile-breadcrumb-nav').css('justify-content', justifyContent);
        return visibleItemCount;
    }
    FormatMobileBreadcrumbNav() {
        var serviceBreadcrumbs = $('.mobile-breadcrumb-nav li');
        serviceBreadcrumbs.show();
        var scrollWidth = $('.mobile-breadcrumb-nav')[0].scrollWidth;
        var offsetWidth = $('.mobile-breadcrumb-nav')[0].offsetWidth;
        var contentFits = scrollWidth <= offsetWidth;
        // Work out how many breadcrumbs will fit in space
        var itemCount = serviceBreadcrumbs.length;
        var visibleItemCount = 0;
        if (!contentFits) {
            // Show overflow buttons, which will reduce the size of our container, so
            // calculate visible breadcrumbs afterwards
            $('.mobile-breadcrumb-overflow').parent().show();
            visibleItemCount = this.GetVisibleCount();
        } else {
            $('.mobile-breadcrumb-nav').css('justify-content', 'center');
            $('.mobile-breadcrumb-overflow').parent().hide();
            return;
        }
        // Works out a range that positions the active breadcrumb two positions from the end
        // using a 1-based active index
        var activeIndex = serviceBreadcrumbs.index($('.mobile-breadcrumb-nav li.active')) + 1;
        var end = activeIndex + 2;
        if (end > itemCount) end = itemCount;
        var start;
        if (end < visibleItemCount) {
            start = 1;
            end = visibleItemCount;
        } else start = end - visibleItemCount + 1;
        var range = {
            active: activeIndex,
            start: start,
            end: end,
            left: start - 1,
            right: itemCount - end
        };
        // Show buttons that fall within our visible range and hide the rest
        $('.mobile-breadcrumb-nav').css('justify-content', 'space-between');
        $('#leftOverflow').text('-' + (range.left > 0 ? range.left : ''));
        $('#rightOverflow').text('+' + (range.right > 0 ? range.right : ''));
        $('.mobile-breadcrumb-nav li').each(function(index) {
            if (index + 1 < range.start || index + 1 > range.end) $(this).hide();
            else $(this).show();
        });
    }
    BuildMobileBreadcrumbNav() {
        var html = '';
        var template = kendo.template($('#mobile-breadcrumb-template').html());
        $("#serviceBreadcrumb li:not([style*='display: none'])").each(function(index) {
            var li = $(this);
            var heading = li.attr('data-menuanchor').toLowerCase().replace('anchor', '');
            // skip confirmation step because we'll add an 'fa-check' for it after this loop
            if (heading === 'confirmation') return;
            // Evaluate CSS class
            var cssClass = '';
            if (li.hasClass('active')) cssClass = 'active';
            else if (li.hasClass('validated')) cssClass = 'validated';
            // Pass data to template
            var data = {
                index: index + 1,
                cssClass: cssClass,
                heading: heading
            };
            html += template(data);
        });
        html += "<li class='mobile-breadcrumb'><i class='fa fa-check'></i></li>";
        $('.mobile-breadcrumb-nav').empty().html(html);
        this.FormatMobileBreadcrumbNav();
    }
    RefreshMobileBreadcrumbNav() {
        $("#serviceBreadcrumb li:not([style*='display: none'])").each(function(index) {
            // Remove classes on our mobile breadcrumb
            var mobileBreadcrumb = $('.mobile-breadcrumb-nav li:nth-child(' + (index + 1) + ')');
            mobileBreadcrumb.removeClass('active');
            // Find out active class on main breadcrumb and set on mobile
            // breadcrumb
            var breadcrumb = $(this);
            if (breadcrumb.hasClass('active')) mobileBreadcrumb.addClass('active');
            else if (breadcrumb.hasClass('validated')) mobileBreadcrumb.addClass('validated');
        });
        this.FormatMobileBreadcrumbNav();
    }
    incrementBreadCrumbs(activeSection, nextSection) {
        $('[data-menuanchor="' + nextSection.anchor + '"]').addClass('active');
        $('[data-menuanchor="' + activeSection.anchor + '"]').removeClass('active').addClass('validated');
        this.RefreshMobileBreadcrumbNav();
    }
    DoNotAllowDepotSelection() {
        var subdomains = [
            'leaseplan',
            'micheldever',
            'mfs',
            'northgate',
            'vms',
            'arval',
            'omodaandjaecoo',
            'mg',
            'hyundai',
            'honda',
            'kindertons',
            'byd'
        ];
        return subdomains.includes(subdomain);
    }
    DoNotShowCalendar() {
        var hideCalendar = false;
        if (this.IsVMS()) {
            if (this.IsChecked('ServiceRequiredRapidResponse') || this.IsChecked('ServiceRequiredNextDayMobile') || this.IsChecked('ServiceRequiredSameDayMobile')) hideCalendar = true;
        }
        var subdomains = [
            'mfs'
        ];
        return subdomains.includes(subdomain) || hideCalendar;
    }
    IsChecked = (id)=>{
        var result = false;
        if ($('#' + id).length) result = $('#' + id).is(":checked");
        return result;
    };
    IsMfs() {
        return subdomain == 'mfs';
    }
    IsVMS() {
        return subdomain == 'vms';
    }
}
class $254a84bc556d8bd3$export$61b5e5bf1558fa5f {
    constructor(success, inputConcerned, errorMessage){
        this.success = success;
        this.input = inputConcerned;
        this.errorMessage = errorMessage;
    }
}
let $254a84bc556d8bd3$export$366dc4c52172531e = new $254a84bc556d8bd3$var$Utilities();


class $f736a2b71cdbd3b5$var$Common {
    static HideUserMessage() {
        $('#UserMessage').hide();
    }
    static ShowUserMessage(title, message, hidePanels) {
        if (hidePanels) $('#mainContent').hide();
        $('#UserMessage #UserMessage_Title').html(title);
        $('#UserMessage #UserMessage_Message').html(message);
        $('#UserMessage').show();
    }
    static ShowGenericError() {
        $('#ErrorDialog').kendoDialog({
            width: '450px',
            title: 'Error',
            closable: true,
            modal: false,
            content: 'Sorry, an error occured. Please try again or contact your dedicated Driverline for assistance'
        });
    }
    static CustomerOrderNumberValidator() {
        return $('#Mileage').kendoValidator({
            rules: {
                customerOrderNumberRequired: function(input) {
                    return false;
                }
            },
            messages: {
                customerOrderNumberRequired: 'Invalid mileage. Must be greater than previous mileage.'
            }
        }).data('kendoValidator');
    }
    static GetVehicleValidator() {
        return $('#VehicleDetailsSection').kendoValidator({
            rules: {
                minimumMileageRequired: function(input) {
                    var mileageSupplied = $('#Mileage').val().replace(/\,/g, '');
                    var currentMileage = $('#VehicleMileage').val();
                    var confirmMileageCheckBox = $('#ConfirmMileageCheckBox').is(':checked');
                    if (parseInt(currentMileage) > parseInt(mileageSupplied) && !confirmMileageCheckBox) {
                        let msg = `The mileage provided is lower than the last reading (${currentMileage}). <br/>Check this box to confirm the mileage you have entered is correct, or re enter.`;
                        $('#ConfirmMileageCheckBox').next().addClass('k-checkbox-label').html(msg);
                        $('#ConfirmMileageContainer').removeClass('d-none').addClass('d-inline-block');
                        $('#vehicle-mileage').text(currentMileage);
                        return false;
                    } else if (!confirmMileageCheckBox) $('#ConfirmMileageContainer').removeClass('d-inline-block').addClass('d-none');
                    if (parseInt(mileageSupplied) > 2000000) {
                        let msg = `The provided mileage can not be higher than 2,000,000 miles!`;
                        $('#ConfirmMileageCheckBox').next().removeClass('k-checkbox-label').html(msg);
                        $('#ConfirmMileageContainer').removeClass('d-none').addClass('d-inline-block');
                        return false;
                    } else if (!ConfirmMileageCheckBox) $('#ConfirmMileageContainer').removeClass('d-inline-block').addClass('d-none');
                    return true;
                }
            },
            messages: {
                minimumMileageRequired: 'Invalid mileage. Must be greater than previous mileage.'
            }
        }).data('kendoValidator');
    }
    static BindValidationStyles(validator) {
        validator.bind("validate", function(e) {
            let $container = $(e.sender.element);
            let $invalidInputs = $container.find(".k-invalid");
            let validationManager = {
                _tooltipTemplate: `<div class="tooltip tooltip-error tooltip-checkbox" role="tooltip"><div class="arrow tooltip-arrow-error"></div><div class="tooltip-inner tooltip-inner-error"></div></div>`,
                _highlightLabel: (invalidInput)=>$(invalidInput).closest(".row").find("label:not(.k-radio-label)").addClass("error-label"),
                applyPrivacyCheckboxInputValidationStyle: (invalidInput)=>{
                    $(invalidInput).prop("data-toggle", "tooltip");
                    $(invalidInput).parent().find("label").addClass("privacy-checkbox-validation-label");
                    $(invalidInput).tooltip({
                        boundary: "body",
                        trigger: "manual",
                        placement: "auto",
                        template: validationManager._tooltipTemplate
                    });
                    $(invalidInput).tooltip("show");
                },
                applyLabelLessTextboxValidationStyle: (invalidInput)=>{
                    const errorMessage = $(invalidInput).parent().find('.k-tooltip-validation.k-invalid-msg').text();
                    if ($(invalidInput).parent().find(".error-icon-absolute").length === 0) {
                        let newElement = `<i class="fas fa-exclamation-circle error-icon-absolute" style="left: ${$(invalidInput).position().left + 15}px; top: ${$(invalidInput).position().top + 8}px;" data-toggle="tooltip" title="${errorMessage}" tabindex="-1"></i>`;
                        $(invalidInput).parent().append(newElement);
                        $('[data-toggle="tooltip"]').tooltip({
                            boundary: "body",
                            trigger: "focus",
                            placement: "auto",
                            template: validationManager._tooltipTemplate
                        });
                        (0, $254a84bc556d8bd3$export$8e0397c03d8b0af5).set(invalidInput, $(invalidInput).prop("placeholder"));
                        $(invalidInput).removeAttr("placeholder");
                    }
                },
                applyGenericValidationStyle: (invalidInput)=>{
                    const errorMessage = $(invalidInput).closest(".row.form-group").find(".k-tooltip-validation.k-invalid-msg").text();
                    const newElement = `<i class="fas fa-exclamation-circle error-icon" data-toggle="tooltip" title="${errorMessage}" tabindex="-1"></i>`;
                    if ($(invalidInput).closest(".row.form-group").find(".error-icon").length === 0) {
                        validationManager._highlightLabel(invalidInput);
                        $(invalidInput).closest(".row.form-group").find("label:not(.k-radio-label)").append(newElement);
                        $('[data-toggle="tooltip"]').tooltip({
                            boundary: "body",
                            trigger: "focus",
                            placement: "auto",
                            template: validationManager._tooltipTemplate
                        });
                        if ($(invalidInput).is(':radio')) $(invalidInput).closest(".row.form-group").find(".k-radio-label").addClass("error-radio-btn-label");
                    }
                },
                applyWheelplanPanelValidation: (invalidPanel)=>{
                    let newElement = `<i class="fas fa-exclamation-circle error-icon-absolute" style="left: 30px; top: 15px;" data-toggle="tooltip" title="${$(invalidPanel).parent().find('.k-tooltip-validation.k-invalid-msg').text()}" tabindex="-1"></i>`;
                    $(invalidPanel).parent().append(newElement);
                    $('[data-toggle="tooltip"]').tooltip({
                        boundary: "body",
                        trigger: "focus",
                        placement: "auto",
                        template: validationManager._tooltipTemplate
                    });
                },
                applyBtnValidationStyle: (invalidInput)=>{
                    const $btn = $(invalidInput).parent().find(".btn-to-validate");
                    const errorMessage = $(invalidInput).parent().find(".k-invalid-msg").text();
                    const newElement = `<i class="fas fa-exclamation-circle error-icon" data-toggle="tooltip" title="${errorMessage}" tabindex="-1"></i>`;
                    $btn.before(newElement);
                    $('[data-toggle="tooltip"]').tooltip({
                        boundary: "body",
                        trigger: "focus",
                        placement: "auto",
                        template: validationManager._tooltipTemplate
                    });
                }
            };
            if ($container.is('[id^="wheelPlanSection"]')) validationManager.applyWheelplanPanelValidation($container.find('.tyreDetailInvalid'));
            else if ($invalidInputs) $invalidInputs.each((index, invalidInput)=>{
                if (!$invalidInputs.hasClass('noValidationStyle')) {
                    // Making sure the input is not hidden
                    let isHidden = $(invalidInput).is(':hidden');
                    let isDropDownList = $(invalidInput).data("role") === "dropdownlist";
                    if (!isHidden || isHidden && isDropDownList) {
                        // check if input is single checkbox
                        if ($(invalidInput).hasClass('privacyCheckboxValidation')) validationManager.applyPrivacyCheckboxInputValidationStyle(invalidInput);
                        else // check if input is textbox and without label, if so apply icon within
                        if ($(invalidInput).is('input:text') && $(invalidInput).data('role') !== 'dropdownlist' && ($(invalidInput).closest('.row.form-group').length === 0 || $(invalidInput).closest('.form-group.row').find('label:not(.k-radio-label)').length === 0)) validationManager.applyLabelLessTextboxValidationStyle(invalidInput);
                        else if (isDropDownList) {
                            validationManager.applyGenericValidationStyle(invalidInput);
                            $(invalidInput).prevAll().closest(".k-dropdown-wrap").addClass('invalid-border');
                        } else // for everything else apply generic styles
                        validationManager.applyGenericValidationStyle(invalidInput);
                    } else if ($(invalidInput).hasClass('btn-validation-input')) validationManager.applyBtnValidationStyle(invalidInput);
                }
            });
        });
    }
    static RemoveValidationStyles(input, panel) {
        if (input) {
            const removeHighlightLabel = (invalidInput)=>$(invalidInput).closest('.row.form-group').find('label').removeClass('error-label');
            const removeErrorIcon = (invalidInput)=>$(invalidInput).closest('.row.form-group').find('label').find('.error-icon').remove();
            const removeErrorIconOnBtn = (invalidHiddenInput)=>$(invalidHiddenInput).parent().find('.error-icon').remove();
            const removeInputErrorIcon = (invalidInput)=>{
                const errorIconEl = $(invalidInput).parent().find('.error-icon-absolute');
                if (errorIconEl.length !== 0) {
                    errorIconEl.remove();
                    if ((0, $254a84bc556d8bd3$export$8e0397c03d8b0af5).has(input)) {
                        (0, $254a84bc556d8bd3$export$8e0397c03d8b0af5).get(input);
                        $(input).attr('placeholder', (0, $254a84bc556d8bd3$export$8e0397c03d8b0af5).get(input));
                        (0, $254a84bc556d8bd3$export$8e0397c03d8b0af5).delete(input);
                    }
                }
            };
            const removeKendoHighlight = (invalidInput)=>$(invalidInput).removeClass('k-invalid');
            const removePrivacyCheckboxValidationStyles = (invalidInput)=>{
                $(invalidInput).removeAttr('data-toggle');
                $(invalidInput).parent().find('label').removeClass('privacy-checkbox-validation-label');
            };
            if ($(input).prop('data-toggle') === 'tooltip') // dispose of a tooltip when applied to the DOM Element itself.
            $(input).tooltip('dispose');
            else // dispose of a tooltip when applied to the DOM Element parent.
            $(input).closest('.row').find('[data-toggle="tooltip"]').tooltip('dispose');
            if ($(input).hasClass('privacyCheckboxValidation')) removePrivacyCheckboxValidationStyles(input);
            else if ($(input).hasClass('noLabelValidation')) removeInputErrorIcon(input);
            else {
                removeHighlightLabel(input);
                removeErrorIcon(input);
                removeErrorIconOnBtn(input);
                removeKendoHighlight(input);
                let isDropDownList = $(input).data("role") === "dropdownlist";
                if ($(input).is(':radio')) $(input).closest('.row.form-group').find('.k-radio-label').removeClass('error-radio-btn-label');
                else if (isDropDownList) $(input).prevAll().closest(".k-dropdown-wrap").removeClass('invalid-border');
            }
        } else if (panel && panel.length > 0) {
            $(panel).find('[data-toggle="tooltip"]').tooltip('dispose');
            $(panel).find('.error-icon-absolute').remove();
            $(panel).find('.tyreDetailInvalid').removeClass('tyreDetailInvalid');
        }
    }
    static Bounce(element, times, distance, speed) {
        for(var i = 0; i < times; i++)element.animate({
            marginTop: '-=' + distance
        }, speed).animate({
            marginTop: '+=' + distance
        }, speed);
    }
    static InitialiseEmailSupportTab() {
        $('#email-tab').click(()=>$('#email-container').toggle('slide'));
        [
            $('#supportLargeScreenForm'),
            $('#supportSmallScreenForm')
        ].forEach((form)=>{
            form.on('submit', (event)=>{
                if (event.target.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                } else {
                    let driverData = null;
                    let endpoint = null;
                    let $formContainer = $(event.target).closest('.form');
                    $formContainer.find('#sendSupportEmail').prop('disabled', true);
                    let formData = {
                        fullname: $formContainer.find('#user-name').val(),
                        email: $formContainer.find('#user-email').val(),
                        phone: $formContainer.find('#user-phone').val(),
                        note: $formContainer.find('#user-note').val()
                    };
                    let formName = $('#fullPageContainer').attr('data-formName');
                    formName;
                    driverData = null;
                    let data = {
                        'driverData': driverData,
                        'formData': formData
                    };
                    $.ajax({
                        type: 'POST',
                        url: endpoint,
                        data: data,
                        success: function() {
                            $('#email-container, #emailModal').find('#confirmationMessage').show(), setTimeout(function() {
                                $('#email-container, #emailModal').find('#confirmationMessage').fadeOut();
                                $('#email-container, #emailModal').toggle('slide').find('textarea').val('');
                                $('.modal-backdrop').hide();
                            }, 3000);
                        },
                        error: ()=>console.log('error sending email.')
                    });
                }
                event.target.classList.add('was-validated');
                event.preventDefault();
            });
        });
    }
    static GetQueryStringValue(key, url) {
        if (!url) url = window.location.href;
        key = key.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + key + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}
var $f736a2b71cdbd3b5$export$2e2bcd8739ae039 = $f736a2b71cdbd3b5$var$Common;
$(document).ready(function() {
    $('.tip').tooltip({
        boundary: "body",
        trigger: "focus",
        placement: "auto"
    });
    $f736a2b71cdbd3b5$var$Common.InitialiseEmailSupportTab();
    $(document).on('focus focusout click', 'input.k-invalid', (event)=>$f736a2b71cdbd3b5$var$Common.RemoveValidationStyles(event.target));
    $(document).on('change', '.k-dropdown', (event)=>$f736a2b71cdbd3b5$var$Common.RemoveValidationStyles(event.target));
    $(document).on('click', '.btn', (event)=>$f736a2b71cdbd3b5$var$Common.RemoveValidationStyles(event.target));
    if (!$('#fullPageContainer[data-formName="VE103"]').length) $('#supportModalBtn').hide();
    document.documentElement.style.setProperty('--customer-color', SITE_COLOR);
    document.documentElement.style.setProperty('--customer-sub-color', SITE_COLOR2);
    document.documentElement.style.setProperty('--customer-color-gradient1', SITE_COLOR_GRADIENT_1);
    document.documentElement.style.setProperty('--customer-color-gradient2', SITE_COLOR_GRADIENT_2);
    document.documentElement.style.setProperty('--customer-color-gradient3', SITE_COLOR_GRADIENT_3);
    document.documentElement.style.setProperty('--customer-color-gradient4', SITE_COLOR_GRADIENT_4);
    document.documentElement.style.setProperty('--customer-header-bar-style', SITE_HEADER_BAR_STYLE);
    document.documentElement.style.setProperty('--customer-header-row-style', SITE_HEADER_ROW_STYLE);
    if (SITE_TITLE_BAR_COLOR_USE_GRADIENT.toUpperCase() === 'TRUE') {
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient1', SITE_COLOR_GRADIENT_1);
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient2', SITE_COLOR_GRADIENT_2);
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient3', SITE_COLOR_GRADIENT_3);
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient4', SITE_COLOR_GRADIENT_4);
    } else {
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient1', SITE_COLOR);
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient2', SITE_COLOR);
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient3', SITE_COLOR);
        document.documentElement.style.setProperty('--customer-title-bar-color-gradient4', SITE_COLOR);
    }
    $('.view-privacy-policy').on('click', (event)=>{
        $('#privacyPolicy').toggleClass('d-none');
    });
});


/*****************************************/ /************* MODEL CLASSES *************/ /*****************************************/ class $a854c42000216589$export$ab51f1f03e871453 {
    constructor(){
        this.wheelSelected = null;
        this.width = null;
        this.ratio = null;
        this.diameter = null;
        this.rating = null;
        this.load = null;
        this.construction = null;
        this.brand = null;
        this.title = null;
        this.damageType = null;
        this.pattern = null;
    }
    static getTyreBrands(callback) {
        $.get('/Tyres/GetAllTyreBrands').done(function(data) {
            callback(data);
        });
    }
}
class $a854c42000216589$export$2a98583447337f2c {
    constructor(mileage, reg, id, make, model, orderNumber, mileageCheckSuppression){
        this.vehicleMileage = mileage;
        this.vehicleId = id;
        this.vehicleReg = reg;
        this.vehicleMake = make;
        this.vehicleModel = model;
        this.orderNumber = orderNumber;
        this.mileageCheckSuppression = mileageCheckSuppression;
    }
}
class $a854c42000216589$export$22dcfb8ced99b296 {
    constructor(className, wheelPlans){
        this.name = className;
        this.wheelPlans = wheelPlans;
    }
    get wheelPlans() {
        return this._wheelPlans;
    }
    set wheelPlans(wheelPlan) {
        this._wheelPlans = wheelPlan;
    }
    get plans() {
        return this._plans;
    }
    set plans(wheelPlan) {
        this._plans = wheelPlan;
    }
    GetWheelPlans(className) {
        //populate wheel plan.
        return this.wheelplans.filter((plan)=>{
            return plan.className == className;
        });
    }
    GetWheelPlanImageName(className, id) {
        return this._wheelPlans.find((plan)=>plan.id === id).image;
    }
}
class $a854c42000216589$export$51caeb4db17cd636 {
    constructor(){
        this._wheelPlan = null;
        this._wheelDetails = null;
        this._vehicleDetails = null;
        this._tyreDetailLines = [];
        this._wheelsSelected = null;
        this._tyreHistory = null;
        this._class = null;
    }
    get tyreDetailLines() {
        return this._tyreDetailLines;
    }
    set tyreDetailLines(newDetails) {
        this._tyreDetailLines = newDetails;
    }
    get wheelPlan() {
        return this._wheelPlan;
    }
    set wheelPlan(newPlan) {
        this._wheelPlan = newPlan;
    }
    get vehicleDetails() {
        return this._vehicleDetails;
    }
    set vehicleDetails(newDetails) {
        this._vehicleDetails = newDetails;
    }
    get wheelDetails() {
        return this._wheelDetails;
    }
    set wheelDetails(newDetails) {
        this._wheelDetails = newDetails;
    }
    get wheelSelected() {
        return this._wheelsSelected;
    }
    set wheelSelected(newSelection) {
        this._wheelsSelected = newSelection;
    }
    get tyreHistory() {
        return this._tyreHistory;
    }
    set tyreHistory(newHistory) {
        this._tyreHistory = newHistory;
    }
    get class() {
        return this._class;
    }
    set class(newClass) {
        this._class = newClass;
    }
}
class $a854c42000216589$export$3bd673aceb961187 {
    constructor(name, homeLink){
        this._name = name;
        this._homeLink = homeLink;
    }
    get name() {
        return this._name;
    }
    get homeLink() {
        return this._homeLink;
    }
}
class $a854c42000216589$var$DataModel {
    constructor(){
        this._vehicle = new $a854c42000216589$export$51caeb4db17cd636();
        this._driver = null;
        this._bookingDetails = new $a854c42000216589$export$9e0f97765bb7a5d5();
        this.selectedDepot = null;
        this.customer = null;
    }
    get driver() {
        return this._driver;
    }
    set driver(newDriver) {
        this._driver = newDriver;
    }
    get vehicle() {
        return this._vehicle;
    }
    set vehicle(newVehicle) {
        this._vehicle = newVehicle;
    }
    get bookingDetails() {
        return this._bookingDetails;
    }
    set bookingDetails(newDetails) {
        this._bookingDetails = newDetails;
    }
    // builds an object for development to allow skipping steps when testing
    initSelfDevObject(constructedObject) {
        this.driver = constructedObject.driver;
        this.vehicle = constructedObject.vehicle;
        this.bookingDetails = constructedObject.bookingDetails;
    }
}
class $a854c42000216589$export$80c5523270cba9e9 {
    static getUnavailableBookingDates(callback) {
        let nonBookingDates = [];
        $.get('/Tyres/GetUnavailableBookingCalendarDates', function(data) {
            if (data !== undefined && data.length > 0) $.each(data, function(_index, date) {
                nonBookingDates.push(new Date(Date.parse(date)));
            });
        }).done(function() {
            callback(nonBookingDates);
        });
    }
    static getFirstAvailableDateTime() {
        return new Promise((resolve, reject)=>{
            $.get('/Tyres/GetFirstAvailableDateTime').done((data)=>resolve(data)).fail((error)=>reject(error));
        });
    }
}
class $a854c42000216589$export$4ffaef9f9e4625b3 {
    constructor(wheelType, roadworthySpare, spareSize, inflationKit, lockingWheelNuts, obstruction, obstructionDetails){
        this.wheelType = wheelType;
        this.obstructions = obstruction;
        this.roadworthySpare = roadworthySpare;
        this.spareSize = spareSize;
        this.inflationKit = inflationKit;
        this.lockingWheelNuts = lockingWheelNuts;
        this.obstructionDetails = obstructionDetails;
    }
}
class $a854c42000216589$export$c4123383392d4053 {
    constructor(title, firstname, lastname, mobile, landline, email, smsConfirmation, address, privacyPolicyAccepted, additionalInformation){
        this.title = title;
        this.firstname = firstname;
        this.surname = lastname;
        this.mobile = mobile;
        this.landline = landline;
        this.email = email;
        this.smsConfirmation = smsConfirmation;
        this.address = address;
        this.privacyPolicyAccepted = privacyPolicyAccepted;
        this.additionalInformation = additionalInformation;
    }
}
class $a854c42000216589$export$f5004a899ec10a9 {
    constructor(name, line1, line2, town, county, postcode){
        this.name = name;
        this.line1 = line1;
        this.line2 = line2;
        this.town = town;
        this.county = county;
        this.postcode = postcode;
    }
}
class $a854c42000216589$export$9e0f97765bb7a5d5 {
    constructor(){
        this._serviceRequired = null;
        this._location = new $a854c42000216589$export$f5004a899ec10a9();
        this._bookingDate = null;
        this._bookingTime = null;
        this._bookingDate2 = null;
        this._bookingTime2 = null;
        this._bookingDate3 = null;
        this._bookingTime3 = null;
        this._depot = null;
        this._addressType = null;
        this._jobType = null;
        this._jobTypeName = null;
    }
    get bookingDate() {
        return this._bookingDate;
    }
    set bookingDate(newDate) {
        this._bookingDate = newDate;
    }
    get bookingTime() {
        return this._bookingTime;
    }
    set bookingTime(newTime) {
        this._bookingTime = newTime;
    }
    get bookingDate2() {
        return this._bookingDate2;
    }
    set bookingDate2(newDate) {
        this._bookingDate2 = newDate;
    }
    get bookingTime2() {
        return this._bookingTime2;
    }
    set bookingTime2(newTime) {
        this._bookingTime2 = newTime;
    }
    get bookingDate3() {
        return this._bookingDate3;
    }
    set bookingDate3(newDate) {
        this._bookingDate3 = newDate;
    }
    get bookingTime3() {
        return this._bookingTime3;
    }
    set bookingTime3(newTime) {
        this._bookingTime3 = newTime;
    }
    get serviceRequired() {
        return this._serviceRequired;
    }
    set serviceRequired(newService) {
        this._serviceRequired = newService;
    }
    get location() {
        return this._location;
    }
    set location(newLocation) {
        this._location = newLocation;
    }
    get depot() {
        return this._depot;
    }
    set depot(newDepot) {
        this._depot = newDepot;
    }
    get addressType() {
        return this._addressType;
    }
    set addressType(addressTypeValue) {
        this._addressType = addressTypeValue;
    }
    get jobType() {
        return this._jobType;
    }
    set jobType(jobTypeValue) {
        this._jobType = jobTypeValue;
    }
    get jobTypeName() {
        return this._jobTypeName;
    }
    set jobTypeName(jobTypeNameValue) {
        this._jobTypeName = jobTypeNameValue;
    }
}
class $a854c42000216589$export$ffb7a2719c551bf4 {
    constructor(name, value, position){
        this.name = name;
        this.value = value;
        this.position = position;
        this.selected = false;
    }
}
class $a854c42000216589$export$5a83fe19d473e305 {
    static timesSaturday = [
        {
            id: 0,
            value: "Please Select"
        },
        {
            id: 9,
            value: "09:00AM"
        },
        {
            id: 10,
            value: "10:00AM"
        },
        {
            id: 11,
            value: "11:00AM"
        },
        {
            id: 12,
            value: "12:00PM"
        }
    ];
    static timesWeekday = [
        {
            id: 0,
            value: "Please Select"
        },
        {
            id: 9,
            value: "09:00AM"
        },
        {
            id: 10,
            value: "10:00AM"
        },
        {
            id: 11,
            value: "11:00AM"
        },
        {
            id: 12,
            value: "12:00PM"
        },
        {
            id: 13,
            value: "01:00PM"
        },
        {
            id: 14,
            value: "02:00PM"
        },
        {
            id: 15,
            value: "03:00PM"
        },
        {
            id: 16,
            value: "04:00PM"
        }
    ];
}
/*****************************************/ /************ GLOBAL VARIABLES ***********/ /*****************************************/ let $a854c42000216589$export$bd25e24024963319 = new $a854c42000216589$var$DataModel();
let $a854c42000216589$export$b8cfe935cdbfd3a9 = {
    collection: [
        {
            moniker: 'NSF',
            name: 'Passenger Side Front'
        },
        {
            moniker: 'OSF',
            name: 'Driver Side Front'
        },
        {
            moniker: 'NSR',
            name: 'Passenger Side Rear'
        },
        {
            moniker: 'OSR',
            name: 'Driver Side Rear'
        },
        {
            moniker: 'NSR2',
            name: 'Passenger Side Rear Outside'
        },
        {
            moniker: 'OSR2',
            name: 'Driver Side Rear Outside'
        },
        {
            moniker: 'SPARE',
            name: 'Spare'
        }
    ],
    getName (moniker) {
        return this.collection.find((tyre)=>tyre.moniker === moniker).name;
    }
};






class $6d0ce8ba0314f583$var$WheelPlans {
    // --------------------------------------------------
    // CONSTRUCTOR
    // --------------------------------------------------
    constructor(){
        this._wheelShapeOriginalColor = undefined;
        this._wheelShapes = undefined;
        this._wheelPlan = undefined;
    }
    // --------------------------------------------------
    // GETTER AND SETTER
    // --------------------------------------------------
    // --------------------------------------------------
    // 'PRIVATE' FUNCTIONS
    // --------------------------------------------------
    BindControls() {
        let _this = this;
        $('input[name="WheelPlan"], .selectWheelPlanBtn').off();
        $('input[name="WheelPlan"]').on('change', function() {
            (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelPlan = $(this).filter(':checked').val();
            $('#selectedTyresContainer').empty();
            _this.ShowDiagramSelection((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelPlan, $(this).filter(':checked').next('label').text(), false);
        });
        $('.selectWheelPlanBtn').on('click', function(e) {
            $('.wheel-plan-container').removeClass('tyreDetailInvalid');
            e.preventDefault();
            (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelPlan = $(e.target).parents('.wheel-plan-container').data('wheelplanid');
            _this.ShowDiagramSelection((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelPlan, true);
            (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).RemoveValidationStyles(undefined, $(this).closest('[id^="wheelPlanSection"]'));
        });
        $('.changeSpareRadio').on('change', function(args) {
            let $nextbutton = $('.nextButton');
            if (this.checked) {
                $nextbutton.show();
                _this._wheelPlan.SPARE.Selected = 1;
                (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).RemoveValidationStyles(undefined, $(args.target).closest('.wheel-plan-container'));
            } else _this._wheelPlan.SPARE.Selected = 0;
        });
    }
    BuildWheelPlanDom() {
        return new Promise((resolve, reject)=>{
            // TODO: reshape the getWheelplan methods and objects, done it quickly to implement Recaptcha properly.
            let { vehicleMileage: mileage, vehicleId: id, vehicleReg: registration, vehicleMake: make, vehicleModel: description } = (0, $a854c42000216589$export$bd25e24024963319).vehicle.vehicleDetails;
            $.post("tyres/UpdateVehicleWheelPlan", {
                "mileage": mileage,
                "id": id,
                "registration": registration,
                "make": make,
                "description": description
            }).done((updatedVehicle)=>{
                let responseObject = updatedVehicle ? JSON.parse(updatedVehicle) : null;
                let vehicleWheelPlans = responseObject ? responseObject.WheelPlans.filter((w)=>w.Name) : null;
                // WheelPlans header
                let wheelplansHeaderTemplate = $('#wheelPlanHeaderTemplate').html();
                Mustache.parse(wheelplansHeaderTemplate);
                let noWheelPlan = !vehicleWheelPlans;
                let wheelPlanHeader = vehicleWheelPlans && vehicleWheelPlans.length > 0;
                let renderedHeaderWheelplan = Mustache.render(wheelplansHeaderTemplate, {
                    "noWheelPlan": noWheelPlan,
                    "wheelPlanHeader": wheelPlanHeader
                });
                $('#wheelPlanHeaderContainer').html(renderedHeaderWheelplan);
                if (!vehicleWheelPlans) return resolve();
                // Add wheelplan index and active class for previous code compatibility
                let vehicleWheelPlansIndexed = vehicleWheelPlans.map((plan, index)=>{
                    plan.index = index + 1;
                    plan.active = plan.Id === 1 ? 'active' : 'inactive';
                    return plan;
                });
                // Radio Buttons template
                let wheelplansRadiosbtnTemplate = $('#wheelPlanRadioBtnTemplate').html();
                Mustache.parse(wheelplansRadiosbtnTemplate);
                let renderedRadioBtnWheelplan = Mustache.render(wheelplansRadiosbtnTemplate, {
                    "wheelplans": vehicleWheelPlansIndexed
                });
                $('#wheelPlanRadioButtonContainer').html(renderedRadioBtnWheelplan);
                // Wheelplan Images containers template
                let spareTyreImagePath = '/images/Tyres/spareTyreicon.png';
                let wheelplansTemplate = $('#wheelPlanTemplate').html();
                Mustache.parse(wheelplansTemplate);
                let renderedWheelplan = Mustache.render(wheelplansTemplate, {
                    "wheelplans": vehicleWheelPlansIndexed,
                    "spareTyreImage": spareTyreImagePath
                });
                $('#wheelPlansContainer').html(renderedWheelplan);
                resolve();
            }).fail(()=>{
                // WheelPlans header
                let wheelplansHeaderTemplate = $('#wheelPlanHeaderTemplate').html();
                Mustache.parse(wheelplansHeaderTemplate);
                let renderedHeaderWheelplan = Mustache.render(wheelplansHeaderTemplate, {
                    "noWheelPlan": true,
                    "wheelPlanHeader": false
                });
                $('#wheelPlanHeaderContainer').html(renderedHeaderWheelplan);
                reject();
            });
        });
    }
    InitialiseWheelPlanImages() {
        let _this = this;
        if ((0, $a854c42000216589$export$bd25e24024963319).vehicle.class.toUpperCase() === 'CAR') {
            $('.tyre-wheelPlan-Column').addClass('d-none');
            _this.SelectCarWheelPlan();
            var viewport = $(window).width();
            if (viewport < 767.98) {
                $('#wheelPlanCarouselContainer').removeClass('d-none');
                if ($('.carousel-inner .tyre-wheelPlan-Column').length > 0) $('.carousel-inner .tyre-wheelPlan-Column').removeClass('d-none active');
                else $('.tyre-wheelPlan-Column').prependTo($('.carousel-inner')).addClass('carousel-item').removeClass('offset-2 col-8 offset-md-0 col-md-6 col-lg-4 d-none active');
                $($('.tyre-wheelPlan-Column')[0]).addClass('active');
            }
        } else $('[name="WheelPlan"]').each(function(index, planElement) {
            var $wheelPlanName = $(planElement).next('label').text();
            var $wheelPlanDomlabel = $(planElement).attr('data-label');
            if (!$wheelPlanName) return;
            if ((0, $a854c42000216589$export$bd25e24024963319).vehicle.class.toUpperCase() == 'STANDARD CAR' || (0, $a854c42000216589$export$bd25e24024963319).vehicle.class.toUpperCase() == 'LCV') _this.LoadWheelPlanImage($(planElement).val(), $wheelPlanName, $('#' + $wheelPlanDomlabel + 'ImageContainer')).then(()=>{
                _this.FilterWheelplanSelection((0, $a854c42000216589$export$bd25e24024963319).vehicle.class, $wheelPlanName);
            });
            else _this.LoadWheelPlanImage($(planElement).val(), $wheelPlanName, $('#' + $wheelPlanDomlabel + 'ImageContainer'));
        });
    }
    SelectCarWheelPlan() {
        let _this = this;
        let $StandardCarWheelPlan = $('[name="WheelPlan"][data-label="StandardCar"]');
        let $wheelPlanDomlabel = $StandardCarWheelPlan.attr('data-label');
        let $wheelPlanName = $StandardCarWheelPlan.next('label').text();
        _this.LoadWheelPlanImage($StandardCarWheelPlan.val(), $wheelPlanName, $('#' + $wheelPlanDomlabel + 'ImageContainer')).then(()=>{
            _this.FilterWheelplanSelection((0, $a854c42000216589$export$bd25e24024963319).vehicle.class, $wheelPlanName);
        });
    }
    FilterWheelplanSelection(vehicleClass, wheelplanName) {
        if (!vehicleClass || !wheelplanName) return;
        if (vehicleClass.toUpperCase() === 'CAR' && wheelplanName.toUpperCase() === 'STANDARD CAR') {
            var $carselectbutton = $('#StandardCarDiagramContainer').find('.selectWheelPlanBtn');
            $carselectbutton.trigger('click');
        } else if (vehicleClass.toUpperCase() === 'LCV' && wheelplanName.toUpperCase().substring(wheelplanName.length - 3) === 'VAN') $('#StandardCarDiagramContainer').hide();
    }
    LoadWheelPlanImage(wheelPlanId, wheelPlanName, target) {
        let _this = this;
        return new Promise((resolve, reject)=>{
            // Exit if we don't have a valid wheel plan or the image already exist
            var isValidWheelPlanId = wheelPlanId && $.isNumeric(parseInt(wheelPlanId));
            var imageAlreadyDisplayed = target.find('svg').length > 0;
            if (!isValidWheelPlanId || imageAlreadyDisplayed) return;
            // Load image. IE renders dynamically created SVG in black, so we load image for IE using
            // an IFRAME, accepting that tooltips don't work
            var wheelPlanImage = _this.GetWheelPlanImageName(wheelPlanId);
            target.empty();
            $.ajax({
                type: 'GET',
                cache: false,
                url: '/images/tyres/' + wheelPlanImage,
                success: function(svg) {
                    var importedSVGRootElement = document.importNode(svg.documentElement, true);
                    target.append(importedSVGRootElement);
                    var svgElement = target.find('svg');
                    var isWheelPlanImage = wheelPlanImage !== 'no_image_available.svg';
                    if (svgElement && isWheelPlanImage) {
                        if (!(0, $254a84bc556d8bd3$export$366dc4c52172531e).IsInternetExplorer()) svgElement.css('height', '100%');
                        else svgElement.css('height', '400px');
                        $(svgElement).addClass('img-fluid');
                    }
                    return resolve();
                },
                error: function(error) {
                    reject(error);
                }
            });
            _this.ActivateWheelPlan(wheelPlanId, wheelPlanName, target);
        });
    }
    ResetWheelShapes() {
        let _this = this;
        $(_this._wheelShapes).off();
        $.each(_this._wheelShapes, function(index, wheel) {
            $(wheel).css('fill', _this._wheelShapeOriginalColor);
        });
    }
    GetWheelShapes(target, selector) {
        return target.find(selector);
    }
    UpdateImageTitle(text) {
        let title = $('svg title');
        if (title) title.text(text);
    }
    UpdateWheelPlanIdAndName(wheelPlanId, wheelPlanName, target) {
        // Overlay wheel plan name and title
        target.parents('.wheel-plan-container').find('.wheel-plan-name > h4 > .textValue').html(wheelPlanName);
        // Attach basic zoom feature to title
        let wheelPlanImage = this.GetWheelPlanImageName(wheelPlanId);
        let wheelPlanTitle = target.find('.wheel-plan-title');
        if (wheelPlanTitle) wheelPlanTitle.click(function() {
            $('#popupWheelPlan').dialog({
                width: 800,
                height: 800,
                modal: true
            });
            $('#popupWheelPlan').html("<iframe src='/images/WheelPlan/" + wheelPlanImage + "' style='height: 100%; width: 100%;' frameborder='0'/>");
        });
    }
    GetVehicleWheelPlanById(wheelPlanId) {
        let vehicle = (0, $a854c42000216589$export$22dcfb8ced99b296).plans.find((plan)=>plan.name === (0, $a854c42000216589$export$bd25e24024963319).vehicle.class.toLowerCase());
        var wheelplans;
        if (vehicle != undefined) wheelplans = vehicle.wheelPlans.find((plan)=>plan.id == wheelPlanId);
        else for(let index = 0; index < (0, $a854c42000216589$export$22dcfb8ced99b296).plans.length; index++)wheelplans = (0, $a854c42000216589$export$22dcfb8ced99b296).plans[index].wheelPlans.find((plan)=>plan.id == wheelPlanId);
        return wheelplans;
    }
    GetWheelPlanImageName(wheelPlanId) {
        let _this = this;
        //To do: This method and the above method should not exist as the wheelplan should come from an object.  
        let plan = _this.GetVehicleWheelPlanById(wheelPlanId);
        if (plan !== undefined) return plan.image;
    }
    ActivateWheelPlan(wheelPlanId, wheelPlanName, target) {
        let _this = this;
        // Get an array of SVG shapes representing tyres from image, and an object that
        // can be used to map these IDs to additional properties, like the "Selected setting
        // or a name for the tyre.
        switch(parseInt(wheelPlanId)){
            case 1:
                _this._wheelShapes = _this.GetWheelShapes(target, '#NSF, #NSR, #OSF, #OSR');
                _this._wheelPlan = {
                    'NSF': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('NSF'),
                        Position: 'NSF',
                        CheckedRadioListIds: []
                    },
                    'OSF': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('OSF'),
                        Position: 'OSF',
                        CheckedRadioListIds: []
                    },
                    'NSR': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('NSR'),
                        Position: 'NSR',
                        CheckedRadioListIds: []
                    },
                    'OSR': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('OSR'),
                        Position: 'OSR',
                        CheckedRadioListIds: []
                    },
                    'SPARE': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('SPARE'),
                        Position: 'SPARE',
                        CheckedRadioListIds: []
                    }
                };
                break;
            case 2:
                _this._wheelShapes = _this.GetWheelShapes(target, '#NSF, #NSR, #OSF, #OSR, #NSR2, #OSR2, #SPARE');
                _this._wheelPlan = {
                    'NSF': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('NSF'),
                        Position: 'NSF',
                        CheckedRadioListIds: []
                    },
                    'OSF': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('OSF'),
                        Position: 'OSF',
                        CheckedRadioListIds: []
                    },
                    'NSR': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('NSR') + " Inside",
                        Position: 'NSR',
                        CheckedRadioListIds: []
                    },
                    'OSR': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('OSR') + " Inside",
                        Position: 'OSR',
                        CheckedRadioListIds: []
                    },
                    'NSR2': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('NSR2'),
                        Position: 'NSR2',
                        CheckedRadioListIds: []
                    },
                    'OSR2': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('OSR2'),
                        Position: 'OSR2',
                        CheckedRadioListIds: []
                    },
                    'SPARE': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('SPARE'),
                        Position: 'SPARE',
                        CheckedRadioListIds: []
                    }
                };
                break;
            case 21:
                _this._wheelShapes = _this.GetWheelShapes(target, '#NSF, #NSR, #OSF, #OSR');
                _this._wheelPlan = {
                    'NSF': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('NSF'),
                        Position: 'NSF',
                        CheckedRadioListIds: []
                    },
                    'OSF': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('OSF'),
                        Position: 'OSF',
                        CheckedRadioListIds: []
                    },
                    'NSR': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('NSR'),
                        Position: 'NSR',
                        CheckedRadioListIds: []
                    },
                    'OSR': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('OSR'),
                        Position: 'OSR',
                        CheckedRadioListIds: []
                    },
                    'SPARE': {
                        Selected: 0,
                        Name: (0, $a854c42000216589$export$b8cfe935cdbfd3a9).getName('SPARE'),
                        Position: 'SPARE',
                        CheckedRadioListIds: []
                    }
                };
                break;
            default:
                break;
        }
        // Attach event handlers to elements
        if (_this._wheelShapes.length && $.type(_this._wheelPlan) === 'object') {
            if (_this._wheelShapeOriginalColor === undefined) _this._wheelShapeOriginalColor = _this._wheelShapes[0].style['fill'];
            _this.BindSvgImageControls();
        }
        // Overlay text showing the wheel plan ID and name
        _this.UpdateWheelPlanIdAndName(wheelPlanId, wheelPlanName, target);
    }
    BindSvgImageControls() {
        let _this = this;
        // Reset wheelShapes
        _this.ResetWheelShapes();
        // We have a group of SVG shapes representing the wheels
        _this._wheelShapes.css('cursor', 'pointer');
        _this._wheelShapes.mouseover(function() {
            var wheelShape = $(this);
            var id = wheelShape.prop('id');
            _this.UpdateImageTitle(_this._wheelPlan[id].Name);
            if (!_this._wheelPlan[id].Selected) $(this).css('fill', 'Red');
        });
        _this._wheelShapes.mouseout(function() {
            var wheelShape = $(this);
            var id = wheelShape.prop('id');
            _this.UpdateImageTitle('');
            if (!_this._wheelPlan[id].Selected) $(this).css('fill', '#606161');
        });
        _this._wheelShapes.on('click', function(event) {
            _this.BindWheelShapeEvent(event);
        });
    }
    BindWheelShapeEvent(event) {
        let _this = this;
        // Update "Selected" property of wheel and update fill
        let wheelShape = $(event.target);
        let id = wheelShape.prop('id');
        let activeWheelPlanArray = [];
        if (_this._wheelPlan[id].Selected) {
            wheelShape.css('fill', '#606161');
            wheelShape.attr('data-selected', 'false');
            _this._wheelPlan[id].Selected = 0;
            // Check if current wheelplan has radio button dependencies
            if (_this._wheelPlan[id].CheckedRadioListIds.length) for(let index = 0; index < _this._wheelPlan[id].CheckedRadioListIds.length; index++){
                var radioValue = _this._wheelPlan[id].CheckedRadioListIds[index];
                $('#' + radioValue).css('fill', '#606161');
                $('#' + radioValue).on('click', _this.BindWheelShapeEvent);
                _this._wheelPlan[radioValue].Selected = 0;
            }
        } else {
            wheelShape.css('fill', 'Blue');
            wheelShape.attr('data-selected', 'true');
            _this._wheelPlan[id].Selected = 1;
            //Turn on the button when a selection is made. 
            var $nextbutton = $('.nextButton');
            if ($nextbutton.is(':hidden')) $nextbutton.show();
            (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).RemoveValidationStyles(undefined, wheelShape.closest('[id^="wheelPlanSection"]'));
        }
    }
    ShowDiagramSelection(wheelPlanId, removeSelectBtn) {
        let _this = this;
        // 1. Hide all diagrams and titles
        $('.tyre-wheelPlan-Column').addClass('d-none');
        // 2. Get hold of selected diagram container
        let $selectedWheelPlan = $('.wheel-plan-container[data-wheelPlanId=' + wheelPlanId + ']').parent();
        // 3. If selection done through inital select button then get rid of them, not needed anymore
        // and display the radio button selection
        if (removeSelectBtn === true) {
            $('.selectWheelPlanBtn').hide();
            $('#wheelPlanSection #carTypeTitle').closest('.row').hide();
            $('#diagramUserInfo').show();
            $('.spareTyreContainer').show();
        }
        // 4. Reduce svg padding
        $selectedWheelPlan.find('svg').css('margin-top', '-30px').css('margin-bottom', '-30px');
        // 5. Show the selected wheelPlan, related info, and next button
        $selectedWheelPlan.add('.tyre-selection-info').add($('.nextButton').closest('.card-footer')).add('#tyreDetailColumn').add($selectedWheelPlan).removeClass('d-none').show('slow');
        // 6. hide carousel controls
        $('.carousel-indicators').hide();
        $('.carousel-control-prev').hide();
        $('.carousel-control-next').hide();
        // 7. Activate Wheel Selection and tooltip
        let wheelPlanName = $('input[name="WheelPlan"][value="' + wheelPlanId + '"]').next('label').text();
        //Check we have the name or get it from the VehicleWheelPlan object.
        wheelPlanName = wheelPlanName === '' ? _this.GetVehicleWheelPlanById(wheelPlanId).name : wheelPlanName;
        let diagramTarget = $selectedWheelPlan.find('div[id$="ImageContainer"]');
        _this.ActivateWheelPlan(wheelPlanId, wheelPlanName, diagramTarget);
    }
    HideDiagramSelection() {
        let _this = this;
        // Restore the layout for selecting a wheelplan
        $('.tyre-wheelPlan-Column').removeClass('d-none');
        $('#wheelPlanSection #carTypeTitle').closest('.row').show();
        $('#diagramUserInfo').hide();
        $('.selectWheelPlanBtn').show();
        $('.carousel-indicators').show();
        $('.carousel-control-prev').show();
        $('.carousel-control-next').show();
        $('.spareTyreContainer').hide();
        $('.tyre-selection-info').hide();
        // Re-set the image margins, which are modified when a wheelplan is
        // selected
        $('.tyre-wheelPlan-Column').find('svg').css('margin-top', '0px').css('margin-bottom', '0px');
        _this._wheelShapes.css('cursor', 'default');
        // De-activate diagram, so tyre cannot be selected until a wheelplan has
        // been chosen.
        _this.ResetWheelShapes();
        // Change data-selected value of all svg rect objects (the tyres) to false
        $('#wheelPlanSection [data-wheelplanid="' + (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelPlan + '"] rect').each(function(index) {
            $(this).attr('data-selected', 'false');
        });
        // We have effectively de-selected a tyre, so clear wheel plan and any selected tyres
        for(let property in _this._wheelPlan)_this._wheelPlan[property].Selected = 0;
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelPlan = null;
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelsSelected = null;
    }
    // --------------------------------------------------
    // PUBLIC FUNCTIONS
    // --------------------------------------------------
    GetValidator() {
        var validator = $('#wheelPlanSection').kendoValidator({
            rules: {
                mandatoryVehicleSelection: function(input) {
                    let wheelPlanSelected = $.isNumeric((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelPlan);
                    if (!wheelPlanSelected) return false;
                    else {
                        // Only validate tyre posisitons which are present in the currently selected wheelplan 
                        var anyWheelChecked = $('#wheelPlanSection [data-wheelplanid="' + (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelPlan + '"] rect').filter('[data-selected="true"]').length > 0;
                        var spare = $('#wheelPlanSection [data-wheelplanid="' + (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelPlan + '"] .changeSpareRadio').is(":checked");
                        if (!anyWheelChecked && !spare) return false;
                    }
                    return true;
                }
            },
            messages: {
                mandatoryVehicleSelection: 'Please select at least 1 wheelplan and 1 tyre.'
            }
        }).data('kendoValidator');
        validator.bind('validate', function(e) {
            let $invalidInputs = $(e.sender.element).find('.k-invalid');
            let wheelPlanselected = $invalidInputs.filter('[name="WheelPlan"]').length > 0;
            if (wheelPlanselected) $('.wheel-plan-container').addClass('tyreDetailInvalid');
            else $('.wheel-plan-container').removeClass('tyreDetailInvalid');
        });
        return validator;
    }
    async GetLatestTyreFittingsDataSource(vehicleRegistration) {
        return await this.GetLatestTyreFittings(vehicleRegistration);
    }
    async GetLatestTyreFittings(vehicleRegistration) {
        let result = $.Deferred();
        let queryString = (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).GetQueryStringValue('q', null);
        let url = '/vehicle/latesttyrespecifichistory?q=' + queryString + '&vehicleRegistration=' + vehicleRegistration;
        $.ajax({
            url: url,
            type: 'GET',
            cache: false,
            success: function(data) {
                result.resolve(data);
            },
            error: function(xhr, ajaxOptions, thrownError) {
                console.log(thrownError);
            },
            complete: function() {}
        });
        return result.promise();
    }
    async Initialise(disableSection, enableSection) {
        $('.nextButton').hide();
        // need to set tyre history before we use on next section
        if ((0, $a854c42000216589$export$bd25e24024963319)._vehicle._tyreHistory === null) {
            const registration = $('#vehicle-search-input').val().replace(' ', '').toUpperCase();
            (0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreHistory = JSON.parse(await this.GetLatestTyreFittingsDataSource(registration));
            // re-order the history so '[New]' are at tops
            (0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreHistory.sort(function(a, b) {
                let newItem = a.newExisting;
                let existingItem = b.newExisting;
                if (newItem < existingItem) return 1;
                if (newItem > existingItem) return -1;
                //equal
                return 0;
            });
        }
        this.BuildWheelPlanDom().then(()=>{
            this.BindControls();
            this.InitialiseWheelPlanImages();
        }).finally(()=>{
            //Show the panel
            this.disableSection = (sectionName)=>{
                disableSection(sectionName);
            };
            this.enableSection = (sectionName)=>{
                enableSection(sectionName);
            };
        });
    }
}
let $6d0ce8ba0314f583$export$e753aa4e59dfd0d5 = new $6d0ce8ba0314f583$var$WheelPlans();


class $5e7fa57200602e68$var$TyreDetailsSummary {
    displayTyresSelection(moveToHandler, navigatingForward) {
        this.moveTo = (sectionName)=>{
            moveToHandler(sectionName);
        };
        const wheelDetailsModel = (0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreDetailLines;
        let $parentContainer = $('#tyreDetailSummaryContainer .card-body');
        let wheelplan = (0, $6d0ce8ba0314f583$export$e753aa4e59dfd0d5)._wheelPlan;
        // put the tyre details in spefic order
        var order = [
            "NSF",
            "OSF",
            "NSR",
            "OSR",
            "NSR2",
            "OSR2",
            "SPARE"
        ];
        _.sortBy((0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreDetailLines, function(obj) {
            return _.indexOf(order, obj.title);
        });
        if (navigatingForward) {
            $('.nextButton').hide();
            this.resetContainer($parentContainer);
            var top = (dataPosition, title, width, ratio, diameter, load, rating, construction)=>`<div class="row mb-2" data-position="${dataPosition}">
                    <div class="col-sm-12 col-md text-center p-2"><span class="d-md-none font-weight-bold">Side: </span>${wheelplan[title].Name}</div>
                    <div class="col-sm-12 col-md col text-center p-2"><span class="d-md-none font-weight-bold">Dimensions: </span>${width}/${ratio} R${diameter} ${load}${rating} ${construction}</div>
                    
                    <div class="col-sm-12 col-md text-center"><span class="d-md-none font-weight-bold">Brand: </span>
                        <input id="${title}_Brand" class="form-control tyreDetailBrand" data-validate="false" data-wheel="${title}" name="${title}_Brand" data-value="0" data-label="brand_label" />
                    </div>`;
            var middle = (title)=>`<div class="col-sm-12 col-md text-center"><span class="d-md-none font-weight-bold">Pattern: </span>
                    <input id="${title}_TyreDetailPattern" class="form-control tyreDetailPattern" data-wheel="${title}" name="${title}_Pattern" data-value="0" data-label="pattern_label" />
                </div>`;
            var bottom = (title)=>`<div class="col-sm-12 col-md text-center"><span class="d-md-none font-weight-bold">Replacement Reason: </span>
                    <input id="${title}_TyreDetailDamage" class="form-control tyreDetailDamage" data-validate="false" data-wheel="${title}" name="${title}_DamageType" /></span>
                </div>
            </div>`;
            if (!wheelDetailsModel) return;
            for(const key in wheelDetailsModel){
                const element = wheelDetailsModel[key];
                var html = top(element.wheelSelected, element.title, element.width, element.ratio, element.diameter, element.load, element.rating, element.construction) + ((0, $254a84bc556d8bd3$export$366dc4c52172531e).IsMfs() ? middle(element.title) : '') + bottom(element.title);
                $parentContainer.append(html);
                this.bindDrowDowns($parentContainer, element.title);
                if ((0, $254a84bc556d8bd3$export$366dc4c52172531e).IsMfs()) //Calling bind, will stop free form text entry
                this.setPatterns(element.title);
                $($parentContainer).find(`#${element.title}_Brand`)[0].value = element.brand;
            }
            this.bindConfirmBtnClickHandler($parentContainer);
            this.bindEditButtonHandler($parentContainer);
        }
    }
    setPatterns = (wheel, values = null)=>{
        let _this = this;
        let $parentContainer = $('#tyreDetailSummaryContainer .card-body');
        let tyreDetailLineModel = (0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreDetailLines.find((attr)=>attr.wheelSelected === wheel);
        if (values == null) tyreDetailLineModel.pattern = null;
        $($parentContainer).find(`#${wheel}_TyreDetailPattern`).kendoDropDownList({
            dataSource: {
                data: values
            },
            change: function() {
                var pattern = this.value();
                if (pattern == 'Choose') pattern = null;
                tyreDetailLineModel.pattern = pattern;
            }
        });
    };
    showPattern = (model)=>{
        if ((0, $254a84bc556d8bd3$export$366dc4c52172531e).IsMfs()) {
            var wheel = model.wheelSelected;
            $.ajax({
                url: 'Tyres/GetPatterns',
                contentType: "application/json",
                dataType: "json",
                type: 'post',
                data: JSON.stringify({
                    brand: model.brand,
                    width: model.width,
                    profile: model.ratio,
                    rim: model.diameter,
                    load: model.load,
                    speed: model.rating,
                    construction: model.construction
                }),
                success: (patterns)=>{
                    if (patterns.length > 0) patterns = [
                        'Choose',
                        ...patterns
                    ];
                    this.setPatterns(wheel, patterns);
                }
            });
        }
    };
    bindDrowDowns($parentContainer, wheel) {
        let _this = this;
        (0, $a854c42000216589$export$ab51f1f03e871453).getTyreBrands(function(brands) {
            var $input = $($parentContainer).find(`#${wheel}_Brand`);
            $input.kendoAutoComplete({
                dataSource: brands,
                dataTextField: 'name',
                filter: 'contains',
                placeholder: 'Enter Tyre Brand',
                select: function(e) {
                    var dataItem = this.dataItem(e.item.index());
                    $(this).data('value', dataItem.id);
                    let $this = $(e.sender.element);
                    let $container = $this.parents('.detailcontainer');
                    let labelClass = '.' + $this.data('label');
                    let $displaySpan = $container.find(labelClass);
                    let currentValue = dataItem.name;
                    $displaySpan.text(currentValue);
                    $displaySpan.addClass('font-weight-bold').addClass('text-info');
                },
                change: function() {
                    var found = false;
                    var value = this.value();
                    var wheel = this.element.data('wheel');
                    var data = this.dataSource.view();
                    for(var idx = 0, length = data.length; idx < length; idx++)if (data[idx].name === value) {
                        found = true;
                        break;
                    }
                    let tyreDetailLineModel = (0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreDetailLines.find((attr)=>attr.wheelSelected === wheel);
                    // Only allow values in the dataSource list
                    if (!found) {
                        this.value("");
                        $('.nextButton').hide();
                        tyreDetailLineModel.brand = null;
                        if ((0, $254a84bc556d8bd3$export$366dc4c52172531e).IsMfs()) _this.setPatterns(wheel);
                    } else {
                        tyreDetailLineModel.brand = value;
                        _this.showPattern(tyreDetailLineModel);
                        if (_this.tyreDetailLineValid()) $('.nextButton').show();
                    }
                }
            });
        });
        $($parentContainer).find(`#${wheel}_TyreDetailDamage`).kendoDropDownList({
            dataSource: {
                transport: {
                    read: {
                        url: '/tyres/gettyreinitialreasons?includeDefaultOption=true',
                        dataType: 'json'
                    }
                }
            },
            dataTextField: 'name',
            dataValueField: 'id',
            change: function() {
                var value = this.value();
                if (value !== '' && value !== '0') {
                    let tyreDetailLineModel = (0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreDetailLines.find((attr)=>attr.wheelSelected === wheel);
                    tyreDetailLineModel.damageType = {
                        Id: value,
                        Name: $(this.element).data('kendoDropDownList').text()
                    };
                    if (_this.tyreDetailLineValid()) $('.nextButton').show();
                } else $('.nextButton').hide();
            }
        });
    }
    tyreDetailLineValid(checkPattern = false) {
        let isValid = true;
        for(const key in (0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreDetailLines){
            const element = (0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreDetailLines[key];
            if (element.damageType === null || element.damageType.Id === '0') isValid = false;
            if (element.brand === '' || element.brand === null) isValid = false;
            if (checkPattern) {
                if ((0, $254a84bc556d8bd3$export$366dc4c52172531e).IsMfs()) {
                    var $parentContainer = $('#tyreDetailSummaryContainer .card-body');
                    var patternControl = $($parentContainer).find(`#${element.wheelSelected}_TyreDetailPattern`);
                    var patterns = patternControl.data("kendoDropDownList").dataSource.view();
                    if (patterns.length > 0) {
                        if (element.pattern == null) isValid = false;
                    }
                }
            }
        }
        return isValid;
    }
    resetContainer($parentContainer) {
        $parentContainer.html('');
        $('#confirmTyreSelection').show().parent().addClass('text-right').removeClass('text-center');
        const $btnCollection = $parentContainer.closest('.card').find('.btn');
        $parentContainer.closest('.card').find('.animated-tick-wrapper').remove();
        $btnCollection.removeAttr('disable').removeClass('disabled').css('cursor', 'pointer');
        $('#tyreDetailsConfirmedInput').val('');
    }
    bindConfirmBtnClickHandler($parentContainer) {
        let _this = this;
        $('#confirmTyreSelection').off();
        $('#confirmTyreSelection').on('click', (event)=>{
            if (_this.tyreDetailLineValid()) {
                let $btn = $(event.target);
                let $btnCollecton = $parentContainer.closest('.card').find('.btn');
                let animatedSvgTick = ((0, $254a84bc556d8bd3$export$366dc4c52172531e).IsEdgeBrowser() || (0, $254a84bc556d8bd3$export$366dc4c52172531e).IsInternetExplorer()) === true ? `<i class="far fa-check-circle text-success" style="font-size:1.2em;"></i>` : `<div class="animated-tick-wrapper">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" 
                viewBox="0 0 98.5 98.5" enable-background="new 0 0 98.5 98.5" xml:space="preserve"> 
                <path class="checkmark" fill="none" stroke-width="8" stroke-miterlimit="10" d="M81.7,17.8C73.5,9.3,62,4,49.2,4 
                C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"/>
                </svg>
            </div>`;
                $btnCollecton.prop('disable', 'disabled').addClass('disabled').css('cursor', 'not-allowed');
                $btnCollecton.off();
                $btn.hide().parent().removeClass('text-right').addClass('text-center');
                $('#tyreDetailSummaryContainer .card-footer').append(animatedSvgTick);
                $('#tyreDetailsConfirmedInput').val(true);
                $('.nextButton').show();
            }
        });
    }
    bindEditButtonHandler($parentContainer) {
        $('.btn-warning').off();
        $parentContainer.find('.btn-warning').on('click', (event)=>{
            const tyrePosition = $(event.target).closest('.row').data('position');
            this.moveTo(tyrePosition.toLowerCase());
        });
    }
    GetValidator() {
        var _this = this;
        return $('#tyreDetailsSummarySection').kendoValidator({
            rules: {
                confirmationSelected: function() {
                    return (0, $254a84bc556d8bd3$export$366dc4c52172531e).IsMfs() ? _this.tyreDetailLineValid(true) : true;
                }
            }
        }).data('kendoValidator');
    }
}
let $5e7fa57200602e68$export$3d0653d9b1fe5763 = new $5e7fa57200602e68$var$TyreDetailsSummary();




var $1c69d9f7d2723de0$var$VehiclePanel = function() {
    // -------------------------------------------------------------------------------
    //  Private members
    // -------------------------------------------------------------------------------
    var BindControls = function() {};
    // -------------------------------------------------------------------------------
    //  Public members
    // -------------------------------------------------------------------------------
    return {
        InitializePanel: function() {
            BindControls();
        },
        SaveVehicleDetails: function() {
            let mileage = $('#vehicleDetailsSection #Mileage').val().replace(',', '');
            let reg = $('#vehicle-registration').text();
            let vehicleId = $('#VehicleID').val();
            let make = $('#vehicleDetailsSection #vehicle-make').text();
            let model = $('#vehicleDetailsSection #vehicle-description').text();
            let orderNumber = $('#CustomerOrderNumber').length ? $('#CustomerOrderNumber').val() : null;
            let mileageNotRequired = $('#mileageInput').is(':hidden');
            (0, $a854c42000216589$export$bd25e24024963319).vehicle.vehicleDetails = new (0, $a854c42000216589$export$2a98583447337f2c)(mileage, reg, vehicleId, make, model, orderNumber, mileageNotRequired);
        },
        VehicleRegistration: function() {
            return $('#vehicleDetailsSection #vehicle-registration').text();
        },
        VehicleMake: function() {
            return $('#vehicleDetailsSection #vehicle-make').text();
        },
        VehicleDescription: function() {
            return $('#vehicleDetailsSection #vehicle-description').text();
        }
    };
};
let $1c69d9f7d2723de0$export$e760877cb454c9d4 = new $1c69d9f7d2723de0$var$VehiclePanel();





let $9ac33b0fd47521c4$var$DriverPanel = function() {
    // -------------------------------------------------------------------------------
    //  Private members
    // -------------------------------------------------------------------------------
    var BindControls = function() {
        $('#Driver_Title').kendoDropDownList({
            dataSource: {
                transport: {
                    read: {
                        url: '/Driver/GetAllDriverTitles'
                    }
                }
            },
            dataTextField: 'text',
            dataValueField: 'value'
        });
        $('#CheckBoxSendSMSConfirmation').change(function() {
            if (this.checked) $('#Mobile').attr('required', 'required');
            else {
                $('#Mobile').removeAttr('required');
                (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).RemoveValidationStyles($('#Mobile'));
            }
        });
    };
    // -------------------------------------------------------------------------------
    //  Public members
    // -------------------------------------------------------------------------------
    return {
        InitializePanel: function() {
            BindControls();
        },
        SaveDriverDetails: function() {
            let $panel = $('#driverDetailsSection');
            let driverAddress = new (0, $a854c42000216589$export$f5004a899ec10a9)();
            if (!(0, $a854c42000216589$export$bd25e24024963319).driver || (0, $a854c42000216589$export$bd25e24024963319).driver.postcode === undefined || (0, $a854c42000216589$export$bd25e24024963319).driver.postcode === null) {
                driverAddress.name = $panel.find('input[id$="Address_Name"]').val();
                driverAddress.line1 = $panel.find('input[id$="Address_AddressLine1"]').val();
                driverAddress.line2 = $panel.find('input[id$="Address_AddressLine2"]').val();
                driverAddress.town = $panel.find('input[id$="Address_Town"]').val();
                driverAddress.county = $panel.find('input[id$="Address_County"]').val();
                driverAddress.postcode = $panel.find('input[id$="Postcode"]').val();
            }
            (0, $a854c42000216589$export$bd25e24024963319).driver = new (0, $a854c42000216589$export$c4123383392d4053)($panel.find('input[id="Driver_Title"]').val(), $panel.find('input[id="Driver_MainFirstName"]').val(), $panel.find('input[id="Driver_MainSurname"]').val(), $panel.find('input[id="Mobile"]').val(), $panel.find('input[id="AlternativePhone"]').val(), $panel.find('input[id="Email"]').val(), $panel.find('input[name="CheckBoxSendSMSConfirmation"]').is(':checked'), driverAddress, $panel.find('#PrivacyCheckBox').is(':checked'), (0, $254a84bc556d8bd3$export$366dc4c52172531e).IsMfs() || (0, $254a84bc556d8bd3$export$366dc4c52172531e).IsVMS() ? $panel.find('textarea[id="AdditionalInformation"]').val() : null);
        },
        getDriverDetailValidator: function() {
            return $('#driverDetailsSlide').kendoValidator({
                rules: {
                    mandatoryMobileNumber: function(input) {
                        // check if 'text message' is selected and if so make sure a mobile is provided
                        if (input.is('#PreferredContactMethodSms')) {
                            var textMessageChecked = $('#PreferredContactMethodSms').is(':checked');
                            var mobileNumberProvided = (0, $254a84bc556d8bd3$export$366dc4c52172531e).CheckIfMobilePhoneProvided([
                                $('#Mobile'),
                                $('#AlternativePhone')
                            ]);
                            if (textMessageChecked && !mobileNumberProvided) return false;
                        }
                        return true;
                    },
                    preferredMethodOfContact: function(input) {
                        if (input.is('#PreferredContactMethodSms')) {
                            var textMessageChecked = $('#PreferredContactMethodSms').is(':checked');
                            var emailMessageChecked = $('#PreferredContactMethodEmail').is(':checked');
                            if (!textMessageChecked && !emailMessageChecked) return false;
                        }
                        return true;
                    },
                    dataPrivacyPolicyChecked: function(input) {
                        if (input.is('#PrivacyCheckBox')) {
                            let privacyPolicyChecked = $('#PrivacyCheckBox').is(':checked');
                            if (!privacyPolicyChecked) return false;
                        }
                        return true;
                    }
                },
                messages: {
                    mandatoryMobileNumber: 'Please enter a valid mobile phone in order to receive text notification.',
                    preferredMethodOfContact: 'Select a preferred contact method.'
                }
            }).data('kendoValidator');
        },
        getDataPrivacyValidator: function() {
            return $('#DataProtectionSlide').kendoValidator({
                rules: {
                    dataPrivacyPolicyChecked: function(input) {
                        if (input.is('#PrivacyCheckBox')) {
                            let privacyPolicyChecked = $('#PrivacyCheckBox').is(':checked');
                            if (!privacyPolicyChecked) return false;
                        }
                        return true;
                    }
                },
                messages: {
                    dataPrivacyPolicyChecked: 'You must accept the privacy policy in order to continue'
                }
            }).data('kendoValidator');
        }
    };
};
let $9ac33b0fd47521c4$export$ca9d9c6ddb699dc1 = new $9ac33b0fd47521c4$var$DriverPanel();


//import kendo from '@progress/kendo-ui';

class $0f9b377c2aa86abc$var$Address {
    constructor(){
        this.ElementID = null;
    }
    // Built to only have one address visible on the page at once
    // Call setup after you make your address visible to the user
    Setup(AddressListElementID, UniqueReference, LogDescription) {
        let _this = this;
        let container = new ContainingElement(UniqueReference);
        var $buttonSelector = $('#' + container.ElementID + 'ButtonPostCodeLookup');
        $buttonSelector.unbind('click');
        $buttonSelector.click(function() {
            _this.Search(AddressListElementID, LogDescription, container.ElementID);
        });
        $buttonSelector.trigger('click');
    }
    GetAddressList(PostCode, RequestVerificationToken, Logdescription) {
        var result = $.Deferred();
        $.ajax({
            url: '/address/addresslist',
            type: 'POST',
            data: {
                postcode: PostCode,
                __RequestVerificationToken: RequestVerificationToken,
                LogDescription: Logdescription
            },
            cache: true,
            success: function(data) {
                result.resolve(data);
            },
            error: function(xhr, ajaxOptions, thrownError) {},
            complete: function(data) {}
        });
        return result.promise();
    }
    GetCoordinates(postcode, requestVerificationToken, logDescription) {
        return new Promise(function(resolve, reject) {
            $.ajax({
                url: '/address/coordinates',
                type: 'POST',
                data: {
                    postcode: postcode,
                    __RequestVerificationToken: requestVerificationToken,
                    logDescription: logDescription
                },
                cache: true,
                success: function(data) {
                    resolve(data);
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    reject(thrownError);
                },
                complete: function(data) {}
            });
        });
    }
    GetPostCodeAddress(Key, RequestVerificationToken, VehicleRegistration) {
        var result = $.Deferred();
        $.ajax({
            url: '/address/PostCodeAddress',
            type: 'POST',
            data: {
                key: Key,
                __RequestVerificationToken: RequestVerificationToken,
                vehicleRegistration: VehicleRegistration
            },
            cache: true,
            success: function(data) {
                result.resolve(data);
            },
            error: function(xhr, ajaxOptions, thrownError) {},
            complete: function(data) {}
        });
        return result.promise();
    }
    Search(addressListElementID, logDescription, containerElementID) {
        let _this = this;
        var addressHTML = '';
        var postcode = $('#' + containerElementID + 'Postcode').val().toLocaleUpperCase();
        $('#' + containerElementID + 'Postcode').val(postcode);
        if (!postcode) {
            $('#' + containerElementID + 'Postcode').addClass('k-invalid');
            return;
        } else $('#' + containerElementID + 'Postcode').removeClass('k-invalid');
        var addresses = this.GetAddressList(postcode, $('input[name=__RequestVerificationToken]').val(), logDescription);
        $.when(addresses).done(function(l_addresses) {
            if (l_addresses.length > 0) {
                addressHTML += '<ul class="pl-0" style="list-style-type:none;">';
                $.each(l_addresses, function(Id, address) {
                    var displayText = '';
                    if (address.property.length > 0) displayText = address.property + ', ';
                    if (address.organisation.length > 0) displayText += address.organisation + ', ';
                    if (address.street.length > 0) displayText += address.street + ', ';
                    if (address.town.length > 0) displayText += address.town;
                    addressHTML += '<li><a href="#" class=\"address-list-item\" data-organisation=\"' + address.organisation + '\" data-property=\"' + address.property + '\" data-street=\"' + address.street + '\" data-locality=\"' + address.locality + '\" data-town=\"' + address.town + '\" data-postalcounty=\"' + address.postalCounty + '\" data-postcode=\"' + address.postcode + '\"><span class=\"fas fa-home\" style=\"margin-right:10px;\"></span>' + displayText + '</li>';
                });
                addressHTML += '</ul>';
            } else {
                addressHTML += "<p>We're sorry but we cannot find the postcode <strong>" + postcode + "</strong>. If that is the correct postcode, please call your driverline for further assistance.</p>";
                addressHTML += '<div class="form-group row mt-3" ><div class="col-md-10"><button class="btn btn-outline-dark" style="width:280px;">Go Back</button></div></div>';
            }
            $('#' + containerElementID + 'AddressList').html('').html(addressHTML).css('height', $('#' + containerElementID).height() + 'px');
            $('#' + containerElementID + 'AddressList').find('.address-list-item').each(function(index, element) {
                $(element).on('click', function(event) {
                    event.preventDefault();
                    _this.PopulateAddress(this, addressListElementID, containerElementID);
                });
            });
            $('#' + containerElementID + 'AddressList').find('.btn-outline-dark').each(function(index, element) {
                $(element).on('click', function() {
                    _this.SlideBack(containerElementID);
                });
            });
            $('#' + containerElementID).animate({
                marginLeft: '-1500px'
            }, 500, function() {
                $('#' + containerElementID + 'AddressList').animate({
                    marginRight: '0px'
                }, 500, function() {
                // Animation complete.
                });
            });
        });
    }
    PopulateAddress(addressElement, addressListElementID, containerElement) {
        this.SlideBack(containerElement);
        let street = $(addressElement).data('property') ? `${$(addressElement).data('property')}, ${$(addressElement).data('street')}` : $(addressElement).data('street');
        let address = {
            addressLine1Input: $('#' + containerElement).find('#' + containerElement + 'Address_AddressLine1'),
            addressLine2Input: $('#' + containerElement).find('#' + containerElement + 'Address_AddressLine2'),
            addressTown: $('#' + containerElement).find('#' + containerElement + 'Address_Town'),
            addressCounty: $('#' + containerElement).find('#' + containerElement + 'Address_County'),
            addressPostCode: $('#' + containerElement).find('#' + containerElement + 'Postcode')
        };
        for(let prop in address){
            $(address[prop]).val('');
            (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).RemoveValidationStyles(address[prop]);
        }
        if ($(addressElement).data('organisation')) {
            address.addressLine1Input.val($(addressElement).data('organisation'));
            address.addressLine2Input.val(street);
        } else address.addressLine1Input.val(street);
        address.addressTown.val($(addressElement).data('town'));
        address.addressCounty.val($(addressElement).data('postalcounty'));
        address.addressPostCode.val($(addressElement).data('postcode'));
    }
    BindControls() {
        let _this = this;
        $('.buttonPostCodeLookup').on('click', function() {
            var containerId = $(this).parents('.addressContainer').prop('id').replace(' ', '');
            _this.Search('PostCodeLookupDialog', '', containerId);
        });
    }
    SlideBack(containerElement) {
        $('#' + containerElement + 'AddressList').animate({
            marginRight: '-1500px'
        }, 500, function() {
            $('#' + containerElement).animate({
                marginLeft: '0px'
            }, 500, function() {
                $('#' + containerElement + 'AddressList').html('');
            });
        });
    }
    ContainingElement(elementID) {
        this.ElementID = elementID;
    }
}
let $0f9b377c2aa86abc$export$f5c65d7eccbf77d4 = new $0f9b377c2aa86abc$var$Address();



class $1ab168822f4abc32$var$Mapping {
    constructor(){
        this.green = '#00C800';
        this.blue = '#4472c4';
        this.selectedDepotId = null;
        this.map = null;
        this.infobox = null;
        this.depots = [];
        this.debug = false;
        this.manufacturerId = 0;
        this.serviceId = 0;
        this.level = 1;
        this.tier = 1;
        this.postcode = null;
        this.serviceType = null;
        this.customerId = null;
    }
    ResetState() {
        $('#grid').html('');
        $('#map').html('');
        this.selectedDepotId = null;
        this.map = null;
        this.infobox = null;
        this.depots = [];
        this.manufacturerId = 0;
        this.serviceId = 0;
        this.postcode = null;
    }
    SetManufacturerId(manufacturerId) {
        this.manufacturerId = manufacturerId;
    }
    SetServiceType(serviceType) {
        this.serviceType = serviceType;
    }
    SetCustomerId(customerId) {
        this.customerId = customerId;
    }
    GetPostcodeCoordinates() {
        kendo.ui.progress($("body"), true);
        let _this = this;
        if (this.postcode != $('#jobPostcode').val()) {
            this.ResetState();
            this.postcode = $('#jobPostcode').val();
            var coordinatesRequest = (0, $0f9b377c2aa86abc$export$f5c65d7eccbf77d4).GetCoordinates(this.postcode, $('input[name=__RequestVerificationToken]').val(), '');
            $.when(coordinatesRequest).then(function(coordinates) {
                _this.coordinates = coordinates;
                _this.RefreshMap(coordinates);
                var depotsRequest = _this.GetDepotList(coordinates.latitude, coordinates.longitude);
                $.when(depotsRequest).then(function(response) {
                    _this.depots = response;
                    var clusterDepots = false;
                    _this.PlotDepots(clusterDepots);
                    _this.RefreshDepotList();
                    kendo.ui.progress($("body"), false);
                });
            });
        } else kendo.ui.progress($("body"), false);
    }
    RefreshMap(coords) {
        let _this = this;
        if (!coords) coords = _this.coordinates;
        // Create map
        var jobLocation = new Microsoft.Maps.Location(coords.latitude, coords.longitude);
        _this.map = new Microsoft.Maps.Map(document.getElementById('map'), {
            center: jobLocation,
            zoom: 12
        });
        // Create an infobox for depot information. This is hidden by default, and
        // populated and displayed when a pushpin is selected
        _this.infobox = new Microsoft.Maps.Infobox(_this.map.getCenter(), {
            visible: false,
            autoAlignment: true
        });
        _this.infobox.setMap(_this.map);
        // Draw proximity circles
        Microsoft.Maps.loadModule('Microsoft.Maps.SpatialMath', function() {
            // Inner circle
            var greenFill = new Microsoft.Maps.Color(0.1, 0, 200, 0);
            var greenStroke = new Microsoft.Maps.Color(1, 0, 200, 0);
            _this.DrawMapCircle(jobLocation, 5, greenFill, greenStroke);
            // Outer circle
            var blueFill = new Microsoft.Maps.Color(0, 0, 0, 200);
            var blueStroke = new Microsoft.Maps.Color(1, 0, 0, 200);
            _this.DrawMapCircle(jobLocation, 10, blueFill, blueStroke);
            // Add a pushpin at the user's location.
            var pin = new Microsoft.Maps.Pushpin(jobLocation);
            _this.map.entities.push(pin);
        });
    }
    GetDepotList(latitude, longitude) {
        var result = $.Deferred();
        var url = '';
        if (this.serviceType === 'S') url = '/servicebooking/depots';
        else if (this.serviceType === 'T') url = '/supplier/depots';
        $.ajax({
            url: url,
            type: 'POST',
            data: {
                customerId: this.customerId === '5130292' ? '5479221' : this.customerId,
                latitude: this.coordinates.latitude,
                longitude: this.coordinates.longitude
            },
            success (data) {
                result.resolve(data);
            },
            error (xhr, ajaxOptions, thrownError) {},
            complete (data) {}
        });
        return result.promise();
    }
    DrawMapCircle(location, radius, fillColour, strokeColour) {
        var path = Microsoft.Maps.SpatialMath.getRegularPolygon(location, radius, 360, Microsoft.Maps.SpatialMath.DistanceUnits.Miles);
        var poly = new Microsoft.Maps.Polygon(path, {
            fillColor: fillColour,
            strokeColor: strokeColour,
            strokeThickness: 1,
            strokeDashArray: [
                1,
                2
            ]
        });
        this.map.entities.push(poly);
    }
    RefreshDepotList() {
        let _this = this;
        $('#grid').parents('.section').prop('id') === 'jobLocationSection' || $('#grid').parents('.section').prop('id');
        let selectedDepotId = (0, $a854c42000216589$export$bd25e24024963319).selectedDepot ? (0, $a854c42000216589$export$bd25e24024963319).selectedDepot.id : _this.GetSelectedDepotId();
        $('#grid').html('');
        $('#grid').kendoGrid({
            dataSource: _this.depots,
            resizable: true,
            selectable: true,
            scrollable: true,
            columns: [
                {
                    field: 'id',
                    title: 'ID',
                    hidden: true
                },
                {
                    field: 'id',
                    title: ' ',
                    template: '<div class="text-center"><div class="custom-control custom-radio"><input class="custom-control-input depot-radio-btn" type="radio" name="depot-list" required id="#: id#" data-depot-id="#: id#"> <label class="custom-control-label" for="#: id#"></label></div></div>',
                    width: '30px'
                },
                {
                    field: 'name',
                    title: 'Depot name',
                    template: kendo.template($('#depot-address-template').html()),
                    media: "(min-width: 450px)"
                },
                {
                    field: 'distanceInMiles',
                    title: 'Distance',
                    template: "<div style='text-align:left'>#=Number(distanceInMiles).toFixed(2)# miles</div>",
                    media: "(min-width: 450px)"
                },
                {
                    title: "Garage location",
                    template: kendo.template($("#depot-address-template-mobile").html()),
                    media: "(max-width: 450px)"
                }
            ],
            change: function() {
                let row = this.select();
                let $input = $(row).find('.depot-radio-btn');
                $input[0].checked = true;
                _this.SelectDepot($input.data('depotId'));
                $('.nextButtonSlide').show();
            }
        }).kendoValidator({
            rules: {
                depotMissing: function(input) {
                    if (input.is("[type=radio]") && input.attr("required")) return $("#grid").find("[name=depot-list]").is(":checked");
                    return true;
                }
            },
            messages: {
                depotMissing: 'Please select a depot'
            }
        }).data('kendoValidator');
    }
    PlotDepots(clusterDepots) {
        let _this = this;
        // Create an array of depot pushpins
        var pushpins = [];
        _this.depots.forEach(function(depot) {
            // Define pushpin
            var location = new Microsoft.Maps.Location(depot.latitude, depot.longitude);
            var pushpin = new Microsoft.Maps.Pushpin(location, {
                color: _this.blue,
                enableHoverStyle: true
            });
            // Create metadata linking pushpin to depot
            if (!pushpin.metadata) pushpin.metadata = {};
            $.extend(pushpin.metadata, {
                title: depot.name,
                depotId: depot.id,
                address: depot.address.split(',').join('<br/>'),
                selected: false
            });
            // Attach handler for selecting depot
            Microsoft.Maps.Events.addHandler(pushpin, 'click', function(args) {
                _this.SelectDepot(args.target.metadata.depotId);
            });
            pushpins.push(pushpin);
        });
        // Display depots
        if (clusterDepots) Microsoft.Maps.loadModule('Microsoft.Maps.Clustering', function() {
            var clusterLayer = new Microsoft.Maps.ClusterLayer(pushpins);
            _this.map.layers.insert(clusterLayer);
        });
        else _this.map.entities.push(pushpins);
    }
    SelectDepot(depotId) {
        let _this = this;
        // De-select active depot
        var pushpin = null;
        var depotListCircle = null;
        _this.RefreshMap();
        _this.PlotDepots(false);
        if (_this.selectedDepotId) {
            // Map
            pushpin = _this.GetPushpinByDepotId(_this.selectedDepotId);
            pushpin.setOptions({
                color: _this.blue
            });
            _this.infobox.setOptions({
                visible: false
            });
        }
        _this.selectedDepotId = depotId;
        pushpin = _this.GetPushpinByDepotId(_this.selectedDepotId);
        pushpin.setOptions({
            color: _this.green
        });
        // Display information about depot
        _this.infobox.setOptions({
            location: pushpin.getLocation(),
            title: pushpin.metadata.title,
            description: pushpin.metadata.address,
            maxHeight: 256,
            visible: true
        });
        (0, $a854c42000216589$export$bd25e24024963319).selectedDepot = _this.depots.filter((depot)=>depot.id === depotId)[0];
    }
    GetPushpinByDepotId(depotId) {
        let _this = this;
        var pushpin = null;
        var mapEntities = _this.map.entities;
        var entityCount = mapEntities.getLength();
        for(var i = 0; i < entityCount; i++){
            var entity = mapEntities.get(i);
            if (entity instanceof Microsoft.Maps.Pushpin) {
                var metadata = entity.metadata;
                if (metadata && metadata.depotId === depotId) {
                    pushpin = entity;
                    break;
                }
            }
        }
        return pushpin;
    }
    GetMap() {
        let _this = this;
        return this.map;
    }
    GetDepots() {
        let _this = this;
        return this.depots;
    }
    GetSelectedDepotId() {
        let _this = this;
        return this.selectedDepotId;
    }
}
let $1ab168822f4abc32$export$9d1417450875059f = new $1ab168822f4abc32$var$Mapping();





class $5fd7e02679a61613$var$BookingDetailsPanel {
    // -------------------------------------------------------------------------------
    //  Private members
    // -------------------------------------------------------------------------------
    constructor(){
        this.calendarMaxDate = 120;
        this.MaxCalendarLength = 21;
        this.LeadHours = 16;
        this.hoursUntilFirstSelectableTime = 50;
        this.selectedDate = null;
        this.selectedTime = null;
        this.selectedDate2 = null;
        this.selectedTime2 = null;
        this.selectedDate3 = null;
        this.selectedTime3 = null;
        this._firstAvailableDateTime = null;
        this.saturdayHours = [
            "09:00",
            "10:00",
            "11:00",
            "12:00"
        ];
        this.weekdayHours = [
            "09:00",
            "10:00",
            "11:00",
            "12:00",
            "13:00",
            "14:00",
            "15:00",
            "16:00"
        ];
    }
    BindControls = ()=>{
        let _this = this;
        let selectedOptionId = (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.serviceRequired;
        $('#CalendarContainer').show();
        let kendoCalendar = $('#calendar').data('kendoCalendar');
        if (!SITE_CAN_SELECT_MULTIPLE_DATES && !kendoCalendar) {
            if (selectedOptionId === 'D') {
                (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime && $('#bookingTimeDiv').show();
                $('#bookingTimeSelectionMobile').hide();
            } else if (selectedOptionId === 'M') {
                $('#bookingTimeDiv').hide();
                $('#bookingTimeSelectionMobile').show();
                $('input[name="AmPmSlotSelection"]').on('change', (e)=>{
                    _this.selectedTime = $(e.target).val();
                });
            }
            (0, $a854c42000216589$export$80c5523270cba9e9).getUnavailableBookingDates(_this.InitCalendars);
            let availableHours = null;
            // First time round initialize pickers with current date, otherwise use existing
            let currentDate = new Date();
            if (currentDate.getDay() === 6) availableHours = _this.saturdayHours;
            else availableHours = _this.weekdayHours;
            let availableDateTimes = [];
            $.each(availableHours, function(_index, value) {
                let hour = moment(value, 'HH:mm').hour();
                let minute = moment(value, 'HH:mm').minutes();
                let date = moment(currentDate.setHours(hour, minute)).toDate();
                availableDateTimes.push(date);
            });
            if ((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.serviceRequired === 'D') {
                $('#bookingTimeSlot').kendoTimePicker({
                    dates: availableDateTimes
                });
                let timePicker = $('#bookingTimeSlot').data('kendoTimePicker');
                if (timePicker) timePicker.value(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 9));
            } else _this.selectedTime = $('input[name="AmPmSlotSelection"]:checked').val();
        } else if (SITE_CAN_SELECT_MULTIPLE_DATES) {
            _this.selectedDate = $('#tyreBookingDate1').val();
            _this.selectedDate2 = $('#tyreBookingDate2').val();
            _this.selectedDate3 = $('#tyreBookingDate3').val();
            if (selectedOptionId === 'D') {
                $('.mobileTimeSelection').hide();
                $('#tyreBookingTime1').show();
                $('#tyreBookingTime2').show();
                $('#tyreBookingTime3').show();
                $('#tyreBookingTime1').on('change', function(e) {
                    _this.selectedTime = $(e.target).val();
                });
                $('#tyreBookingTime2').on('change', function(e) {
                    _this.selectedTime2 = $(e.target).val();
                });
                $('#tyreBookingTime3').on('change', function(e) {
                    _this.selectedTime3 = $(e.target).val();
                });
            } else if (selectedOptionId === 'M') {
                $('.mobileTimeSelection').show();
                $('#tyreBookingTime1').hide();
                $('#tyreBookingTime2').hide();
                $('#tyreBookingTime3').hide();
                $('input[name="tyreBookingTime1Mobile"]').on('change', function(e) {
                    _this.selectedTime = $(e.target).val();
                });
                $('input[name="tyreBookingTime2Mobile"]').on('change', function(e) {
                    _this.selectedTime2 = $(e.target).val();
                });
                $('input[name="tyreBookingTime3Mobile"]').on('change', function(e) {
                    _this.selectedTime3 = $(e.target).val();
                });
            }
            (0, $a854c42000216589$export$80c5523270cba9e9).getUnavailableBookingDates(_this.InitCalendars);
        }
    };
    InitializeFullSizeCalendar = (unavailableDates)=>{
        let _this = this;
        let today = new Date();
        $("#calendar").kendoCalendar({
            disableDates: function(date) {
                if ((0, $254a84bc556d8bd3$export$366dc4c52172531e).IsInArray(date, unavailableDates)) return true;
                return false;
            },
            min: today,
            value: today,
            max: new Date(today.getFullYear(), today.getMonth(), today.getDate() + _this.MaxCalendarLength),
            format: 'dd/MM/yyyy hh:mm tt',
            dates: unavailableDates,
            month: {
                // template for dates in month view
                content: `# var customDate = data.date; #` + `# var firstAvailableDate = new Date(new Date(document.getElementById('firstAvailableDate').value).setHours(0,0,0,0)); #` + `# if (IsInArray(customDate, data.dates)) { #` + `<span class='datesNotAvailable'> #= data.value # </span>` + `# } else { #` + `<span class='# if (customDate.getTime() === firstAvailableDate.getTime()) { #firstAvailableDate# } else { #availableDate# } #'> #= data.value #</span>` + `# } #`,
                empty: '<span class="datesNotAvailable">#= data.value #</span>'
            },
            change: function() {
                _this.selectedDate = moment(this.value()).format("DD/MM/YYYY");
                //Date has changed, clear time information
                _this.selectedTime = "";
                $('#bookingDetailsSection').find('input[id="bookingTimeSlot"]').val("");
                _this.showHideValidationMessage($("div#appointmentTimeInvalidMessage"), _this.selectedTime);
                _this.showHideValidationMessage($("div#appointmentDateInvalidMessage"), this.value().toJSON());
                let firstAvailableDate = new Date(_this._firstAvailableDateTime.getFullYear(), _this._firstAvailableDateTime.getMonth(), _this._firstAvailableDateTime.getDate());
                let formatedDate = new Date(this.value().getFullYear(), this.value().getMonth(), this.value().getDate());
                let availableHours = null;
                if (moment(formatedDate).day() === 6) availableHours = _this.saturdayHours;
                else availableHours = _this.weekdayHours;
                var filteredAvailableHours = availableHours;
                if (moment(formatedDate).isSame(firstAvailableDate)) filteredAvailableHours = availableHours.filter(function(value, _index, _arr) {
                    let hour = moment(value, 'HH:mm').hour();
                    let minute = moment(value, 'HH:mm').minutes();
                    let valueTime = moment(formatedDate.setHours(hour, minute));
                    let firstAvailableTimeFormat = moment(_this._firstAvailableDateTime);
                    return valueTime.isSameOrAfter(firstAvailableTimeFormat);
                });
                var availableDateTimes = [];
                $.each(filteredAvailableHours, function(_index, value) {
                    let hour = moment(value, 'HH:mm').hour();
                    let minute = moment(value, 'HH:mm').minutes();
                    let date = moment(formatedDate.setHours(hour, minute)).toDate();
                    availableDateTimes.push(date);
                });
                if ((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.serviceRequired === 'D') {
                    $("#bookingTimeDiv").show('slow');
                    let timePicker = $('#bookingTimeSlot').data('kendoTimePicker');
                    timePicker.setOptions({
                        dates: availableDateTimes,
                        change: OnChange
                    });
                    timePicker.min(availableDateTimes[0]);
                    timePicker.max(availableDateTimes[availableDateTimes.length - 1]);
                    timePicker.value(null);
                }
                function OnChange(e) {
                    _this.selectedTime = $('#bookingDetailsSection').find('input[id="bookingTimeSlot"]').val();
                    _this.showHideValidationMessage($("div#appointmentTimeInvalidMessage"), _this.selectedTime);
                }
                $("#bookingDateDiv #bookingDate").val(kendo.toString(this.value(), 'dd/MM/yyyy'));
                (0, $254a84bc556d8bd3$export$366dc4c52172531e).ShowNextRow($('#driverBookingCalendar'), 1, 'bd-row');
            },
            footer: false
        });
    };
    InitCalendars = (unavailableDatesArray)=>{
        let _this = this;
        (0, $a854c42000216589$export$80c5523270cba9e9).getFirstAvailableDateTime().then((firstDate)=>{
            _this._firstAvailableDateTime = new Date(firstDate);
            $('#firstAvailableDate').val(_this._firstAvailableDateTime);
            _this.InitializeFullSizeCalendar(unavailableDatesArray);
            _this.InitialiseFlatpickrCalender(unavailableDatesArray);
        }).catch((error)=>console.log(error));
    };
    Init = (moveNext, moveBack, forward)=>{
        let _this = this;
        $("#bookingTimeDiv").hide();
        _this.BindControls(_this.MaxCalendarLength);
        if ((0, $254a84bc556d8bd3$export$366dc4c52172531e).DoNotShowCalendar()) {
            if (forward) moveNext();
            else moveBack();
        }
    };
    InitialiseFlatpickrCalender = (unavailableDates)=>{
        const today = new Date();
        const datesToExclude = [];
        const datesInView = [];
        const firstSelectableTime = this.firstSelectableDate();
        const fp = flatpickr(".date", {
            minDate: firstSelectableTime,
            maxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + this.MaxCalendarLength),
            disable: [
                (date)=>{
                    var isUnavailableDate = this.dateInArray(unavailableDates, date);
                    let result;
                    const isFirstSelectableSameDate = date.toDateString() === firstSelectableTime.toDateString();
                    switch(date.getDay()){
                        case 0:
                            result = true;
                            break;
                        case 6:
                            result = isFirstSelectableSameDate ? firstSelectableTime.getHours() >= 12 : date < firstSelectableTime;
                            break;
                        default:
                            result = isFirstSelectableSameDate ? firstSelectableTime.getHours() >= 16 : date < firstSelectableTime;
                            break;
                    }
                    if (isUnavailableDate) result = true;
                    if (!this.dateInArray(datesInView, date)) {
                        if (date > today && date.getMonth() === today.getMonth()) datesInView.push(date);
                    }
                    if (result) {
                        if (!this.dateInArray(datesToExclude, date)) {
                            if (date > today) datesToExclude.push(date);
                        }
                    }
                    return result;
                }
            ],
            dateFormat: "d/m/Y",
            onChange: (selectedDates, dateStr, instance)=>{
                this.dateChanged(instance.input.id);
            },
            onOpen: (selectedDates, dateStr, instance)=>{
                let daysLeftInView = datesInView.some((dayOfMonth)=>!this.dateInArray(datesToExclude, dayOfMonth));
                if (!daysLeftInView) instance.changeMonth(1);
            }
        });
    };
    dateChanged = (controlId)=>{
        var date = this.newDate(controlId);
        var timeId = controlId.replace('Date', 'Time');
        var bookingTimes = date.getDay() == 6 ? (0, $a854c42000216589$export$5a83fe19d473e305).timesSaturday : (0, $a854c42000216589$export$5a83fe19d473e305).timesWeekday;
        const firstSelectableTime = this.firstSelectableDate();
        $('#' + timeId).prop("disabled", false);
        $('#' + timeId).empty();
        if ((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.serviceRequired === 'D') bookingTimes.forEach((item)=>{
            const [hour, minute] = item.value.split(/[: ]/);
            const itemHour = minute === "00PM" && hour !== "12" ? parseInt(hour) + 12 : minute === "00AM" && hour === "12" ? 0 : parseInt(hour);
            if (hour == "Please") this.addTime(timeId, item);
            else if (date.toDateString() === firstSelectableTime.toDateString()) {
                if (itemHour > firstSelectableTime.getHours()) this.addTime(timeId, item);
            } else this.addTime(timeId, item);
        });
    };
    addTime = (controlId, item)=>{
        $('#' + controlId).append($('<option>', {
            value: item.id,
            text: item.value
        }));
    };
    newDate = (id, hours = null)=>{
        if (!hours) hours = 9;
        var dateParts = $('#' + id).val().split("/");
        var date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        date.setHours(hours, 0, 0, 0);
        return date;
    };
    firstSelectableDate = ()=>{
        return new Date(new Date().getTime() + this.hoursUntilFirstSelectableTime * 3600000);
    };
    dateInArray = (array, value)=>{
        return !!array.find((item)=>{
            return item.getTime() == value.getTime();
        });
    };
    // -------------------------------------------------------------------------------
    //  Public members
    // -------------------------------------------------------------------------------
    InitializePanel = (moveNext, moveBack, forward)=>{
        if (!SITE_CAN_SELECT_MULTIPLE_DATES) // set kendo calendar to start by Monday
        kendo.culture().calendar.firstDay = 1;
        this.Init(moveNext, moveBack, forward);
    };
    SaveBookingDetails = ()=>{
        let _this = this;
        let $panel = $('#bookingDetailsSection');
        if (SITE_CAN_SELECT_MULTIPLE_DATES) {
            _this.selectedDate = $('#tyreBookingDate1').val();
            _this.selectedDate2 = $('#tyreBookingDate2').val();
            _this.selectedDate3 = $('#tyreBookingDate3').val();
            (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingDate = _this.selectedDate;
            (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingDate2 = _this.selectedDate2;
            (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingDate3 = _this.selectedDate3;
            if ($("input[name='ServiceRequired']:checked").val() === 'D') (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime = $panel.find('select[id="tyreBookingTime1"] option:selected').text();
            else (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime = $panel.find('input[name="tyreBookingTime1Mobile"]:checked').val();
            if ($("input[name='ServiceRequired']:checked").val() === 'D') (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime2 = $panel.find('select[id="tyreBookingTime2"] option:selected').text();
            else (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime2 = $panel.find('input[name="tyreBookingTime2Mobile"]:checked').val();
            if ($("input[name='ServiceRequired']:checked").val() === 'D') (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime3 = $panel.find('select[id="tyreBookingTime3"] option:selected').text();
            else (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime3 = $panel.find('input[name="tyreBookingTime3Mobile"]:checked').val();
        } else {
            (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingDate = _this.selectedDate;
            if ($("input[name='ServiceRequired']:checked").val() === 'D') (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime = $panel.find('input[id="bookingTimeSlot"]').val();
            else (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime = $panel.find('input[name="AmPmSlotSelection"]:checked').val();
        }
    };
    showHideValidationMessage = ($validationElement, valid)=>{
        if (SITE_CAN_SELECT_MULTIPLE_DATES) {
            if (valid) (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).RemoveValidationStyles($validationElement);
        } else if (valid) $validationElement.hide();
        else {
            $validationElement.show('slow');
            (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).RemoveValidationStyles($("input[id^=bookingTimeSlot]"));
        }
    };
    GetValidator = ()=>{
        let _this = this;
        let validator;
        if (SITE_CAN_SELECT_MULTIPLE_DATES) {
            let selectedOptionId = (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.serviceRequired;
            validator = $('#bookingDetailsSection').kendoValidator({
                rules: {
                    validateDateOption1: ()=>!!$('#tyreBookingDate1').val(),
                    validateDateOption2: ()=>!!$('#tyreBookingDate2').val(),
                    validateDateOption3: ()=>!!$('#tyreBookingDate3').val(),
                    validateTimeOption1: ()=>{
                        if (selectedOptionId === 'M') return !!$('input[name="tyreBookingTime1Mobile"]:checked').val();
                        else {
                            const timeValue = $('#tyreBookingTime1').val();
                            return timeValue && timeValue !== "0" && timeValue !== "";
                        }
                    },
                    validateTimeOption2: ()=>{
                        if (selectedOptionId === 'M') return !!$('input[name="tyreBookingTime2Mobile"]:checked').val();
                        else {
                            const timeValue = $('#tyreBookingTime2').val();
                            return timeValue && timeValue !== "0" && timeValue !== "";
                        }
                    },
                    validateTimeOption3: ()=>{
                        if (selectedOptionId === 'M') return !!$('input[name="tyreBookingTime3Mobile"]:checked').val();
                        else {
                            const timeValue = $('#tyreBookingTime3').val();
                            return timeValue && timeValue !== "0" && timeValue !== "";
                        }
                    },
                    validateMaxTwoSameDates: ()=>{
                        const dates = [
                            $('#tyreBookingDate1').val(),
                            $('#tyreBookingDate2').val(),
                            $('#tyreBookingDate3').val()
                        ].filter((date)=>!!date);
                        const dateFrequency = dates.reduce((acc, date)=>{
                            acc[date] = (acc[date] || 0) + 1;
                            return acc;
                        }, {});
                        return !Object.values(dateFrequency).some((count)=>count > 2);
                    },
                    validateUniqueDateTimeCombinations: ()=>{
                        const combinations = [
                            {
                                date: $('#tyreBookingDate1').val(),
                                time: selectedOptionId === 'M' ? $('input[name="tyreBookingTime1Mobile"]:checked').val() : $('#tyreBookingTime1').val()
                            },
                            {
                                date: $('#tyreBookingDate2').val(),
                                time: selectedOptionId === 'M' ? $('input[name="tyreBookingTime2Mobile"]:checked').val() : $('#tyreBookingTime2').val()
                            },
                            {
                                date: $('#tyreBookingDate3').val(),
                                time: selectedOptionId === 'M' ? $('input[name="tyreBookingTime3Mobile"]:checked').val() : $('#tyreBookingTime3').val()
                            }
                        ];
                        const uniqueCombinations = new Set(combinations.map((c)=>`${c.date} ${c.time}`));
                        return uniqueCombinations.size === combinations.length;
                    }
                },
                messages: {
                    validateDateOption1: "Please select a date for Option 1",
                    validateDateOption2: "Please select a date for Option 2",
                    validateDateOption3: "Please select a date for Option 3",
                    validateTimeOption1: "Please select a time for Option 1",
                    validateTimeOption2: "Please select a time for Option 2",
                    validateTimeOption3: "Please select a time for Option 3",
                    validateMaxTwoSameDates: "You can select a maximum of two of the same date across the 3 options.",
                    validateUniqueDateTimeCombinations: "Date and Times must be unique across all 3 options."
                }
            }).data('kendoValidator');
            validator.bind('validate', function() {
                const isValidTime1 = $('#tyreBookingDate1').val() && (selectedOptionId === 'M' ? $('input[name="tyreBookingTime1Mobile"]:checked').val() : $('#tyreBookingTime1').val() && $('#tyreBookingTime1').val() !== "0" && $('#tyreBookingTime1').val() !== "");
                const isValidTime2 = $('#tyreBookingDate2').val() && (selectedOptionId === 'M' ? $('input[name="tyreBookingTime2Mobile"]:checked').val() : $('#tyreBookingTime2').val() && $('#tyreBookingTime2').val() !== "0" && $('#tyreBookingTime2').val() !== "");
                const isValidTime3 = $('#tyreBookingDate3').val() && (selectedOptionId === 'M' ? $('input[name="tyreBookingTime3Mobile"]:checked').val() : $('#tyreBookingTime3').val() && $('#tyreBookingTime3').val() !== "0" && $('#tyreBookingTime3').val() !== "");
                const dates = [
                    $('#tyreBookingDate1').val(),
                    $('#tyreBookingDate2').val(),
                    $('#tyreBookingDate3').val()
                ].filter((date)=>!!date);
                const dateFrequency = dates.reduce((acc, date)=>{
                    acc[date] = (acc[date] || 0) + 1;
                    return acc;
                }, {});
                const hasThreeSameDates = Object.values(dateFrequency).some((count)=>count > 2);
                const dateTimeCombinations = [
                    {
                        date: $('#tyreBookingDate1').val(),
                        time: selectedOptionId === 'M' ? $('input[name="tyreBookingTime1Mobile"]:checked').val() : $('#tyreBookingTime1').val()
                    },
                    {
                        date: $('#tyreBookingDate2').val(),
                        time: selectedOptionId === 'M' ? $('input[name="tyreBookingTime2Mobile"]:checked').val() : $('#tyreBookingTime2').val()
                    },
                    {
                        date: $('#tyreBookingDate3').val(),
                        time: selectedOptionId === 'M' ? $('input[name="tyreBookingTime3Mobile"]:checked').val() : $('#tyreBookingTime3').val()
                    }
                ];
                const uniqueCombinations = new Set(dateTimeCombinations.map((c)=>`${c.date} ${c.time}`));
                const hasNoDuplicateDateTime = uniqueCombinations.size === dateTimeCombinations.length;
                const hasValidationError = !isValidTime1 || !isValidTime2 || !isValidTime3 || hasThreeSameDates || !hasNoDuplicateDateTime;
                _this.showHideValidationMessage($("#tyreBookingTime1"), !hasValidationError);
                _this.showHideValidationMessage($("#tyreBookingTime2"), !hasValidationError);
                _this.showHideValidationMessage($("#tyreBookingTime3"), !hasValidationError);
            });
        } else {
            validator = $('#bookingDetailsSection').kendoValidator({
                rules: {
                    validateCalendar: ()=>{
                        return (0, $254a84bc556d8bd3$export$366dc4c52172531e).DoNotShowCalendar() ? true : _this.selectedDate ? true : false;
                    },
                    validateTime: ()=>{
                        return (0, $254a84bc556d8bd3$export$366dc4c52172531e).DoNotShowCalendar() ? true : _this.selectedTime ? true : false;
                    }
                },
                messages: {
                    validateCalendar: "Please select an appointment date",
                    validateTime: "Please select an appointment time"
                }
            }).data('kendoValidator');
            validator.bind('validate', function() {
                _this.showHideValidationMessage($("div#appointmentDateInvalidMessage"), _this.selectedDate);
                if ($("input[id^=bookingTimeSlot]").is(":visible")) _this.showHideValidationMessage($("div#appointmentTimeInvalidMessage"), _this.selectedTime);
            });
        }
        return validator;
    };
}
let $5fd7e02679a61613$export$575f8a200748f96d = new $5fd7e02679a61613$var$BookingDetailsPanel();



let $971800e8c852106e$var$WheelDetailsPanel = function() {
    // -------------------------------------------------------------------------------
    //  Private members
    // -------------------------------------------------------------------------------
    let toggleLine = function($elementToToggle, flag) {
        $elementToToggle.find('input:radio').prop('checked', false);
        if (flag === 'show') $elementToToggle.css('display', 'flex');
        else if (flag === 'hide') $elementToToggle.css('display', 'none');
    };
    let bindControls = function() {
        $('input[name="WheelType"]').on('change', function(e) {
            e.preventDefault();
            toggleLine($('#wheelDetailsSection .form-group:not(.first)'), 'hide');
            var selectedValue = $(this).filter(':checked').val();
            if (selectedValue === 'Steel') toggleLine($(this).closest('.form-group').nextAll().not('.lockingNutsRow').first(), 'show');
            else if (selectedValue === 'Alloy') toggleLine($('.lockingNutsRow'), 'show');
        });
        $('input[name="LockingWheelNuts"]').on('change', function() {
            const hasLockingNuts = $(this).filter(':checked').val();
            const toggleWheelNutMessages = (togglePropArray)=>{
                togglePropArray.forEach((element)=>{
                    toggleLine($(element.id), element.style);
                });
            };
            switch(hasLockingNuts){
                case 'Yes':
                    toggleWheelNutMessages([
                        {
                            id: '#wheelNutsWarning',
                            style: 'hide'
                        },
                        {
                            id: '#wheelNutsInfo',
                            style: 'show'
                        }
                    ]);
                    break;
                case 'No':
                    toggleWheelNutMessages([
                        {
                            id: '#wheelNutsWarning',
                            style: 'hide'
                        },
                        {
                            id: '#wheelNutsInfo',
                            style: 'hide'
                        }
                    ]);
                    break;
                case 'Unknown':
                    toggleWheelNutMessages([
                        {
                            id: '#wheelNutsWarning',
                            style: 'show'
                        },
                        {
                            id: '#wheelNutsInfo',
                            style: 'hide'
                        }
                    ]);
                    break;
            }
            toggleLine($(this).closest('.form-group').next(), 'show');
        });
        $('input[name="RoadworthySpare"]').on('change', function(e) {
            e.preventDefault();
            var selectedValue = $(this).filter(':checked').val();
            if (selectedValue === 'No') {
                toggleLine($('.spareSizeRow'), 'hide');
                toggleLine($('.inflationKitRow'), 'show');
            } else {
                toggleLine($('.spareSizeRow'), 'show');
                toggleLine($('.inflationKitRow'), 'hide');
            }
        });
        $('input[name="SpareSize"], input[name="InflationKit"]').on('change', function(e) {
            e.preventDefault();
            toggleLine($(this).closest('.form-group').nextAll().not('.spareSizeRow').not('.inflationKitRow').first(), 'show');
        });
        $('input[name="ObstructionTyres"]').on('change', function(e) {
            e.preventDefault();
            var selectedValue = $(this).filter(':checked').val();
            if (selectedValue === 'No') toggleLine($('.obstructionDetailsRow'), 'hide');
            else toggleLine($('.obstructionDetailsRow'), 'show');
        });
    };
    // -------------------------------------------------------------------------------
    //  Public members
    // -------------------------------------------------------------------------------
    return {
        initializePanel: function() {
            bindControls();
        },
        saveWheelDetails: function() {
            let $currentPanel = $('#wheelDetailsSection');
            var wheelDetailsModel = new (0, $a854c42000216589$export$4ffaef9f9e4625b3)($currentPanel.find('input[name="WheelType"]:checked').val(), $currentPanel.find('input[name="RoadworthySpare"]:checked').val(), $currentPanel.find('input[name="SpareSize"]:checked').val(), $currentPanel.find('input[name="InflationKit"]:checked').val(), $currentPanel.find('input[name="LockingWheelNuts"]:checked').val(), $currentPanel.find('input[name="ObstructionTyres"]:checked').val(), $currentPanel.find('#obstructionDetails').val());
            (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails = wheelDetailsModel;
        },
        getValidator: function() {
            var $roadworthySpareInput;
            var $obstructionInput;
            return $('#wheelDetailsSection').kendoValidator({
                rules: {
                    wheelTypeSelected: function(input) {
                        // Make sure wheelType is selected
                        if ($(input).is('input[name="WheelType"]')) {
                            var $wheelTypeInput = $('input[name="WheelType"]');
                            if (!$wheelTypeInput.is(':checked')) return false;
                        }
                        return true;
                    },
                    wheelNutSelected: function(input) {
                        // If Alloy wheel type is selected make sure wheel nut is selected
                        if ($(input).is('input[name="LockingWheelNuts"]') && $('input[name="WheelType"]').is(':checked')) {
                            if ($('input[name="WheelType"]').filter(':checked').val() === 'alloy') {
                                var $wheelnutsInput = $('input[name="LockingWheelNuts"]');
                                if (!$wheelnutsInput.is(':checked')) return false;
                            }
                        }
                        return true;
                    },
                    roadWorthySpareSelected: function(input) {
                        if ($(input).is('input[name="RoadworthySpare"]')) {
                            $roadworthySpareInput = $('input[name="RoadworthySpare"]');
                            if (!$roadworthySpareInput.is(':checked')) return false;
                        }
                        return true;
                    },
                    spareSizeSelected: function(input) {
                        // If RoadworthySpare is Yes then spare size should be selected
                        if ($(input).is('input[name="SpareSize"]') && $('input[name="RoadworthySpare"]').is(':checked')) {
                            if ($roadworthySpareInput.filter(':checked').val() === 'true') {
                                var $SpareSizeInput = $('input[name="SpareSize"]');
                                if (!$SpareSizeInput.is(':checked')) return false;
                            }
                        }
                        return true;
                    },
                    inflationKitSelected: function(input) {
                        if ($(input).is('input[name="InflationKit"]') && $('input[name="RoadworthySpare"]').is(':checked')) {
                            if ($roadworthySpareInput.filter(':checked').val() === 'false') {
                                var $inflationKitInput = $('input[name="InflationKit"]');
                                if (!$inflationKitInput.is(':checked')) return false;
                            }
                        }
                        return true;
                    },
                    obstructionSelected: function(input) {
                        // Make sure obstruction on tyre is selected
                        if ($(input).is('input[name="ObstructionTyres"]')) {
                            $obstructionInput = $('input[name="ObstructionTyres"]');
                            if (!$obstructionInput.is(':checked')) return false;
                        }
                        return true;
                    },
                    obstructionDetailsSelected: function(input) {
                        if ($(input).is('#obstructionDetails') && $('input[name="ObstructionTyres"]').is(':checked')) {
                            if ($obstructionInput.filter(':checked').val() === 'true') {
                                var $obstructionDetailInput = $('#obstructionDetails');
                                if ($obstructionDetailInput.val().length < 1) return false;
                            }
                        }
                        return true;
                    }
                },
                messages: {
                    wheelTypeSelected: 'Wheel type field is mandatory',
                    wheelNutSelected: 'Wheel nut field is mandatory',
                    roadWorthySpareSelected: 'Roadworthy spare field is mandatory',
                    spareSizeSelected: 'Spare size field is mandatory',
                    inflationKitSelected: 'Inflation kit field is mandatory',
                    obstructionSelected: 'Obstructions field is mandatory',
                    obstructionDetailsSelected: 'Obstruction details field is mandatory'
                }
            }).data('kendoValidator');
        }
    };
};
let $971800e8c852106e$export$f4684e08bac54ec3 = new $971800e8c852106e$var$WheelDetailsPanel();











class $69c3cf5eb45c3c99$export$2e2bcd8739ae039 {
    static nextIndex = 0;
    static ValidateElements = ($carousel, direction)=>{
        $carousel.on('slide.bs.carousel', function(event) {
            if (direction === 'next') {
                let next = $(event.relatedTarget);
                let nextIndex = next.index();
                let items = $carousel.find('.k-input');
                let validator = items.kendoValidator().data('kendoValidator');
                if (!validator.validate()) return false;
                //Return and use for actions. 
                $69c3cf5eb45c3c99$export$2e2bcd8739ae039.nextIndex = nextIndex;
            }
        });
    };
}



class $580dee653a8183ea$var$TyreDetails {
    // --------------------------------------------------
    // CONSTRUCTOR
    // --------------------------------------------------
    constructor(){
        this.tyreAlreadySelected = new Set();
        this.duplicateTyreSelections = new Set();
        this.tyreAttributes = [];
        this.plan = null;
        this.axle = '';
        this.tyreLoading = false;
    }
    // --------------------------------------------------
    // GETTER AND SETTER
    // --------------------------------------------------
    // --------------------------------------------------
    // 'PRIVATE' FUNCTIONS
    // --------------------------------------------------
    ShowTyreDetailSection(plan, sectionId, navigatingForward) {
        let _this = this;
        $('li[data-menuanchor="' + plan + 'Anchor' + '"]').show();
        (0, $a854c42000216589$export$bd25e24024963319).wheelsSelected = plan;
        this.plan = plan = {
            Name: 'ALLTYRES',
            Position: 'ALLTYRES'
        };
        (0, $254a84bc556d8bd3$export$366dc4c52172531e).LoadHtmlTemplate('/Tyres/GetPartialView', {
            positionName: plan.Name,
            positionLabel: plan.Position,
            viewName: '~/Views/Tyres/Partials/_tyreDetails.cshtml'
        }, // callback
        async function(template) {
            if (navigatingForward) {
                $('#' + sectionId).empty();
                $('#' + sectionId).append(template);
                // init tyre visual
                $(`#ALLTYRES_tyreVisual .tyre-wrap h1`).lettering();
                $(`#ALLTYRES_tyreVisual .tyre-wrap h1 span`).addClass('rubber');
                // hide the tyre carousel by default
                $('#ALLTYRES_DetailContainer1').find('.tyre-edit').addClass('d-lg-none');
                $(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'none');
                // load tyre history
                _this.GetTyreHistory();
                _this.SetupDefaultButtons(template);
            } else {
                // hide the tyre carousel by default
                $('#ALLTYRES_DetailContainer1').find('.tyre-edit').addClass('d-lg-none');
                $('.nextButton').show();
            }
        });
        $('#' + sectionId).show();
        $('.nextButton').hide();
        (0, $254a84bc556d8bd3$export$366dc4c52172531e).BuildMobileBreadcrumbNav();
    }
    SetCurrentConfigToHistoricalData(positionToLoad, axleToApply, complete) {
        let _this = this;
        let historyData = Object.values((0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreHistory).find((attr)=>attr.positionCode === positionToLoad);
        // match the wheel position code final char which indicates front or rear to the first char of the axle label F or R
        let applyToConfigs;
        if (axleToApply === 'SPARE') applyToConfigs = _this.tyreAttributes.filter((attr)=>attr.name === axleToApply.toUpperCase());
        else applyToConfigs = _this.tyreAttributes.filter((attr)=>attr.name.substring(2, 3) === axleToApply.substring(0, 1).toUpperCase());
        applyToConfigs.forEach((config)=>{
            Object.keys(config.configuration).forEach(function(currentItem) {
                let loadPosition = currentItem.toLowerCase();
                if (loadPosition === 'loadindex') loadPosition = 'loadIndex';
                if (loadPosition === 'diameter') loadPosition = 'rim';
                if (loadPosition === 'brand') loadPosition = 'brandName';
                if (historyData[loadPosition] !== undefined) config.configuration[currentItem].value = historyData[loadPosition];
            });
            config.configuration.complete = true;
            if (!complete) _this.GoToTyreVisualIndex(config.configuration, 0);
        });
        _this.tyreLoading = false;
    }
    GoToTyreVisualIndex(currentPositionConfiguration, index) {
        let currentPosition = 'ALLTYRES';
        // if we already have a value then it was loaded by tyre history/or edit - validate - show next button
        let widthDdl = $(`#${currentPosition}_Width`)[0];
        let ratiosDdl = $(`#${currentPosition}_Ratio`);
        let diametersDdl = $(`#${currentPosition}_Diameter`);
        let loadRatingsDdl = $(`#${currentPosition}_LoadRating`);
        let speedRatiosDdl = $(`#${currentPosition}_SpeedRating`);
        let constructionsDdl = $(`#${currentPosition}_Construction`);
        //TO DO - check data is valid still as historical tyre may no longer be available as current product - told to not worry for now.
        widthDdl.value = currentPositionConfiguration.width.value;
        ratiosDdl.data('kendoDropDownList').value(currentPositionConfiguration.profile.value);
        diametersDdl.data('kendoDropDownList').value(currentPositionConfiguration.diameter.value);
        loadRatingsDdl.data('kendoDropDownList').value(currentPositionConfiguration.loadindex.value);
        speedRatiosDdl.data('kendoDropDownList').value(currentPositionConfiguration.speed.value);
        constructionsDdl.data('kendoDropDownList').value(currentPositionConfiguration.construction.value);
        let $previous = $(`#ALLTYRES_slideTyreDropDownLeft`);
        let $next = $(`#ALLTYRES_slideTyreDropDownRight`);
        if (index > 0) $next.css('display', 'block').addClass('rightmove');
        if (index > 5) {
            $(`#ALLTYRES_carouselTyresDropDownLists`).find(`.carousel-item:nth-child(7)`).addClass('active');
            (0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).nextIndex = 5;
            $previous.css('display', 'block').addClass('leftmove');
            $next.css('display', 'none');
        } else {
            $(`#ALLTYRES_carouselTyresDropDownLists`).find(`.carousel-item:nth-child(${index + 1})`).addClass('active');
            (0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).nextIndex = index;
            let itemToSelect = Object.keys(currentPositionConfiguration).find((attr)=>currentPositionConfiguration[attr].position === index + 1);
            currentPositionConfiguration[itemToSelect].selected = true;
            if (index != 0) {
                $previous.css('display', 'block').addClass('leftmove');
                $next.css('display', 'block').addClass('rightmove');
            }
            this.SetTyreVisual(currentPositionConfiguration, index, currentPosition);
        }
    }
    GetTyreHistory() {
        let _this = this;
        let historyData = (0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreHistory;
        let $historyDiv = $(`#ALLTYRES_DetailContainer1`).find('.tyre-history-data');
        $historyDiv.html('');
        let axlePlan = {
            FRONT: [
                'NSF',
                'OSF'
            ],
            REAR: [
                'NSR',
                'NSR2',
                'OSR2',
                'OSR'
            ],
            SPARE: [
                'SPARE'
            ]
        };
        if (historyData.length === 0) Object.keys(axlePlan).forEach((item)=>{
            // for each axle plan - show some boxes
            let textExtra = !(item === 'SPARE') ? ' axle' : '';
            let textLabel = `<div class="axle-details" data-axle="${item}">Please click and enter your tyre details for the <span class="font-weight-bold ds-contents">${item}</span>${textExtra}</div>`;
            let historyContent = '';
            let wheelsActive = 0;
            Object.values(axlePlan[item]).forEach((wheel)=>{
                // check if wheel plan active
                let foundConfig = Object.values(_this.tyreAttributes).find((attr)=>attr.name === wheel);
                if (foundConfig && wheelsActive < 1) {
                    wheelsActive += 1;
                    historyContent += `<div id="editHistory" class="ml-5 edit-history w-25 btn btn-outline-info text-dark font-weight-bold" data-axle="${item}" data-position="">Enter Details</div>`;
                }
            });
            if (wheelsActive > 0) {
                let htmlBuilder = `<div class="col-12 card mt-2 p-2">${textLabel}${historyContent}</div><br/>`;
                $historyDiv.html($historyDiv.html() + htmlBuilder);
                $historyDiv.parent().removeClass('d-lg-none');
            }
        });
        else Object.keys(axlePlan).forEach((item)=>{
            // for each axle plan - show some boxes
            let textExtra = !(item === 'SPARE') ? ' axle' : '';
            let textLabel = `<div class="axle-details" data-axle="${item}">Please click and enter your tyre details for the <span class="font-weight-bold ds-contents">${item}</span>${textExtra}</div>`;
            let historyLabel = SITE_EXTENDED_WARNINGS ? `<div class="tyre-history-text">Good news. We've found existing tyre history for the <span class="font-weight-bold ds-contents">${item}</span>${textExtra} - Before confirming, please check your tyres and ensure this is correct.  Any incorrect tyres selected could cause delays to your booking. </div>` : `<div class="tyre-history-text">Good news. We've found existing tyre history for the <span class="font-weight-bold ds-contents">${item}</span>${textExtra} - Would you like to use this tyre size?</div>`;
            let historyContent = '';
            let wheelsActive = 0;
            Object.values(axlePlan[item]).forEach((wheel)=>{
                // check if wheel plan active
                let foundConfig = Object.values(_this.tyreAttributes).find((attr)=>attr.name === wheel);
                // just show the first history row for axle as newest - history array is ordered so new are at top
                if (foundConfig && wheelsActive < 1) {
                    wheelsActive += 1;
                    // wheel is active - is there any history data
                    let foundConfig = Object.values(historyData).find((attr)=>attr.positionCode === wheel);
                    if (foundConfig === undefined) {
                        // no history found - find for history on same axle - checking last char
                        let frontRear = wheel.substring(2, 3);
                        foundConfig = Object.values(historyData).find((attr)=>attr.positionCode.includes(frontRear));
                    }
                    if (foundConfig !== undefined) {
                        textLabel = historyLabel;
                        // found history data - show data and hide the tyre selector.
                        $(`#ALLTYRES_DetailContainer1`).find('.tyre-edit').addClass('d-lg-none');
                        let data = foundConfig;
                        historyContent += `<table class="w-100" data-axle="${item}"><tr>
											<td>${data.positionCode}</td>
											<td>${data.width}</td>
											<td>${data.profile}</td>
											<td>${data.rim}</td>
											<td>${data.speed}</td>
											<td>${data.loadIndex}</td>
											<td>${data.construction}</td>
											<td class="text-right">
												<div class="load-history btn btn-success font-weight-bold m-1" data-axle="${item}" data-position="${data.positionCode}">Confirm</div>
												<div class="edit-history btn btn-outline-info text-dark font-weight-bold btn-amend m-1" data-axle="${item}" data-position="${data.positionCode}">Amend</div>
											</td>
										  <tr></table>`;
                    } else historyContent += `<div id="editHistory" class="edit-history w-25 btn btn-outline-info text-dark font-weight-bold" data-axle="${item}" data-position="">Enter Details</div>`;
                }
            });
            if (wheelsActive > 0) {
                let htmlBuilder = `<div class="col-12 card mt-2 p-2">${textLabel}${historyContent}</div><br/>`;
                $historyDiv.html($historyDiv.html() + htmlBuilder);
                $historyDiv.parent().removeClass('d-lg-none');
            }
        });
    }
    HideTyreDetailSection(position, sectionId) {
        $('li[data-menuanchor="' + position + 'Anchor' + '"]').hide();
        kendo.destroy('#' + sectionId);
        $('#' + sectionId).hide();
        (0, $254a84bc556d8bd3$export$366dc4c52172531e).BuildMobileBreadcrumbNav();
    }
    ResetForwardPositionData(currentPositionConfiguration, source) {
        currentPositionConfiguration.complete = false;
        let currentAttributeSelected = Object.values(currentPositionConfiguration).find((attr)=>attr.name === source);
        Object.values(currentPositionConfiguration).forEach((attr)=>{
            if (attr.position > currentAttributeSelected.position) attr.value = '';
        });
        // update history row to not valid - yellow
        $('#ALLTYRES_DetailContainer1 table[data-axle="' + this.axle + '"]').find('td:lt(8)').removeClass('tyre-done-highlight').addClass('bg-highlight');
    }
    RefreshTyreConfigurationAttributes(currentPosition, source, args, isback) {
        let _this = this;
        let result = $.Deferred();
        let container = $(`#tyreSection_TYRES`);
        let ratiosDdl = $(container).find(`#ALLTYRES_Ratio`).data('kendoDropDownList');
        let diametersDdl = $(container).find(`#ALLTYRES_Diameter`).data('kendoDropDownList');
        let loadRatingsDdl = $(container).find(`#ALLTYRES_LoadRating`).data('kendoDropDownList');
        let speedRatiosDdl = $(container).find(`#ALLTYRES_SpeedRating`).data('kendoDropDownList');
        let constructionsDdl = $(container).find(`#ALLTYRES_Construction`).data('kendoDropDownList');
        // *** USED ONLY FOR THE DATA LOOKUP - Get current config into a NON ref array - reset any values greater than current position
        let currentPositionConfiguration = _this.tyreAttributes.find((attr)=>attr.name === currentPosition).configuration;
        let currentPositionConfigurationFilter = JSON.parse(JSON.stringify(currentPositionConfiguration));
        let currentAttributeSelected = Object.values(currentPositionConfiguration).find((attr)=>attr.name === source);
        if (currentAttributeSelected) Object.values(currentPositionConfigurationFilter).forEach((attr)=>{
            if (attr.position > currentAttributeSelected.position) attr.value = '';
        });
        let filterCriteria = {
            Width: currentPositionConfigurationFilter.width.value,
            Profile: currentPositionConfigurationFilter.profile.value,
            Rim: currentPositionConfigurationFilter.diameter.value,
            LoadIndex: currentPositionConfigurationFilter.loadindex.value,
            Speed: currentPositionConfigurationFilter.speed.value,
            Construction: currentPositionConfigurationFilter.construction.value
        };
        //***
        // Get data based on the filter above
        let tyreConfigurationAttributes = _this.GetTyreConfigurationAttributes(filterCriteria);
        $.when(tyreConfigurationAttributes).done(function(data) {
            if (!isback) {
                if (ratiosDdl && source === 'width' && currentAttributeSelected.position <= 2) {
                    let newProfilesSource = new kendo.data.DataSource({
                        data: data.profiles
                    });
                    ratiosDdl.setDataSource(newProfilesSource);
                    ratiosDdl.value(currentPositionConfiguration.profile.value);
                    if (ratiosDdl.value().length > 0 && currentAttributeSelected.position === 1 && !isback) {
                        container.find('span[id$="slideTyreDropDownRight"]').addClass('rightmove');
                        ratiosDdl.trigger('change', [
                            {
                                clearforwarddata: 0
                            }
                        ]);
                    }
                }
                if (diametersDdl && source === 'profile' && currentAttributeSelected.position <= 3) {
                    let newRimsSource = new kendo.data.DataSource({
                        data: data.rims
                    });
                    diametersDdl.setDataSource(newRimsSource);
                    diametersDdl.value(currentPositionConfiguration.diameter.value);
                    if (diametersDdl.value().length > 0 && currentAttributeSelected.position === 2 && !isback) {
                        container.find('span[id$="slideTyreDropDownRight"]').addClass('rightmove');
                        diametersDdl.trigger('change', [
                            {
                                clearforwarddata: 0
                            }
                        ]);
                    }
                }
                if (loadRatingsDdl && source === 'diameter' && currentAttributeSelected.position <= 4) {
                    let newLoadIndexesSource = new kendo.data.DataSource({
                        data: data.loadIndexes
                    });
                    loadRatingsDdl.setDataSource(newLoadIndexesSource);
                    loadRatingsDdl.value(currentPositionConfiguration.loadindex.value);
                    if (loadRatingsDdl.value().length > 0 && currentAttributeSelected.position === 3 && !isback) {
                        container.find('span[id$="slideTyreDropDownRight"]').addClass('rightmove');
                        loadRatingsDdl.trigger('change', [
                            {
                                clearforwarddata: 0
                            }
                        ]);
                    }
                }
                if (speedRatiosDdl && source === 'loadindex' && currentAttributeSelected.position <= 5) {
                    let newSpeedsSource = new kendo.data.DataSource({
                        data: data.speeds
                    });
                    speedRatiosDdl.setDataSource(newSpeedsSource);
                    speedRatiosDdl.value(currentPositionConfiguration.speed.value);
                    if (speedRatiosDdl.value().length > 0 && currentAttributeSelected.position === 4 && !isback) {
                        container.find('span[id$="slideTyreDropDownRight"]').addClass('rightmove');
                        speedRatiosDdl.trigger('change', [
                            {
                                clearforwarddata: 0
                            }
                        ]);
                    }
                }
                if (constructionsDdl && source === 'speed' && currentAttributeSelected.position <= 6) {
                    let newConstructionsSource = new kendo.data.DataSource({
                        data: data.constructions
                    });
                    constructionsDdl.setDataSource(newConstructionsSource);
                    constructionsDdl.value(currentPositionConfiguration.construction.value);
                    if (constructionsDdl.value().length > 0 && currentAttributeSelected.position === 5 && !isback) {
                        container.find('span[id$="slideTyreDropDownRight"]').addClass('rightmove');
                        constructionsDdl.trigger('change', [
                            {
                                clearforwarddata: 0
                            }
                        ]);
                    }
                }
            }
            result.resolve(data);
        });
        return result.promise();
    }
    GetTyreConfigurationAttributes(criteria) {
        let result = $.Deferred();
        $.ajax({
            url: '/tyres/gettyreconfigurationattributes',
            type: 'GET',
            cache: false,
            data: criteria,
            success: function(data) {
                result.resolve(data);
            },
            error: function(xhr, ajaxOptions, thrownError) {},
            complete: function() {}
        });
        return result.promise();
    }
    GetContainer(event) {
        if (event !== undefined && event.sender !== undefined) return $(event.sender.element).parents('.detailcontainer');
        else return this.currentSection.dom;
    }
    CheckIfSelectionCompleted(event) {
        let _this = this;
        $('.nextButton').hide();
        if (_this.ConfigurationIsValid(event)) {
            $('.nextButton').show();
            let $container = _this.GetContainer(event);
            if ($container) {
                $container.find('span[id$="slideTyreDropDownLeft"]').addClass('leftmove');
                $container.find('#tyreConfigurationInvalidWarning').hide();
            }
        }
    }
    ShowHideSelectedWheels(navigatingForward) {
        let _this = this;
        if ((0, $6d0ce8ba0314f583$export$e753aa4e59dfd0d5)._wheelPlan) {
            let position = this.currentSection.name.toUpperCase();
            let sectionId = this.currentSection.dom.prop('id');
            let section = this.currentSection.dom;
            let plan = (0, $6d0ce8ba0314f583$export$e753aa4e59dfd0d5)._wheelPlan[this.currentSection.name.toUpperCase()];
            _this.plan = plan;
            _this.ShowTyreDetailSection('ALLTYRES', sectionId, navigatingForward);
        }
    }
    async GetWidthDataSource() {
        let criteria = {
            Width: 0,
            Profile: "",
            Rim: "",
            LoadIndex: "",
            Speed: "",
            Construction: "",
            IncludeDefaultOption: false
        };
        let tyreConfigurationAttributes = await this.GetTyreConfigurationAttributes(criteria);
        return tyreConfigurationAttributes.widths;
    }
    BindTyreDetails(htmlTemplate, currentPosition) {
        let _this = this;
        let container = $(`#tyreSection_TYRES`);
        let widthsDdl = $(container).find(`#ALLTYRES_Width`);
        let ratiosDdl = $(container).find(`#ALLTYRES_Ratio`);
        let diametersDdl = $(container).find(`#ALLTYRES_Diameter`);
        let loadRatingsDdl = $(container).find(`#ALLTYRES_LoadRating`);
        let speedRatiosDdl = $(container).find(`#ALLTYRES_SpeedRating`);
        let constructionsDdl = $(container).find(`#ALLTYRES_Construction`);
        // TODO as were calling this function for multiple tyres (now against the same slide) - each time called, kendo add spans to the dom - it doesn't clean them up though!
        // kendo nesting dom elements over n over
        // this really needs modifying so the kendo elements are created and then the data source is changed for different tyres.
        // for now the below :(
        if (widthsDdl.data("kendoAutoComplete")) {
            kendo.destroy($(`#ALLTYRES_carouselTyresDropDownLists`)[0]);
            // get the controls container, move control to parent of that, remove the controls initial container. ffs.
            let container = widthsDdl.parent();
            container.parent().append(widthsDdl);
            container.remove();
            container = ratiosDdl.parent();
            container.parent().append(ratiosDdl);
            container.remove();
            container = diametersDdl.parent();
            container.parent().append(diametersDdl);
            container.remove();
            container = loadRatingsDdl.parent();
            container.parent().append(loadRatingsDdl);
            container.remove();
            container = speedRatiosDdl.parent();
            container.parent().append(speedRatiosDdl);
            container.remove();
            container = constructionsDdl.parent();
            container.parent().append(constructionsDdl);
            container.remove();
        }
        $.when(_this.GetWidthDataSource()).done(function(data) {
            let currentConfiguration = _this.tyreAttributes.find((attr)=>attr.name === currentPosition).configuration;
            $(htmlTemplate).find('.tyreDetailWidth').kendoAutoComplete({
                dataSource: data,
                dataTextField: 'name',
                dataValueField: 'value',
                change: function(args) {
                    $('.nextButton').hide();
                    (0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).nextIndex = 1;
                    var found = false;
                    var value = this.value();
                    var data = this.dataSource.view();
                    for(var idx = 0, length = data.length; idx < length; idx++)if (data[idx].value === value) {
                        found = true;
                        break;
                    }
                    // Only allow values in the dataSource list
                    if (!found) {
                        this.value("");
                        $(`#${currentPosition}_slideTyreDropDownRight`).css('display', 'none');
                        currentConfiguration.width.value = '';
                    } else {
                        let $this = $(args.sender.element);
                        $this.parents('.detailcontainer').find('.card-footer').html('<span class="width_label">225</span>/<span class="profile_label">55</span> R<span class="diameter_label">16</span> <span class="load_label">91</span><span class="speed_label">V</span> <span class="construction_label">RFLT</span>');
                        let $container = $this.parents('.detailcontainer');
                        let labelClass = '.' + $this.data('label');
                        let $displaySpan = $container.find(labelClass);
                        let currentValue = $this.val();
                        // reset any items already selected
                        Object.keys(currentConfiguration).forEach((prop)=>currentConfiguration[prop].selected !== undefined && (currentConfiguration[prop].selected = false));
                        // set the current item selected, new value.
                        currentConfiguration.width.selected = true;
                        currentConfiguration.width.value = currentValue;
                        if (currentValue !== undefined && currentValue !== '') {
                            $displaySpan.text(currentValue);
                            $displaySpan.addClass('font-weight-bold').addClass('text-info');
                            //$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'block').addClass('rightmove');
                            $(`#ALLTYRES_slideTyreDropDownRight`).trigger('click');
                        }
                    }
                    // always reset forward positions by default
                    // args passed to disable reset if user went back and forward without changing values.
                    if (args[0] === undefined || args[0]['clearforwarddata'] === 1) _this.ResetForwardPositionData(currentConfiguration, 'width');
                    _this.RefreshTyreConfigurationAttributes(currentPosition, 'speed', null, false);
                    _this.RefreshTyreConfigurationAttributes(currentPosition, 'loadindex', null, false);
                    _this.RefreshTyreConfigurationAttributes(currentPosition, 'diameter', null, false);
                    _this.RefreshTyreConfigurationAttributes(currentPosition, 'profile', null, false);
                    _this.RefreshTyreConfigurationAttributes(currentPosition, 'width', null, false);
                    _this.SetTyreVisual(currentConfiguration, 0, currentPosition);
                },
                placeholder: 'Width'
            });
            _this.tyreLoading = false;
        });
        $(htmlTemplate).find('.tyreDetailRatio').kendoDropDownList({
            dataSource: [],
            dataTextField: 'name',
            dataValueField: 'value',
            change: async function(args) {
                $('.nextButton').hide();
                (0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).nextIndex = 2;
                let currentConfiguration = _this.tyreAttributes.find((attr)=>attr.name === currentPosition).configuration;
                Object.keys(currentConfiguration).forEach((prop)=>currentConfiguration[prop].selected !== undefined && (currentConfiguration[prop].selected = false));
                currentConfiguration.profile.selected = true;
                currentConfiguration.profile.value = args.sender.element[0].value;
                if (args[0] === undefined || args[0]['clearforwarddata'] === 1) _this.ResetForwardPositionData(currentConfiguration, 'profile');
                if (currentConfiguration.profile.value !== '') //$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'block').addClass('rightmove');
                $(`#ALLTYRES_slideTyreDropDownRight`).trigger('click');
                else $(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'none');
                _this.RefreshTyreConfigurationAttributes(currentPosition, 'speed', null, false);
                _this.RefreshTyreConfigurationAttributes(currentPosition, 'loadindex', null, false);
                _this.RefreshTyreConfigurationAttributes(currentPosition, 'diameter', null, false);
                _this.RefreshTyreConfigurationAttributes(currentPosition, 'profile', null, false);
                _this.SetTyreVisual(currentConfiguration, 1, _this.plan.Position);
            },
            optionLabel: 'Profile'
        });
        $(htmlTemplate).find('.tyreDetailDiameter').kendoDropDownList({
            dataSource: [],
            dataTextField: 'name',
            dataValueField: 'value',
            change: async function(args) {
                $('.nextButton').hide();
                (0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).nextIndex = 3;
                let currentConfiguration = _this.tyreAttributes.find((attr)=>attr.name === currentPosition).configuration;
                Object.keys(currentConfiguration).forEach((prop)=>currentConfiguration[prop].selected !== undefined && (currentConfiguration[prop].selected = false));
                currentConfiguration.diameter.selected = true;
                currentConfiguration.diameter.value = args.sender.element[0].value;
                if (args[0] === undefined || args[0]['clearforwarddata'] === 1) _this.ResetForwardPositionData(currentConfiguration, 'diameter');
                if (currentConfiguration.diameter.value !== '') //$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'block').addClass('rightmove');
                $(`#ALLTYRES_slideTyreDropDownRight`).trigger('click');
                else $(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'none');
                _this.RefreshTyreConfigurationAttributes(currentPosition, 'speed', null, false);
                _this.RefreshTyreConfigurationAttributes(currentPosition, 'loadindex', null, false);
                _this.RefreshTyreConfigurationAttributes(currentPosition, 'diameter', null, false);
                _this.SetTyreVisual(currentConfiguration, 2, _this.plan.Position);
            },
            optionLabel: 'Diameter'
        });
        $(htmlTemplate).find('.tyreDetailLoad').kendoDropDownList({
            dataSource: [],
            dataTextField: 'name',
            dataValueField: 'value',
            change: async function(args) {
                $('.nextButton').hide();
                (0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).nextIndex = 4;
                let currentConfiguration = _this.tyreAttributes.find((attr)=>attr.name === currentPosition).configuration;
                Object.keys(currentConfiguration).forEach((prop)=>currentConfiguration[prop].selected !== undefined && (currentConfiguration[prop].selected = false));
                currentConfiguration.loadindex.selected = true;
                currentConfiguration.loadindex.value = args.sender.element[0].value;
                if (args[0] === undefined || args[0]['clearforwarddata'] === 1) _this.ResetForwardPositionData(currentConfiguration, 'loadindex');
                if (currentConfiguration.loadindex.value !== '') //$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'block').addClass('rightmove');
                $(`#ALLTYRES_slideTyreDropDownRight`).trigger('click');
                else $(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'none');
                _this.RefreshTyreConfigurationAttributes(currentPosition, 'speed', null, false);
                _this.RefreshTyreConfigurationAttributes(currentPosition, 'loadindex', null, false);
                _this.SetTyreVisual(currentConfiguration, 3, _this.plan.Position);
            },
            optionLabel: 'Load'
        });
        $(htmlTemplate).find('.tyreDetailSpeed').kendoDropDownList({
            dataSource: [],
            dataTextField: 'name',
            dataValueField: 'value',
            change: async function(args) {
                $('.nextButton').hide();
                (0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).nextIndex = 5;
                let currentConfiguration = _this.tyreAttributes.find((attr)=>attr.name === currentPosition).configuration;
                Object.keys(currentConfiguration).forEach((prop)=>currentConfiguration[prop].selected !== undefined && (currentConfiguration[prop].selected = false));
                currentConfiguration.speed.selected = true;
                currentConfiguration.speed.value = args.sender.element[0].value;
                if (args[0] === undefined || args[0]['clearforwarddata'] === 1) _this.ResetForwardPositionData(currentConfiguration, 'speed');
                if (currentConfiguration.speed.value !== '') //$(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'block').addClass('rightmove');
                $(`#ALLTYRES_slideTyreDropDownRight`).trigger('click');
                else $(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'none');
                _this.RefreshTyreConfigurationAttributes(currentPosition, 'speed', null, false);
                _this.SetTyreVisual(currentConfiguration, 4, _this.plan.Position);
            },
            optionLabel: 'Speed'
        });
        $(htmlTemplate).find('.tyreDetailConstruction').kendoDropDownList({
            dataSource: [],
            dataTextField: 'name',
            dataValueField: 'value',
            change: async function(args) {
                $('.nextButton').hide();
                (0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).nextIndex = 6;
                let value = args.sender.element[0].value;
                let currentConfiguration = _this.tyreAttributes.find((attr)=>attr.name === currentPosition).configuration;
                Object.keys(currentConfiguration).forEach((prop)=>currentConfiguration[prop].selected !== undefined && (currentConfiguration[prop].selected = false));
                currentConfiguration.construction.selected = true;
                currentConfiguration.construction.value = value;
                if (args[0] === undefined || args[0]['clearforwarddata'] === 1) _this.ResetForwardPositionData(currentConfiguration, 'construction');
                //We will have a value for diameter
                var allFieldsValid = currentConfiguration.profile.value != "" && currentConfiguration.diameter.value != "" && currentConfiguration.loadindex.value != "" && currentConfiguration.speed.value != "";
                if (!allFieldsValid) return;
                if (value.length > 0) {
                    $(`#ALLTYRES_DetailContainer1 .axle-details[data-axle*='${_this.axle}']`).addClass('d-none');
                    // final section - set complete
                    currentConfiguration.complete = true;
                    $('#ALLTYRES_DetailContainer1').find('.tyre-edit').addClass('d-lg-none');
                    let newDataRow = `<tr><td colspan="8" class="text-dark">You have updated your ${_this.axle} tyre information as follows:</td></tr><tr>
											<td class="tyre-done-highlight">${currentPosition}</td>
											<td class="tyre-done-highlight">${currentConfiguration.width.value}</td>
											<td class="tyre-done-highlight">${currentConfiguration.profile.value}</td>
											<td class="tyre-done-highlight">${currentConfiguration.diameter.value}</td>
											<td class="tyre-done-highlight">${currentConfiguration.speed.value}</td>
											<td class="tyre-done-highlight">${currentConfiguration.loadindex.value}</td>
											<td class="tyre-done-highlight">${currentConfiguration.construction.value}</td>
											<td class="text-right tyre-done-highlight">
												<div class="reject-tyre-data btn btn-outline-info text-dark font-weight-bold btn-amend" data-axle="${_this.axle}" data-position="${currentPosition}">Amend</div>
											</td>
										  <tr>`;
                    let $editButton = $(`#ALLTYRES_DetailContainer1 .tyre-history-data table td .edit-history[data-axle*='${_this.axle}']`);
                    if ($editButton.length > 0) {
                        $editButton.closest('tr').find('td').each(function() {
                            $(this).removeClass('bg-highlight').removeClass('tyre-done-highlight');
                        });
                        $editButton.closest('tr').find('td:last .btn').css('display', 'none');
                        $editButton.closest('table').find('tr:last').after(newDataRow);
                    } else {
                        $editButton = $(`#ALLTYRES_DetailContainer1 .edit-history[data-axle='${_this.axle}']`);
                        $editButton.before(`<table>${newDataRow}</table>`);
                        $editButton.css('display', 'none');
                    }
                    $(`#ALLTYRES_DetailContainer1`).find('.reject-tyre-data').unbind('click').on('click', function(event) {
                        let row = $(this).closest('tr');
                        let btns = row.parent().find('.btn');
                        if (btns.length > 1) {
                            row.parent().find('.btn').each(function() {
                                $(this).css('display', 'inline-block');
                            });
                            row.prev('tr').remove();
                            row.remove();
                        } else {
                            row = $(this).closest('table');
                            row.parent().find('.edit-history').css('display', 'inline-block');
                            row.remove();
                        }
                        let anyAxleConfig;
                        _this.axle = $(this).data('axle');
                        $(`#ALLTYRES_DetailContainer1 .axle-details[data-axle*='${_this.axle}']`).removeClass('d-none');
                        $('#ALLTYRES_slideTyreDropDownLeft, #ALLTYRES_slideTyreDropDownRight').css('display', 'none');
                        if (_this.axle === 'SPARE') anyAxleConfig = _this.tyreAttributes.filter((attr)=>attr.name === _this.axle);
                        else anyAxleConfig = _this.tyreAttributes.filter((attr)=>attr.name.substring(2, 3) === _this.axle.substring(0, 1));
                        if (anyAxleConfig.length > 0) {
                            Object.values(anyAxleConfig[0].configuration).forEach((attr)=>{
                                if (attr.value) attr.value = '';
                            });
                            anyAxleConfig[0].configuration.complete = false;
                        }
                    });
                    // apply this config to any other selected on the same axle.
                    let axleConfigurations = _this.tyreAttributes.filter((attr)=>attr.name.substring(2, 3) === currentPosition.substring(2, 3) && attr.name !== currentPosition);
                    axleConfigurations.forEach((tyre)=>{
                        tyre.configuration = currentConfiguration;
                        tyre.complete = true;
                    });
                }
                $(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'none');
                _this.SetTyreVisual(currentConfiguration, 5, _this.plan.Position);
                _this.CheckIfSelectionCompleted(args);
            },
            optionLabel: 'Construction'
        });
        $('span[id$="slideTyreDropDownRight"]').closest('div').unbind('click').on('click', async function(event) {
            let $this = $(event.target);
            let $container = $this.parents('.detailcontainer');
            let $carousel = $container.find('.carousel');
            let currentConfiguration = _this.tyreAttributes.find((attr)=>attr.name === currentPosition).configuration;
            let currentAttributeSelected = Object.values(currentConfiguration).find((attr)=>attr.selected === true);
            !currentAttributeSelected && (currentAttributeSelected = currentConfiguration.width);
            !currentAttributeSelected.selected && (currentAttributeSelected.selected = true);
            if (currentAttributeSelected.value === '') return false;
            (0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).ValidateElements($carousel, 'next');
            //$(`#ALLTYRES_slideTyreDropDownLeft`).css('display', 'block').addClass('leftmove');
            $(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'none').removeClass('rightmove');
            await _this.RefreshTyreConfigurationAttributes(currentPosition, currentAttributeSelected.name, $this, false);
            $container.find('.carousel').carousel('next').carousel('pause');
        });
        $('span[id$="slideTyreDropDownLeft"]').unbind('click').on('click', async function(event) {
            let $this = $(event.target);
            let $container = $this.parents('.detailcontainer');
            let $carousel = $container.find('.carousel');
            let currentConfiguration = _this.tyreAttributes.find((attr)=>attr.name === currentPosition).configuration;
            (0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).ValidateElements($carousel, 'prev');
            (0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).nextIndex -= 1;
            $carousel.carousel('prev').carousel('pause');
            $(`#ALLTYRES_slideTyreDropDownRight`).css('display', 'block').addClass('rightmove');
            if ((0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).nextIndex === 0) $this.css('display', 'none');
            else $this.css('display', 'block');
            let indexOfAttributeBeingSlidTo = (0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).nextIndex;
            if (indexOfAttributeBeingSlidTo >= 0) {
                let attributeBeingSlidTo = Object.values(currentConfiguration).find((attr)=>attr.position === indexOfAttributeBeingSlidTo + 1);
                // set previous attribute as current one
                Object.keys(currentConfiguration).forEach((prop)=>currentConfiguration[prop].selected !== undefined && (currentConfiguration[prop].selected = false));
                if (attributeBeingSlidTo != null) {
                    attributeBeingSlidTo.selected = true;
                    await _this.RefreshTyreConfigurationAttributes(currentPosition, attributeBeingSlidTo.name, $this, true);
                    // make the text un-highlight as user goes back - uses user values if set
                    _this.SetTyreVisual(currentConfiguration, indexOfAttributeBeingSlidTo, _this.plan.Position);
                }
            }
        });
        if ((0, $a854c42000216589$export$bd25e24024963319).wheelsSelected.length > 0) $((0, $a854c42000216589$export$bd25e24024963319).wheelsSelected).each(function(index, tyreSelected) {
            if (tyreSelected.Position !== currentPosition) {
                $(htmlTemplate).find('.applyCurrentSelectionContainer .col').append('<div class="form-check form-check-inline"><input class="form-check-input" type="checkbox" id="' + tyreSelected.Position + '_duplicate")" value="' + tyreSelected.Position + '">' + '<label class="form-check-label" for="' + tyreSelected.Position + '_duplicate")">' + tyreSelected.Name + '</label>' + '</div>');
                $('#' + tyreSelected.Position + '_duplicate').on('click', function(event) {
                // RemoveSection(tyreSelected.Position);
                });
            }
        });
    }
    SetupDefaultButtons(template) {
        $('#leaseplanSizeHint').hide();
        let _this = this;
        (0, $f90b7548d54d161a$export$86c665894cf791e).bindButtons();
        $(`#ALLTYRES_carouselTyresDropDownLists`).on('slid.bs.carousel', function(event) {
            let $currentContainer = $(this).parents('.detailcontainer');
            let labelName = $(event.relatedTarget).find('input').data('label');
            $currentContainer.find('.tyreLabelContainer span').removeClass('activelabel');
            $currentContainer.find('.' + labelName).addClass('activelabel');
        });
        $(`#ALLTYRES_DetailContainer1`).find('.edit-history').on('click', function(event) {
            let anyAxleConfig;
            if (!_this.tyreLoading) {
                _this.tyreLoading = true;
                _this.axle = $(this).data('axle');
                $('#ALLTYRES_slideTyreDropDownLeft, #ALLTYRES_slideTyreDropDownRight').css('display', 'none');
                if (_this.axle === 'SPARE') anyAxleConfig = _this.tyreAttributes.filter((attr)=>attr.name === _this.axle);
                else anyAxleConfig = _this.tyreAttributes.filter((attr)=>attr.name.substring(2, 3) === _this.axle.substring(0, 1));
                $(`#ALLTYRES_DetailContainer1`).find('#ALLTYRES_Width').val('');
                if (anyAxleConfig.length > 0) {
                    (0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).nextIndex = 1;
                    _this.BindTyreDetails(template, anyAxleConfig[0].name);
                    $(this).data('position') === '' && _this.GoToTyreVisualIndex(anyAxleConfig[0].configuration, 0);
                    $(`#ALLTYRES_DetailContainer1`).find('.tyre-edit').removeClass('d-lg-none');
                    if (subdomain == 'leaseplan') $('#leaseplanSizeHint').show();
                }
                if ($(this).data('position') !== '') $(this).closest('tr').find('td:lt(8)').removeClass('bg-highlight').addClass('tyre-done-highlight');
            }
        });
        $(`#ALLTYRES_DetailContainer1`).find('.load-history').on('click', function(event) {
            let currentConfiguration = _this.tyreAttributes.find((attr)=>attr.name.substring(2, 3) === $(this).data('position').substring(2, 3)).configuration;
            if (currentConfiguration && !_this.tyreLoading) {
                _this.tyreLoading = true;
                currentConfiguration.complete = true;
                $(this).closest('tr').find('td:lt(8)').removeClass('bg-highlight').addClass('tyre-done-highlight');
                $(`#ALLTYRES_DetailContainer1`).find('.tyre-edit').addClass('d-lg-none');
                $(`#ALLTYRES_slideTyreDropDownLeft`).css('display', 'none');
                let anyAxleConfig;
                _this.axle = $(this).data('axle');
                if (_this.axle === 'SPARE') anyAxleConfig = _this.tyreAttributes.filter((attr)=>attr.name === _this.axle);
                else anyAxleConfig = _this.tyreAttributes.filter((attr)=>attr.name.substring(2, 3) === _this.axle.substring(0, 1));
                if (anyAxleConfig.length > 0) {
                    (0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).nextIndex = 1;
                    _this.BindTyreDetails(template, anyAxleConfig[0].name);
                }
                _this.SetCurrentConfigToHistoricalData($(this).data('position'), $(this).data('axle'), true);
                _this.CheckIfSelectionCompleted(this);
            }
        });
    }
    UpdateTyreAttributes(position) {
        if (!this.tyreAttributes.find((attr)=>attr.name === position)) this.tyreAttributes.push({
            name: position,
            configuration: {
                width: new (0, $a854c42000216589$export$ffb7a2719c551bf4)('width', '', 1),
                profile: new (0, $a854c42000216589$export$ffb7a2719c551bf4)('profile', '', 2),
                diameter: new (0, $a854c42000216589$export$ffb7a2719c551bf4)('diameter', '', 3),
                loadindex: new (0, $a854c42000216589$export$ffb7a2719c551bf4)('loadindex', '', 4),
                speed: new (0, $a854c42000216589$export$ffb7a2719c551bf4)('speed', '', 5),
                construction: new (0, $a854c42000216589$export$ffb7a2719c551bf4)('construction', '', 6),
                brand: new (0, $a854c42000216589$export$ffb7a2719c551bf4)('brand', '', 7),
                complete: false
            }
        });
    }
    GetWheelPositionsForMultiSelect(currentPosition) {
        let positionArray = [];
        for(let property in (0, $6d0ce8ba0314f583$export$e753aa4e59dfd0d5)._wheelPlan)if ((0, $6d0ce8ba0314f583$export$e753aa4e59dfd0d5)._wheelPlan[property].Selected === 1 && (0, $6d0ce8ba0314f583$export$e753aa4e59dfd0d5)._wheelPlan[property].Position !== currentPosition) positionArray.push({
            positionMoniker: (0, $6d0ce8ba0314f583$export$e753aa4e59dfd0d5)._wheelPlan[property].Position,
            positionName: (0, $6d0ce8ba0314f583$export$e753aa4e59dfd0d5)._wheelPlan[property].Name.replace('Side ', '')
        });
        return positionArray;
    }
    GetTyreDetails(position) {
        let tyreDetails = $.grep((0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreDetailLines, function(item) {
            return item.wheelSelected === position;
        });
        return tyreDetails ? tyreDetails[0] : null;
    }
    GetTyreText(currentConfiguration, index, position) {
        // Default text: 255/55 R16 91V RFLT - work out what text and what defaults to show plus extra chars, spacing - also return index for which chars to color.
        let textIndex = 0;
        let tyreText = '';
        let $container = $(`#tyreSection_TYRES`);
        // each section of the tyre text and associated default value if not set by user
        let tyrekey = [
            {
                key: 'width',
                df: '255'
            },
            {
                key: 'profile',
                df: '55'
            },
            {
                key: 'diameter',
                df: '16'
            },
            {
                key: 'loadindex',
                df: '91'
            },
            {
                key: 'speed',
                df: 'V'
            },
            {
                key: 'construction',
                df: 'RFLT'
            }
        ];
        for(let item in tyrekey){
            let doCountChars = false;
            let key = tyrekey[item].key;
            let currentValue = currentConfiguration[key].value;
            let $displaySpan = $container.find(`.tyreLabelContainer .${key}_label`);
            if (currentValue === undefined || currentValue === '') {
                currentValue = tyrekey[item].df;
                $displaySpan.removeClass('font-weight-bold').removeClass('text-info');
            } else {
                // we only want to count the chars if they were set by user
                doCountChars = true;
                $displaySpan.addClass('font-weight-bold').addClass('text-info');
            }
            // update the text box summary
            $displaySpan.text(currentValue);
            switch(key){
                case 'width':
                    currentValue += "/";
                    break;
                case 'profile':
                    currentValue += " ";
                    break;
                case 'diameter':
                    currentValue = "R" + currentValue + " ";
                    break;
                case 'speed':
                    currentValue += " ";
                    break;
            }
            if (doCountChars && item <= index) textIndex += currentValue.length;
            tyreText += currentValue.toString();
        }
        return [
            tyreText,
            textIndex
        ];
    }
    SetTyreVisual(currentConfiguration, index, position) {
        // set the text, styling, transforms to the tyre visual
        let tyreTextResult;
        //let highlight = 'var(--customer-color)';
        let highlight = '#fff';
        let wrapDiv = `#ALLTYRES_tyreVisual .tyre-wrap`;
        let transformDiv = `#ALLTYRES_tyreVisual .tyre-transform`;
        // reset any roation on the tyre
        $(`${transformDiv}`).css('--rotate', '0deg');
        if (index === 5) {
            //construction
            // get the text and counter indicating how many chars to color.
            tyreTextResult = this.GetTyreText(currentConfiguration, index, position);
            $(`${wrapDiv} h1`).text(tyreTextResult[0]);
            if ($(`${wrapDiv} h1`).text().length > 18) {
                // plus 6 degrees = 1 char
                let rotation = currentConfiguration.construction.value.length * 6;
                $(`${transformDiv}`).css('--rotate', `-${rotation}deg`);
            }
            $(`${wrapDiv} h1`).lettering();
            $(`${wrapDiv}`).each(function() {
                $(this).find('h1 span').slice(0, tyreTextResult[1]).css('color', highlight);
            });
        } else {
            // width,profile,diameter,loadindex,speed
            // get the text and counter indicating how many chars to color.
            tyreTextResult = this.GetTyreText(currentConfiguration, index, position);
            $(`${wrapDiv} h1`).text(tyreTextResult[0]);
            $(`${wrapDiv} h1`).lettering();
            if (tyreTextResult[1] > 0) $(`${wrapDiv}`).each(function() {
                $(this).find('h1 span').slice(0, tyreTextResult[1]).css('color', highlight);
            });
            else $(`${wrapDiv} h1 span`).addClass('rubber');
        }
    }
    // --------------------------------------------------
    // PUBLIC FUNCTIONS
    // --------------------------------------------------
    Initialise(sectionName, sectionDom, disableSection, enableSection, navigatingForward) {
        (0, $69c3cf5eb45c3c99$export$2e2bcd8739ae039).nextIndex = 0;
        this.currentSection = {
            name: sectionName,
            dom: sectionDom
        };
        let changeOccured = false;
        if (navigatingForward) {
            // init all selected tyre on wheel plan if not already init
            Object.values((0, $6d0ce8ba0314f583$export$e753aa4e59dfd0d5)._wheelPlan).filter((attr)=>attr.Selected).forEach((wheel)=>{
                let foundConfig = this.tyreAttributes.find((attr)=>attr.name === wheel.Position);
                if (!foundConfig) {
                    this.UpdateTyreAttributes(wheel.Position);
                    changeOccured = true;
                }
            });
            // remove any configs not on wheel plan
            for(var i = 0; i < this.tyreAttributes.length; i++){
                let foundConfig = (0, $6d0ce8ba0314f583$export$e753aa4e59dfd0d5)._wheelPlan[this.tyreAttributes[i].name];
                if (foundConfig.Selected === 0) {
                    this.tyreAttributes.splice(i, 1);
                    changeOccured = true;
                }
            }
        }
        // user went back but didn't change anything
        if (changeOccured === false) navigatingForward = false;
        this.ShowHideSelectedWheels(navigatingForward);
    }
    ConfigurationIsValid() {
        let _this = this;
        let isValid = _this.tyreAttributes.filter((attr)=>attr.configuration.complete === true).length === _this.tyreAttributes.length;
        return isValid;
    }
    Save() {
        let currentConfigurations = this.tyreAttributes.filter((attr)=>attr.configuration.complete === true);
        let tyreLines = [];
        currentConfigurations.forEach((tyre)=>{
            let tyreDetailLineModel = new (0, $a854c42000216589$export$ab51f1f03e871453)();
            let selectedWheelPosition = tyre.name;
            let currentConfiguration = tyre.configuration;
            let editTyreDetailLineModel = Object.values((0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreDetailLines).find((attr)=>attr.wheelSelected === selectedWheelPosition);
            tyreDetailLineModel.wheelSelected = selectedWheelPosition;
            tyreDetailLineModel.title = tyre.name;
            tyreDetailLineModel.width = currentConfiguration.width.value;
            tyreDetailLineModel.ratio = currentConfiguration.profile.value;
            tyreDetailLineModel.diameter = currentConfiguration.diameter.value;
            tyreDetailLineModel.rating = currentConfiguration.speed.value;
            tyreDetailLineModel.load = currentConfiguration.loadindex.value;
            tyreDetailLineModel.construction = currentConfiguration.construction.value;
            tyreDetailLineModel.brand = currentConfiguration.brand.value;
            tyreLines.push(tyreDetailLineModel);
        });
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreDetailLines = tyreLines;
    }
    GetValidator(position) {
        const $panel = this.currentSection.dom;
        return $panel.kendoValidator({
            rules: {
            },
            messages: {
                damageIssueField: 'Damage/Issue field is mandatory'
            }
        }).data('kendoValidator');
    }
}
let $580dee653a8183ea$export$3a3ed1ce81759dd4 = new $580dee653a8183ea$var$TyreDetails();





jQuery.fn.extend({
    enableButton: function() {
        return this.each(function() {
            this.disabled = false;
            this.style.cursor = 'pointer';
            this.classList.remove('disabled');
        });
    },
    disableButton: function() {
        return this.each(function() {
            this.disabled = true;
            this.style.cursor = 'not-allowed';
            this.classList.add('disabled');
        });
    },
    ActivateTabButton: function() {
        return this.each(function() {
            this.classList.remove('btn-secondary');
            this.classList.add('btn-success');
            var currentNodeId = this.id;
            var dataParentValue = this.dataset.tabparent;
            var dataSelector = '[data-tabparent]';
            var siblings = Array.from(document.querySelectorAll(dataSelector)).filter((node)=>node.dataset.tabparent === dataParentValue && node.id !== currentNodeId);
            if (!siblings) return;
            siblings.forEach((node)=>{
                if (!node) return;
                node.classList.remove('btn-success');
                node.classList.add('btn-secondary');
            });
        });
    }
});


class $221458b3c6d8ef58$export$738b6de66bb25f8d {
    static bindControls() {
        if ((0, $254a84bc556d8bd3$export$366dc4c52172531e).IsMfs()) this.showLocationLabel(true);
        $('.nextButtonSlide').show();
        $('#showDepotGrid').on('click', (e)=>{
            $('#depotMapContainer').hide();
            $('#depotGridContainer').show();
            $('#showDepotGrid').ActivateTabButton();
            if (!(0, $a854c42000216589$export$bd25e24024963319).selectedDepot) return;
            let selectedDepotRadio = $(document).find('.k-grid:visible').find(`input:radio[id="${(0, $a854c42000216589$export$bd25e24024963319).selectedDepot.id}"]`);
            (0, $a854c42000216589$export$bd25e24024963319).selectedDepot && selectedDepotRadio.click();
        });
        $('#showDepotMap').on('click', ()=>{
            $('#depotGridContainer').hide();
            $('#depotMapContainer').show();
            $('#showDepotMap').ActivateTabButton();
        });
        $('input[name="ServiceRequired"]').on('change', ()=>{
            this.showLocationLabel();
        });
    }
    static showLocationLabel(isMobile = false) {
        var selectedOptionId = $("input[name='ServiceRequired']:checked").val();
        $('#mobileLocationLabel').hide();
        $('#depotLocationLabel').hide();
        if (selectedOptionId === 'D') $('#depotLocationLabel').show();
        else if (selectedOptionId === 'M' || isMobile) $('#mobileLocationLabel').show();
        $('#CalendarContainer').show();
    }
    static getAddressSlideValidator() {
        return $('#jobAddressSlide').kendoValidator().data('kendoValidator');
    }
    static getValidator() {
        return $('#jobLocationSection').kendoValidator().data('kendoValidator');
    }
    static getDepotValidator() {
        let validator = $('#grid').kendoValidator({
            rules: {
                depotMissing: function(input) {
                    if (input.is("[type=radio]") && input.attr("required")) return $("#grid").find("[name=depot-list]").is(":checked");
                    return true;
                }
            },
            messages: {
                depotMissing: 'Please select a depot'
            }
        }).data('kendoValidator');
        return validator;
    }
    static initialiseDepotList(moveNext) {
        var selectedDepotId = $("input[name='depot-list']:checked").val();
        const mobileServiceRequired = $("input[name='ServiceRequired']:checked").val() === 'M';
        if (mobileServiceRequired || (0, $254a84bc556d8bd3$export$366dc4c52172531e).DoNotAllowDepotSelection()) return moveNext();
        else {
            if (!selectedDepotId) $('.nextButtonSlide').hide();
            (0, $1ab168822f4abc32$export$9d1417450875059f).SetServiceType('T');
            (0, $1ab168822f4abc32$export$9d1417450875059f).SetCustomerId($("#CustomerCompanyId").val());
            (0, $1ab168822f4abc32$export$9d1417450875059f).GetPostcodeCoordinates();
        }
    }
    static saveJobLocation() {
        var locationType = 0;
        //This order is expected in Controller and Service-Api
        if ($("#LocationTypeWork").is(":checked")) locationType = 1;
        else if ($("#LocationTypeHome").is(":checked")) locationType = 2;
        let $jobLocationPanel = $('#jobLocationSection');
        (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.location = new (0, $a854c42000216589$export$f5004a899ec10a9)($jobLocationPanel.find('input[name="LocationType"]:checked').val(), $jobLocationPanel.find('input[id$="Address_AddressLine1"]').val(), $jobLocationPanel.find('input[id$="Address_AddressLine2"]').val(), $jobLocationPanel.find('input[id$="Address_Town"]').val(), $jobLocationPanel.find('input[id$="Address_County"]').val(), $jobLocationPanel.find('input[id$="Postcode"]').val());
        (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.addressType = locationType;
        let depotId = (0, $1ab168822f4abc32$export$9d1417450875059f).GetSelectedDepotId();
        let depots = (0, $1ab168822f4abc32$export$9d1417450875059f).GetDepots();
        (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.depot = $.grep(depots, function(e) {
            return e.id === depotId;
        })[0];
        (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.serviceRequired = $jobLocationPanel.find('input[name="ServiceRequired"]:checked').val();
        //try to set the job type
        if ((0, $254a84bc556d8bd3$export$366dc4c52172531e).IsChecked('ServiceRequiredSameDayMobile')) {
            (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.jobType = 16;
            (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.jobTypeName = 'Same Day Mobile';
        } else if ((0, $254a84bc556d8bd3$export$366dc4c52172531e).IsChecked('ServiceRequiredRapidResponse')) {
            (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.jobType = 12;
            (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.jobTypeName = 'Rapid Response';
        } else if ((0, $254a84bc556d8bd3$export$366dc4c52172531e).IsChecked('ServiceRequiredNextDayMobile')) {
            (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.jobType = 61;
            (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.jobTypeName = 'Next Day Mobile';
        }
    }
}



class $6d1a12d73f412bf4$var$TyresForm {
    constructor(){
        kendo.ui.progress($('body'), true);
        this.vehicleViewModel = null;
        this.navigationTexts = [
            'Vehicle Search',
            'Vehicle',
            'Tyre Selection',
            'Passenger Front',
            'Driver Front',
            'Passenger Rear',
            'Driver Rear',
            'Passenger Rear 2',
            'Driver Rear 2',
            'Tyre Selection Summary',
            'Wheel Details',
            'jobLocationNavigationText',
            'Booking',
            'Driver',
            'Summary',
            'Confirmation'
        ];
        this.navigatingForward = true;
        this.sections = {
            collection: [
                // searchDetail
                {
                    name: 'searchDetail',
                    index: 1,
                    dom: $('#searchDetails'),
                    type: 'section',
                    active: false,
                    disabled: false,
                    onOpen: ()=>{
                        gtag('event', 'entered', {
                            'event_category': 'section',
                            'event_label': '1: enter registration'
                        });
                    },
                    onExit: ()=>{}
                },
                // vehicleDetail
                {
                    name: 'vehicleDetail',
                    anchor: 'vehicleDetailsAnchor',
                    index: 2,
                    dom: $('#vehicleDetailsSection'),
                    type: 'section',
                    active: false,
                    disabled: false,
                    onOpen: ()=>{
                        $('.toast').toast();
                        $($('.mobile-breadcrumb-nav li')[0]).addClass('active');
                        $('#Mileage').focus();
                        this.bindButtons();
                        gtag('event', 'entered', {
                            'event_category': 'section',
                            'event_label': '2: vehicle detail'
                        });
                    },
                    onExit: ()=>{
                        (0, $1c69d9f7d2723de0$export$e760877cb454c9d4).SaveVehicleDetails();
                    },
                    validator: ()=>{
                        var mileageNotRequired = $('#mileageInput').is(':hidden');
                        if (mileageNotRequired) return null;
                        return (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).GetVehicleValidator();
                    }
                },
                // wheelPlan
                {
                    name: 'wheelPlan',
                    anchor: 'wheelPlanAnchor',
                    index: 3,
                    dom: $('#wheelPlanSection'),
                    type: 'section',
                    active: false,
                    disabled: false,
                    onOpen: ()=>{
                        let model = (0, $a854c42000216589$export$bd25e24024963319).vehicle;
                        if (!model._wheelPlan) (0, $6d0ce8ba0314f583$export$e753aa4e59dfd0d5).Initialise(this.sections.disable, this.sections.enable);
                        gtag('event', 'entered', {
                            'event_category': 'section',
                            'event_label': '3: wheel plan'
                        });
                    },
                    onExit: ()=>{},
                    validator: ()=>{
                        return (0, $6d0ce8ba0314f583$export$e753aa4e59dfd0d5).GetValidator();
                    }
                },
                // tyres
                {
                    name: 'tyres',
                    anchor: 'TYRESAnchor',
                    index: 4,
                    dom: $('#tyreSection_TYRES'),
                    type: 'section',
                    active: false,
                    disabled: false,
                    onOpen: ()=>{
                        (0, $580dee653a8183ea$export$3a3ed1ce81759dd4).Initialise('tyres', $('#tyreSection_TYRES'), this.sections.disable, this.sections.enable, this.navigatingForward);
                        gtag('event', 'entered', {
                            'event_category': 'section',
                            'event_label': '4: tyres'
                        });
                    },
                    onExit: ()=>{
                        (0, $580dee653a8183ea$export$3a3ed1ce81759dd4).Save();
                    },
                    validator: ()=>{
                        return (0, $580dee653a8183ea$export$3a3ed1ce81759dd4).GetValidator('tyres');
                    }
                },
                // tyreSummary
                {
                    name: 'tyreSummary',
                    anchor: 'tyreDetailsSummaryAnchor',
                    index: 5,
                    dom: $('#tyreDetailsSummarySection'),
                    type: 'section',
                    active: false,
                    disabled: false,
                    onOpen: ()=>{
                        gtag('event', 'entered', {
                            'event_category': 'section',
                            'event_label': '5: tyre summary'
                        });
                        (0, $5e7fa57200602e68$export$3d0653d9b1fe5763).displayTyresSelection(this.sections.show, this.navigatingForward);
                    },
                    validator: ()=>{
                        return (0, $5e7fa57200602e68$export$3d0653d9b1fe5763).GetValidator();
                    }
                },
                // wheelDetail
                {
                    name: 'wheelDetail',
                    anchor: 'wheelDetailsAnchor',
                    index: 6,
                    dom: $('#wheelDetailsSection'),
                    type: 'section',
                    active: false,
                    disabled: false,
                    onOpen: ()=>{
                        (0, $971800e8c852106e$export$f4684e08bac54ec3).initializePanel();
                        gtag('event', 'entered', {
                            'event_category': 'section',
                            'event_label': '6: wheel detail'
                        });
                    },
                    onExit: ()=>{
                        (0, $971800e8c852106e$export$f4684e08bac54ec3).saveWheelDetails();
                    // console.log(`data: ${JSON.stringify(_data)}`);
                    },
                    validator: ()=>{
                        return (0, $971800e8c852106e$export$f4684e08bac54ec3).getValidator();
                    }
                },
                // jobLocation
                {
                    name: 'jobLocation',
                    anchor: 'jobLocationAnchor',
                    index: 7,
                    dom: $('#jobLocationSection'),
                    type: 'section',
                    active: false,
                    disabled: false,
                    slides: [
                        {
                            name: 'jobAddress',
                            index: 1,
                            dom: $('#jobAddressSlide'),
                            type: 'slide',
                            active: false,
                            disable: false,
                            onOpen: ()=>{
                                (0, $221458b3c6d8ef58$export$738b6de66bb25f8d).bindControls();
                                gtag('event', 'entered', {
                                    'event_category': 'section',
                                    'event_label': '7: job location'
                                });
                            },
                            validator: ()=>{
                                return (0, $221458b3c6d8ef58$export$738b6de66bb25f8d).getAddressSlideValidator();
                            }
                        },
                        {
                            name: 'depotList',
                            index: 2,
                            dom: $('#depotsSlide'),
                            type: 'slide',
                            active: false,
                            disable: false,
                            onOpen: ()=>{
                                (0, $221458b3c6d8ef58$export$738b6de66bb25f8d).initialiseDepotList(this.sections.moveNext, this.move);
                                gtag('event', 'entered', {
                                    'event_category': 'section',
                                    'event_label': '8: depot list'
                                });
                            },
                            validator: ()=>{
                                return (0, $221458b3c6d8ef58$export$738b6de66bb25f8d).getDepotValidator();
                            }
                        }
                    ],
                    validator: ()=>{
                        return (0, $221458b3c6d8ef58$export$738b6de66bb25f8d).getValidator();
                    },
                    onExit: ()=>{
                        (0, $221458b3c6d8ef58$export$738b6de66bb25f8d).saveJobLocation();
                    }
                },
                // bookingDetail
                {
                    name: 'bookingDetail',
                    anchor: 'bookingDetailsAnchor',
                    index: 8,
                    dom: $('#bookingDetailsSection'),
                    type: 'section',
                    active: false,
                    disabled: false,
                    onOpen: ()=>{
                        (0, $5fd7e02679a61613$export$575f8a200748f96d).InitializePanel(this.sections.moveNext, this.sections.moveBack, this.navigatingForward);
                        gtag('event', 'entered', {
                            'event_category': 'section',
                            'event_label': '9: booking detail'
                        });
                    },
                    onExit: ()=>{
                        (0, $5fd7e02679a61613$export$575f8a200748f96d).SaveBookingDetails();
                    },
                    validator: ()=>{
                        return (0, $5fd7e02679a61613$export$575f8a200748f96d).GetValidator();
                    }
                },
                // driverDetail
                {
                    name: 'driverDetail',
                    anchor: 'driverDetailsAnchor',
                    index: 9,
                    dom: $('#driverDetailsSection'),
                    type: 'section',
                    active: false,
                    disabled: false,
                    slides: [
                        {
                            name: 'driverDetailForm',
                            index: 1,
                            dom: $('#driverDetailsSlide'),
                            type: 'slide',
                            active: false,
                            disable: false,
                            validator: (0, $9ac33b0fd47521c4$export$ca9d9c6ddb699dc1).getDriverDetailValidator
                        }
                    ],
                    onOpen: ()=>{
                        (0, $9ac33b0fd47521c4$export$ca9d9c6ddb699dc1).InitializePanel();
                        gtag('event', 'entered', {
                            'event_category': 'section',
                            'event_label': '10: driver detail'
                        });
                    },
                    onExit: ()=>{
                        (0, $9ac33b0fd47521c4$export$ca9d9c6ddb699dc1).SaveDriverDetails();
                    }
                },
                // summary
                {
                    name: 'summary',
                    anchor: 'summaryAnchor',
                    index: 10,
                    dom: $('#summarySection'),
                    type: 'section',
                    active: false,
                    disabled: false,
                    onOpen: ()=>{
                        // Uncomment to enable developer test
                        // console.log(JSON.stringify(_data));
                        // _data.initSelfDevObject(your json object);
                        this.buildSummary();
                        gtag('event', 'entered', {
                            'event_category': 'section',
                            'event_label': '11: final summary'
                        });
                    },
                    onExit: ()=>{}
                },
                // confirmation
                {
                    name: 'confirmation',
                    anchor: 'confirmationAnchor',
                    index: 11,
                    dom: $('#confirmationSection'),
                    type: 'section',
                    active: false,
                    disabled: false,
                    onOpen: ()=>{
                        this.buildConfirmation();
                        gtag('event', 'entered', {
                            'event_category': 'section',
                            'event_label': '12: confirmation'
                        });
                    },
                    onExit: ()=>{}
                }
            ],
            moveNext: ()=>{
                this.navigatingForward = true;
                const activeSection = this.sections.collection.find((section)=>section.active === true);
                const nextSectionsIndexList = this.sections.collection.filter((section)=>section.index > activeSection.index && section.disabled === false).map((section)=>section.index);
                const nextSectionIndex = nextSectionsIndexList.reduce(function(prev, curr) {
                    return Math.abs(curr - activeSection.index) < Math.abs(prev - activeSection.index) ? curr : prev;
                });
                const nextSection = this.sections.collection.find((section)=>section.index === nextSectionIndex);
                let proceed = activeSection.validator ? this.sections.validate(activeSection, activeSection.validator()) : true;
                $6d1a12d73f412bf4$var$removeDuplicateErrorMessages();
                if (proceed) {
                    (0, $254a84bc556d8bd3$export$366dc4c52172531e).incrementBreadCrumbs(activeSection, nextSection);
                    if (activeSection.name === 'summary') this.createJob();
                    else activeSection.onExit && activeSection.onExit();
                    this.sections.hide(activeSection.name);
                    this.sections.show(nextSection.name);
                }
            },
            moveBack: ()=>{
                this.navigatingForward = false;
                let activeSection = this.sections.collection.find((section)=>section.active === true);
                const prevSectionsIndexList = this.sections.collection.filter((section)=>section.index < activeSection.index && section.disabled === false).map((section)=>section.index);
                const prevSectionIndex = prevSectionsIndexList.reduce(function(prev, curr) {
                    return Math.abs(curr - activeSection.index) < Math.abs(prev - activeSection.index) ? curr : prev;
                });
                const previousSection = this.sections.collection.find((section)=>section.index === prevSectionIndex);
                this.sections.hide(activeSection.name);
                this.sections.show(previousSection.name);
                if ($('.nextButton').is(":hidden")) $('.nextButton').show();
            },
            moveTo: (sectionAnchor)=>{
                let activeSection = this.sections.collection.find((section)=>section.active === true);
                let targetDestinationSection = this.sections.collection.find((section)=>section.anchor === sectionAnchor);
                this.sections.hide(activeSection.name);
                this.sections.show(targetDestinationSection.name);
            },
            show: (sectionName)=>{
                let selectedSection = this.sections.collection.find((section)=>section.name === sectionName);
                this.sections.collection.forEach((section)=>{
                    this.sections.hide(section.name);
                });
                selectedSection.active = true;
                //Hack to sort of navigation of slides, this assumes slides are in accending order
                if (selectedSection.slides) {
                    var slideNumber = this.navigatingForward ? 0 : selectedSection.slides.length - 1;
                    //Bad hack to deal with skipping of page
                    if (!this.navigatingForward) {
                        if (selectedSection.name == 'jobLocation' && ((0, $254a84bc556d8bd3$export$366dc4c52172531e).DoNotAllowDepotSelection() || (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.serviceRequired == 'M')) slideNumber = 0;
                    }
                    if (slideNumber < 0) slideNumber = 0;
                    selectedSection.slides && this.sections.showSlide(selectedSection.slides[slideNumber].name);
                }
                selectedSection.dom.show();
                selectedSection.onOpen && selectedSection.onOpen();
            },
            hide: (sectionName)=>{
                let selectedSection = this.sections.collection.find((section)=>section.name === sectionName);
                selectedSection.dom.hide();
                selectedSection.active = false;
            },
            slideRight: ()=>{
                let currentSection = this.sections.collection.find((section)=>section.active === true);
                let currentActiveSlide = currentSection.slides.find((slide)=>slide.active === true);
                let nextSlide = currentSection.slides.find((slide)=>slide.index === currentActiveSlide.index + 1);
                let proceed = currentActiveSlide.validator ? this.sections.validate(currentSection, currentActiveSlide.validator()) : true;
                if (proceed) {
                    this.sections.hideSlide(currentActiveSlide.name);
                    if (nextSlide) this.sections.showSlide(nextSlide.name);
                    else this.sections.moveNext();
                    currentActiveSlide.onExit && currentActiveSlide.onExit();
                }
            },
            slideLeft: ()=>{
                let currentSection = this.sections.collection.find((section)=>section.active === true);
                let currentActiveSlide = currentSection.slides.find((slide)=>slide.active === true);
                let prevSlide = currentSection.slides.find((slide)=>slide.index === currentActiveSlide.index - 1);
                if (!prevSlide) this.sections.moveBack();
                else {
                    this.sections.hideSlide(currentActiveSlide.name);
                    this.sections.showSlide(prevSlide.name);
                    currentActiveSlide.onExit && currentActiveSlide.onExit();
                }
            },
            showSlide: (slideName)=>{
                let currentSection = this.sections.collection.find((section)=>section.active === true);
                let selectedSlide = currentSection.slides.find((slide)=>slide.name === slideName);
                currentSection.slides.forEach((slide)=>{
                    this.sections.hideSlide(slide.name);
                });
                selectedSlide.dom.show();
                selectedSlide.active = true;
                selectedSlide.onOpen && selectedSlide.onOpen();
            },
            hideSlide: (slideName)=>{
                let currentSection = this.sections.collection.find((section)=>section.active === true);
                let selectedSlide = currentSection.slides.find((slide)=>slide.name === slideName);
                selectedSlide.dom.hide();
                selectedSlide.active = false;
            },
            validate: (currentSection, validator)=>{
                const containerId = currentSection.dom.prop('id');
                const isTyreDetailsSection = containerId.startsWith('tyreSection_');
                const section = currentSection.dom;
                // Validate section
                let validated = true;
                if (validator !== null) {
                    (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).BindValidationStyles(validator);
                    // Check if section is valid. Tyre details sections have a default
                    // Kendo validator and a custom validation function
                    if (isTyreDetailsSection) {
                        if (!(0, $580dee653a8183ea$export$3a3ed1ce81759dd4).ConfigurationIsValid()) {
                            section.find('#tyreConfigurationInvalidWarning').show();
                            validator.validate();
                            validated = false;
                        } else {
                            section.find('#tyreConfigurationInvalidWarning').hide();
                            validated = validator.validate();
                        }
                    } else if (containerId == "jobLocationSection") {
                        var kendoValid = validator.validate();
                        var validLocation = $("#LocationTypeWork").is(":checked") || $("#LocationTypeHome").is(":checked") || $("#LocationTypeTemp").is(":checked");
                        var validJobType = (0, $254a84bc556d8bd3$export$366dc4c52172531e).IsChecked('ServiceRequiredSameDayMobile') || (0, $254a84bc556d8bd3$export$366dc4c52172531e).IsChecked('ServiceRequiredRapidResponse') || (0, $254a84bc556d8bd3$export$366dc4c52172531e).IsChecked('ServiceRequiredNextDayMobile') || (0, $254a84bc556d8bd3$export$366dc4c52172531e).IsChecked('ServiceRequiredDepot') || (0, $254a84bc556d8bd3$export$366dc4c52172531e).IsChecked('ServiceRequiredMobile');
                        if (validLocation) {
                            $("#locationTypeError").removeClass("d-block");
                            $("#locationTypeError").addClass("d-none");
                        } else {
                            $("#locationTypeError").removeClass("d-none");
                            $("#locationTypeError").addClass("d-block");
                        }
                        if (validJobType) {
                            $("#JobTypeError").removeClass("d-block");
                            $("#JobTypeError").addClass("d-none");
                        } else {
                            $("#JobTypeError").removeClass("d-none");
                            $("#JobTypeError").addClass("d-block");
                        }
                        var validPostcode = $6d1a12d73f412bf4$var$isValidPostcode($('#jobPostcode').val());
                        if (validPostcode) {
                            $("#PostcodeError").removeClass("d-block");
                            $("#PostcodeError").addClass("d-none");
                        } else {
                            $("#PostcodeError").removeClass("d-none");
                            $("#PostcodeError").addClass("d-block");
                        }
                        validated = kendoValid && validLocation && validJobType && validPostcode;
                    } else validated = validator.validate();
                }
                return validated;
            },
            enable: (sectionName)=>{
                let section = this.sections.collection.find((section)=>section.name === sectionName);
                section.disabled = false;
            },
            disable: (sectionName)=>{
                let section = this.sections.collection.find((section)=>section.name === sectionName);
                section.disabled = true;
            }
        };
        this.disableMoveNext = true;
        this.initTyrePage();
    }
    initTyrePage() {
        let _this = this;
        _this.GetCustomerData();
        kendo.culture('en-GB');
        $('.section').hide();
        _this.sections.show('searchDetail');
        _this.bindFormControls();
        (0, $0f9b377c2aa86abc$export$f5c65d7eccbf77d4).BindControls();
        $('#depotMobileAltAddress').hide();
        //Make sure the next button is shown if turned off by an empty wheel configuration.
        _this.SetWheelPlans();
        $('#vehicle-search-input').focus();
    }
    GetCustomerData() {
        $.get("/tyres/CustomerLink", (data)=>{
            (0, $a854c42000216589$export$bd25e24024963319).customer = new (0, $a854c42000216589$export$3bd673aceb961187)(data.name, data.homeLink);
        });
    }
    SetWheelPlans() {
        //TODO: Revisit this logic.
        (0, $a854c42000216589$export$22dcfb8ced99b296).plans = [];
        var vehicleClasses = [
            "car",
            "lcv"
        ];
        vehicleClasses.forEach((_class)=>{
            let WheelPlans = [
                {
                    id: 1,
                    name: "Standard Car",
                    image: '4x2.svg'
                },
                {
                    id: 2,
                    name: "Twin Wheel Van",
                    image: '4x2twin.svg'
                },
                {
                    id: 21,
                    name: "Standard Van",
                    image: '4x2van.svg'
                }
            ];
            (0, $a854c42000216589$export$22dcfb8ced99b296).plans.push(new (0, $a854c42000216589$export$22dcfb8ced99b296)(_class, WheelPlans));
        });
    }
    bindButtons() {
        let _this = this;
        $('.nextButton').off();
        $('.nextButton').on('click', (_event)=>{
            _this.sections.moveNext();
        });
        $('.nextButtonSlide').off();
        $('.nextButtonSlide').on('click', (_event)=>{
            _this.sections.slideRight();
        });
        $('.backButton').off();
        $('.backButton').on('click', (_event)=>{
            _this.sections.moveBack();
            //TO DO: This is a temporary hack to fix a bug with the wheelplans.
            if ($(this).html() === "Not My Vehicle") location.reload(true);
        });
        $('.backButtonSlide').off();
        $('.backButtonSlide').on('click', (_event)=>{
            _this.sections.slideLeft();
        });
        $('input.submitOnEnter').on('keyup', function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                let btn = $(this).closest('.section').find('.btn-success').not(":hidden");
                btn.trigger('click');
            }
        });
    }
    buildSummary() {
        let _this = this;
        // Vehicle
        var summaryPanel = _this.sections.collection.find((section)=>section.name === 'summary').dom;
        summaryPanel.find('#vehicleRegistration').text((0, $a854c42000216589$export$bd25e24024963319).vehicle.vehicleDetails.vehicleReg);
        summaryPanel.find('#vehicleMake').text((0, $a854c42000216589$export$bd25e24024963319).vehicle.vehicleDetails.vehicleMake);
        summaryPanel.find('#vehicleModel').text((0, $a854c42000216589$export$bd25e24024963319).vehicle.vehicleDetails.vehicleModel);
        if ((0, $a854c42000216589$export$bd25e24024963319).vehicle.vehicleDetails.mileageCheckSuppression) summaryPanel.find('#vehicleMileage').parent().hide();
        else summaryPanel.find('#vehicleMileage').text((0, $a854c42000216589$export$bd25e24024963319).vehicle.vehicleDetails.vehicleMileage);
        // Driver
        var driverFullName = (0, $a854c42000216589$export$bd25e24024963319).driver.title;
        if ((0, $a854c42000216589$export$bd25e24024963319).driver.firstname) driverFullName += ' ' + (0, $a854c42000216589$export$bd25e24024963319).driver.firstname;
        driverFullName += ' ' + (0, $a854c42000216589$export$bd25e24024963319).driver.surname;
        summaryPanel.find('#driverName').text(driverFullName);
        summaryPanel.find('#driverMobile').text((0, $a854c42000216589$export$bd25e24024963319).driver.mobile);
        if ((0, $a854c42000216589$export$bd25e24024963319).driver.landline) {
            summaryPanel.find('#driverAlternativePhone').closest('.row').show();
            summaryPanel.find('#driverAlternativePhone').text((0, $a854c42000216589$export$bd25e24024963319).driver.landline);
        } else summaryPanel.find('#driverAlternativePhone').closest('.row').hide();
        summaryPanel.find('#driverEmail').text((0, $a854c42000216589$export$bd25e24024963319).driver.email);
        summaryPanel.find('#smsConfirmation').text((0, $a854c42000216589$export$bd25e24024963319).driver.smsConfirmation === true ? 'Yes' : 'No');
        // Work required
        // TODO: make all html below a mustache templates;
        summaryPanel.find('#workRequiredSummary').html('<div class="row border-bottom mb-2 mt-2 text-info pt-2 summary-row"><div class="col"><label>Tyre Details</label><a href="#" class="text-muted" data-section-anchor="wheelPlanAnchor"><i class="fas fa-edit ml-2" aria-hidden="true"></i></a></div></div>');
        // Swap lines to enable developer test
        let wheelPlan = (0, $6d0ce8ba0314f583$export$e753aa4e59dfd0d5)._wheelPlan;
        //let wheelPlan = { "NSF": { "Selected": 1, "Name": "Passenger Front", "Position": "NSF", "CheckedRadioListIds": [] }, "OSR": { "Selected": 0, "Name": "Driver Rear", "Position": "OSR", "CheckedRadioListIds": [] }, "NSR": { "Selected": 0, "Name": "Passenger Rear", "Position": "NSR", "CheckedRadioListIds": [] }, "OSF": { "Selected": 0, "Name": "Driver Front", "Position": "OSF", "CheckedRadioListIds": [] } };
        $('#workRequiredSummary').append(`<div class="row tyre-detail-summary-titles d-none d-md-flex">` + `<span class=col-md-3>&nbsp;</span>` + `<span class="col-md-4">Tyre Size</span> ` + `<span class="col-md-2">Brand</span> ` + `<span class="col-md-2">Damage</span> ` + `</div>`);
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreDetailLines.forEach((tyre)=>{
            _this.addTyreDetailSummary(_.assignInWith({}, tyre, {
                title: wheelPlan[tyre.wheelSelected].Name
            }), tyre.wheelSelected);
        });
        summaryPanel.find('#wheelType, #lockingWheelNuts, #roadworthySpare, #spareSize, #inflationKit, #obstructions').closest('.row').hide();
        // Wheel Details
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.wheelType && summaryPanel.find('#wheelType').text((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.wheelType).closest('.row').show();
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.lockingWheelNuts && summaryPanel.find('#lockingWheelNuts').text((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.lockingWheelNuts).closest('.row').show();
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.roadworthySpare && summaryPanel.find('#roadworthySpare').text((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.roadworthySpare).closest('.row').show();
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.spareSize && summaryPanel.find('#spareSize').text((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.spareSize).closest('.row').show();
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.inflationKit && summaryPanel.find('#inflationKit').text((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.inflationKit).closest('.row').show();
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.obstructions && summaryPanel.find('#obstructions').text((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.obstructions).closest('.row').show();
        if ((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.obstructionDetails) {
            summaryPanel.find('#obstructionsComment').closest('.row').show();
            summaryPanel.find('#obstructionsComment').text((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.obstructionDetails);
        } else summaryPanel.find('#obstructionsComment').closest('.row').hide();
        // Address details
        var serviceRequired = (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.serviceRequired;
        if (serviceRequired === 'D') {
            summaryPanel.find('#appointmentType').text('Garage Booking');
            if ((0, $254a84bc556d8bd3$export$366dc4c52172531e).DoNotAllowDepotSelection()) {
                summaryPanel.find('#garageDetails').hide();
                summaryPanel.find('#jobLocationDetails').hide();
            } else {
                var depot = (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.depot;
                summaryPanel.find('#garageName').text(depot.name);
                summaryPanel.find('#garageAddress1').text(depot.address1);
                if (depot.address2) {
                    summaryPanel.find('#garageAddress2').closest('.row').show();
                    summaryPanel.find('#garageAddress2').text(depot.address2);
                } else summaryPanel.find('#garageAddress2').closest('.row').hide();
                summaryPanel.find('#garageTown').text(depot.town);
                var county = summaryPanel.find('#garageCounty');
                if (depot.county === '') county.closest('.row').hide();
                else {
                    county.closest('.row').show();
                    county.text(depot.county);
                }
                summaryPanel.find('#garagePostcode').text(depot.postcode);
                // Show correct address panel
                summaryPanel.find('#garageDetails').show();
                summaryPanel.find('#jobLocationDetails').hide();
            }
        } else if (serviceRequired === 'M') {
            // Populate job location details
            var jobLocation = (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.location;
            summaryPanel.find('#jobLocationAddress1').text(jobLocation.line1);
            if (jobLocation.line2) {
                summaryPanel.find('#jobLocationAddress2').closest('.row').show();
                summaryPanel.find('#jobLocationAddress2').text(jobLocation.line2);
            } else summaryPanel.find('#jobLocationAddress2').closest('.row').hide();
            summaryPanel.find('#jobLocationTown').text(jobLocation.town);
            summaryPanel.find('#jobLocationCounty').text(jobLocation.county);
            summaryPanel.find('#jobLocationPostCode').text(jobLocation.postcode);
            // Show correct address panel
            summaryPanel.find('#garageDetails').hide();
            summaryPanel.find('#jobLocationDetails').show();
            var jobType = (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.jobType ? (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.jobTypeName : 'Mobile';
            summaryPanel.find('#appointmentType').text(jobType);
        }
        if (SITE_CAN_SELECT_MULTIPLE_DATES) {
            //Job types are only currently set for mfs
            if ((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.jobType && serviceRequired === 'M') {
                summaryPanel.find('#appointmentDate').closest('.row').hide();
                summaryPanel.find('#appointmentTime').closest('.row').hide();
                summaryPanel.find('#appointmentDate2').closest('.row').hide();
                summaryPanel.find('#appointmentTime2').closest('.row').hide();
                summaryPanel.find('#appointmentDate3').closest('.row').hide();
                summaryPanel.find('#appointmentTime3').closest('.row').hide();
            } else {
                // Appointment date and time
                let bookingTime = (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime === 'am' ? 'Morning' : (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime === 'pm' ? 'Afternoon' : (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime;
                summaryPanel.find('#appointmentDate').text((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingDate);
                summaryPanel.find('#appointmentTime').text(bookingTime);
                let bookingTime2 = (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime2 === 'am' ? 'Morning' : (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime2 === 'pm' ? 'Afternoon' : (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime2;
                summaryPanel.find('#appointmentDate2').text((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingDate2);
                summaryPanel.find('#appointmentTime2').text(bookingTime2);
                let bookingTime3 = (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime3 === 'am' ? 'Morning' : (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime3 === 'pm' ? 'Afternoon' : (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime3;
                summaryPanel.find('#appointmentDate3').text((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingDate3);
                summaryPanel.find('#appointmentTime3').text(bookingTime3);
                summaryPanel.find('a').off();
                summaryPanel.find('a').on('click', function() {
                    let anchor = $(this).data().sectionAnchor;
                    if (anchor) {
                        // Show the button that allows navigation back to summary
                        let targetSection = _this.sections.collection.find((section)=>section.anchor === anchor).dom;
                        if (targetSection.find(".back-to-summary")) targetSection.find(".back-to-summary").show();
                        // Re-bind buttons, so that events work with dynamic tyre sections
                        $('.back-to-summary').off();
                        $('.back-to-summary').on('click', function(_event) {
                            _this.sections.moveTo('summaryAnchor');
                        });
                    }
                    _this.sections.moveTo(anchor);
                });
            }
        } else //Job types are only currently set for mfs
        if ((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.jobType && serviceRequired === 'M') {
            summaryPanel.find('#appointmentDate').closest('.row').hide();
            summaryPanel.find('#appointmentTime').closest('.row').hide();
        } else {
            // Appointment date and time
            let time = (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime === 'am' ? 'Morning' : (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime === 'pm' ? 'Afternoon' : (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime;
            summaryPanel.find('#appointmentDate').text((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingDate);
            summaryPanel.find('#appointmentTime').text(time);
            summaryPanel.find('a').off();
            summaryPanel.find('a').on('click', function() {
                let anchor = $(this).data().sectionAnchor;
                if (anchor) {
                    // Show the button that allows navigation back to summary
                    let targetSection = _this.sections.collection.find((section)=>section.anchor === anchor).dom;
                    if (targetSection.find(".back-to-summary")) targetSection.find(".back-to-summary").show();
                    // Re-bind buttons, so that events work with dynamic tyre sections
                    $('.back-to-summary').off();
                    $('.back-to-summary').on('click', function(_event) {
                        _this.sections.moveTo('summaryAnchor');
                    });
                }
                _this.sections.moveTo(anchor);
            });
        }
    }
    addTyreDetailSummary(tyre, anchorPosition) {
        const { title: title, brand: brand, width: width, ratio: ratio, diameter: diameter, load: load, rating: rating, construction: construction, damageType: damageType } = tyre;
        let tyrePosition = `<div class="col-md-3"><label>${title}</label></div>`;
        $('#workRequiredSummary').append(`<div class="row">` + `${tyrePosition} <span class="col-md-4">${width}/${ratio} R${diameter} ${load} ${rating} ${construction}</span> ` + `<span class="col-md-2">${brand}</span>` + `<span class="col-md-2">${damageType.Name}</span>` + `</div>`);
    }
    buildConfirmation() {
        let _this = this;
        var $confirmationPanel = _this.sections.collection.find((section)=>section.name === 'confirmation').dom;
        $confirmationPanel.find('#driverTitle').text((0, $a854c42000216589$export$bd25e24024963319).driver.title);
        $confirmationPanel.find('#driverFirstName').text((0, $a854c42000216589$export$bd25e24024963319).driver.surname);
        if (SITE_DO_REDIRECT.toLowerCase() === 'false') $confirmationPanel.find('#customerHomeLink').css('display', 'none');
        else {
            $confirmationPanel.find('#customerHomeLink').text(`Return to ${(0, $a854c42000216589$export$bd25e24024963319).customer.name} Home`);
            $confirmationPanel.find('#customerHomeLink').attr("href", (0, $a854c42000216589$export$bd25e24024963319).customer.homeLink);
        }
        if ((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.lockingWheelNuts) $confirmationPanel.find('#lockingWheelNuts').css('display', 'list-item');
        else $confirmationPanel.find('#lockingWheelNuts').css('display', 'none');
        if ((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.serviceRequired) {
            if ((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.serviceRequired === 'D' && !(0, $254a84bc556d8bd3$export$366dc4c52172531e).DoNotAllowDepotSelection()) {
                $confirmationPanel.find('#depotAddress').show();
                $confirmationPanel.find('#garageName').text((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.depot.name);
                $confirmationPanel.find('#garageAddress1').text((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.depot.address1);
                $confirmationPanel.find('#garageAddress2').text((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.depot.address2);
                $confirmationPanel.find('#garageTown').text((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.depot.town);
                $confirmationPanel.find('#garageCounty').text((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.depot.county);
                $confirmationPanel.find('#garagePostcode').text((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.depot.postcode);
                $confirmationPanel.find('#arriveAtDepotEarly').css('display', 'list-item');
                $confirmationPanel.find('#depotWillInspect').css('display', 'list-item');
                $confirmationPanel.find('#fitterTimeOfArrival').css('display', 'none');
                $confirmationPanel.find('#spaceForFitting').css('display', 'none');
            } else if ((0, $a854c42000216589$export$bd25e24024963319).bookingDetails.serviceRequired === 'M') {
                $confirmationPanel.find('#depotAddress').hide();
                $confirmationPanel.find('#arriveAtDepotEarly').css('display', 'none');
                $confirmationPanel.find('#depotWillInspect').css('display', 'none');
                $confirmationPanel.find('#fitterTimeOfArrival').css('display', 'list-item');
                $confirmationPanel.find('#spaceForFitting').css('display', 'list-item');
            }
        }
        $('#smsConfirmationRequested').hide();
        if ($('#CheckBoxSendSMSConfirmation').is(':checked')) $('#smsConfirmationRequested').show();
    }
    bindFormControls() {
        let _this = this;
        $.each(_this.sections.collection, function(index, section) {
            if (!section.anchor) return;
            var dynamicAnchors = [
                'NSFAnchor',
                'NSRAnchor',
                'OSFAnchor',
                'OSRAnchor',
                'NSR2Anchor',
                'OSR2Anchor'
            ];
            var isTyreDetail = dynamicAnchors.indexOf(section.anchor) > -1;
            var breadcrumbsListItem;
            breadcrumbsListItem = '<li ' + (isTyreDetail === true ? 'style="display: none;"' : '') + ' data-menuanchor="' + section.anchor + '">';
            breadcrumbsListItem += '<a href="#' + section.anchor + '">';
            breadcrumbsListItem += '<div class="d-md-none d-lg-none">' + parseInt(parseInt(index) + 1) + '</div>';
            breadcrumbsListItem += '<div class="text-center">' + _this.navigationTexts[index] + '</div>';
            breadcrumbsListItem += '</a>';
            breadcrumbsListItem += '</li>';
            $('#serviceBreadcrumb').append(breadcrumbsListItem);
        });
        _this.bindButtons();
        (0, $254a84bc556d8bd3$export$366dc4c52172531e).BuildMobileBreadcrumbNav();
        $('#fullPageContainer').show();
        kendo.ui.progress($('body'), false);
    }
    cleanValues(value) {
        if (value) {
            if (value.toUpperCase() === 'YES') value = true;
            else if (value.toUpperCase() === 'NO') value = false;
        }
        return value;
    }
    createJob() {
        let _this = this;
        // reset any yes/no to true/false.
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.lockingWheelNuts = _this.cleanValues((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.lockingWheelNuts);
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.roadworthySpare = _this.cleanValues((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.roadworthySpare);
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.inflationKit = _this.cleanValues((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.inflationKit);
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.obstructions = _this.cleanValues((0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails.obstructions);
        let vehicle = {
            WheelPlan: (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelPlan,
            WheelDetails: (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelDetails,
            VehicleDetails: (0, $a854c42000216589$export$bd25e24024963319).vehicle.vehicleDetails,
            TyreDetailLines: (0, $a854c42000216589$export$bd25e24024963319).vehicle.tyreDetailLines,
            WheelsSelected: (0, $a854c42000216589$export$bd25e24024963319).vehicle.wheelsSelected,
            Class: (0, $a854c42000216589$export$bd25e24024963319).vehicle.class,
            SubDomainCode: (0, $a854c42000216589$export$bd25e24024963319).vehicle.subDomainCode
        };
        var bookingDetails = {
            ServiceRequired: (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.serviceRequired,
            BookingDate: (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingDate,
            BookingTime: (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime,
            BookingDate2: (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingDate2,
            BookingTime2: (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime2,
            BookingDate3: (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingDate3,
            BookingTime3: (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.bookingTime3,
            Location: (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.location,
            Depot: (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.depot,
            AddressType: (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.addressType,
            JobType: (0, $a854c42000216589$export$bd25e24024963319).bookingDetails.jobType
        };
        let serverData = {
            driver: (0, $a854c42000216589$export$bd25e24024963319).driver,
            vehicle: vehicle,
            bookingDetails: bookingDetails
        };
        $.ajax({
            type: 'POST',
            url: '/tyres/createjob',
            data: serverData,
            success: function(data, status, xhr) {
                if (xhr.status !== 200) (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowGenericError();
            },
            error: function(xhr, ajaxOptions, thrownError) {
                (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowGenericError();
            }
        });
    }
    setVehicle(vehicleIn) {
        this.vehicleViewModel = vehicleIn;
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.class = vehicleIn.class;
        (0, $a854c42000216589$export$bd25e24024963319).vehicle.subDomainCode = vehicleIn.subDomainCode;
        let reg = $('#vehicle-search-input').val();
        this.vehicleViewModel.registrationNumber = reg.replace(' ', '');
        $("#CustomerCompanyId").val(vehicleIn.customerCompanyId);
    }
    initialiseVehicleModel() {
        let _this = this;
        $('#VehicleID').val(_this.vehicleViewModel.id);
        $('#VehicleMileage').val(_this.vehicleViewModel.mileage);
        const vehicleDetailSectionId = _this.sections.collection.find((section)=>section.name === 'vehicleDetail').dom.prop('id');
        $.post({
            url: '/Vehicle/GetVehiclePartial',
            data: {
                "vehicleRegistration": _this.vehicleViewModel.registrationNumber
            },
            success: function(vehiclePartial) {
                $(`#${vehicleDetailSectionId} #vehicle-model`).html('');
                $(`#${vehicleDetailSectionId} #vehicle-model`).append(vehiclePartial);
                if (_this.vehicleViewModel.mileageCheckSuppression) {
                    $(`#${vehicleDetailSectionId} #mileageInput`).hide();
                    $(`#${vehicleDetailSectionId} #ConfirmMileageContainer`).hide();
                }
                if (!_this.disableMoveNext) _this.sections.moveNext();
            }
        });
    }
}
// Kendo duplicating the first error message on the first error-label
function $6d1a12d73f412bf4$var$removeDuplicateErrorMessages() {
    $('i.error-icon').each(function() {
        const $icon = $(this);
        const originalTitle = $icon.attr('data-original-title');
        if (originalTitle) {
            const messages = originalTitle.split(/\s{2,}/).map((msg)=>msg.trim()).filter((msg)=>msg !== '');
            const uniqueMessages = [
                ...new Set(messages)
            ];
            const updatedTitle = uniqueMessages.join('  ');
            $icon.attr('data-original-title', updatedTitle);
        }
    });
}
function $6d1a12d73f412bf4$var$isValidPostcode(postcode) {
    var valid = false;
    $.ajax({
        url: `address/validpostcode?postcode=${postcode}`,
        type: 'get',
        async: false,
        success: (data, textStatus, xhr)=>{
            valid = data;
        },
        error: (error)=>{
            alert("Apologies something went wrong.");
            document.location.reload(true);
        }
    });
    return valid;
}
var $6d1a12d73f412bf4$export$2e2bcd8739ae039 = $6d1a12d73f412bf4$var$TyresForm;



let $f90b7548d54d161a$export$666e18616453c6f6;
let $f90b7548d54d161a$export$86c665894cf791e;
let $f90b7548d54d161a$var$vehicleLookup;
class $f90b7548d54d161a$export$2e2bcd8739ae039 {
    constructor(){
        // local fields
        this._vehicle = undefined;
        // Class initialization
        this.BindFormControls();
        if ($('#ServiceIdentifier').val() === 'TYRES') $f90b7548d54d161a$export$86c665894cf791e = new (0, $6d1a12d73f412bf4$export$2e2bcd8739ae039)();
    }
    // --------------------------------------------------
    // GETTER AND SETTER
    // --------------------------------------------------
    get Vehicle() {
        return this._vehicle;
    }
    set Vehicle(newVehicle) {
        this._vehicle = newVehicle;
    }
    // --------------------------------------------------
    // FUNCTIONS
    // --------------------------------------------------
    BindFormControls() {
        let _this = this;
        if ($('#ServiceIdentifier').val()) $('#vehicle-search-input').focus();
        else $('#Registration').focus();
        $('.i247service .fa-info-circle').click(function() {
            var windowText = $(this).data('infotext');
            var windowTitle = $(this).data('infotitle');
            var infoWindow = $('#infoWindow').kendoWindow({
                width: 'auto',
                height: 'auto',
                position: {
                    top: 100
                }
            }).data('kendoWindow');
            infoWindow.title(windowTitle);
            infoWindow.content(windowText);
            infoWindow.center().open();
        });
        $('#ButtonSearchAgain').click(function() {
            $('#PrivacyStatement').hide();
            $('#SearchAgain').hide();
            $('#ServiceList').hide();
            $('#ServicesHeader').hide();
            $('#SearchForm').show();
        });
        $('#PrivacyCheckBox').change(function() {
            if ($(this).is(':checked')) _this.BindServiceButtons(true);
            else _this.BindServiceButtons(false);
        });
    }
    GetVehicle(vehicleRegistration, grecaptcharesponse) {
        let result = $.Deferred();
        // send the q as well, which has the customer id in it to filter the vehicles returned.
        let queryString = (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).GetQueryStringValue('q', null);
        let url = '/vehicle/GetVehicle?q=' + queryString + '&vehicleRegistration=' + vehicleRegistration + '&grecaptcharesponse=' + grecaptcharesponse;
        $.ajax({
            url: url,
            type: 'GET',
            cache: false,
            success: (data)=>{
                result.resolve(data);
            },
            error: (xhr, ajaxOptions, thrownError)=>{
                console.log(xhr.status);
                console.log(xhr.responseText);
                console.log(thrownError);
                kendo.ui.progress($('body'), false);
                (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowGenericError();
            }
        });
        return result.promise();
    }
    GetVehicleServices(vehicleRegistration) {
        var result = $.Deferred();
        var url = '/vehicle/GetServices?vehicleRegistration=' + vehicleRegistration;
        $.ajax({
            url: url,
            type: 'GET',
            cache: false,
            success: function(data) {
                result.resolve(data);
            },
            error: function(xhr, ajaxOptions, thrownError) {
                console.log(xhr.status);
                console.log(xhr.responseText);
                console.log(thrownError);
                kendo.ui.progress($('body'), false);
                (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowGenericError();
            },
            complete: function() {}
        });
        return result.promise();
    }
    DoLookup(registration, grecaptcharesponse) {
        let _this = this;
        var serviceIdentifier = $('#ServiceIdentifier').val();
        // Retrieve from Site Settings
        var canCreateNewBookingWithExistingBooking = JSON.parse($('#CanCreateNewBookingWithExistingBooking').val());
        $.get("tyres/CustomerLink").fail(function() {
            (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowGenericError();
        }).done(function(customer) {
            if (serviceIdentifier) {
                kendo.ui.progress($('body'), true);
                (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).HideUserMessage();
                const registration = $('#vehicle-search-input').val().replace(' ', '').toUpperCase();
                var vehicleNotFoundMessage = '';
                switch(subdomain){
                    case 'novuna':
                        vehicleNotFoundMessage = `<p>Sorry no details are currently held on our system for registration ${registration}.</p><p>You may want to check the registration entered.</p><p>Please check this is a Novuna vehicle. If you still encounter issues please call your Driverline and select the option for tyres where one of the team will be able to assist.</p><p><a class="btn btn-success" href="/">Try again</a></p>`;
                        break;
                    case 'mfs':
                        vehicleNotFoundMessage = `<p>Sorry no details are currently held against registration ${registration}.</p><p>Please check this is a Babcock vehicle and then contact the tyre team on <a href="tel:01202611567">01202 611567</a> where one of the team will be able to assist.</p><p>You may want to check the registration entered.</p><p><a class="btn btn-success" href="/">Try again</a></p>`;
                        break;
                    default:
                        var customerName = '';
                        switch(customer.name){
                            case 'Micheldever':
                                customerName = "Micheldever Fleet Solutions";
                                break;
                            case 'Vms':
                                customerName = "VMS";
                                break;
                            case 'Omodaandjaecoo':
                                customerName = "Omoda and Jaecoo Contract Hire";
                                break;
                            case 'Mg':
                                customerName = 'MG Contract Hire';
                                break;
                            case 'Hyundai':
                                customerName = 'Hyundai Contract Hire';
                                break;
                            case 'Honda':
                                customerName = 'Honda Contract Hire';
                                break;
                            case 'Byd':
                                customerName = "BYD";
                                break;
                            default:
                                customerName = customer.name;
                                break;
                        }
                        vehicleNotFoundMessage = `<p>Sorry no details are currently held against registration ${registration}.</p><p>Please check this vehicle is covered for tyres through ${customerName} then call your Driverline and select the option for tyres where one of the team will be able to assist.</p><p>You may want to check the registration entered.</p><p><a class="btn btn-success" href="/">Try again</a></p>`;
                        break;
                }
                _this.GetVehicle(registration, grecaptcharesponse).done((vehicle1)=>{
                    if (!vehicle1) {
                        (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowUserMessage('Vehicle Not Found', vehicleNotFoundMessage, true);
                        kendo.ui.progress($('body'), false);
                        return;
                    } else {
                        var message = '';
                        var title = '';
                        var showCreateBookingWarning = false;
                        if (vehicle1.existingBooking && !(0, $254a84bc556d8bd3$export$366dc4c52172531e).IsMfs()) {
                            if (canCreateNewBookingWithExistingBooking) {
                                showCreateBookingWarning = true;
                                kendo.ui.progress($('body'), false);
                                $('#existing-booking-found-for-vehicle-message').show();
                            } else {
                                message = "It appears we\u2019ve already received an appointment request for this vehicle which our team are attempting to coordinate with our approved garages. Please rest assured the team will be in contact shortly with confirmation once a booking has been secured that can facilitate the work requirements and appointment preferences. If you\u2019d like to alter this appointment please call your Driverline. Thank you for your patience.";
                                title = 'Existing Booking';
                            }
                        } else if ((0, $254a84bc556d8bd3$export$366dc4c52172531e).IsMfs()) {
                            var validClassList = [
                                'car',
                                'lcv'
                            ];
                            if (!vehicle1.class || !validClassList.includes(vehicle1.class.toLowerCase())) {
                                message = 'We are unable to process this request online, please call 01202 611567.';
                                title = 'Please Call Us';
                            }
                        }
                        $f90b7548d54d161a$export$86c665894cf791e.disableMoveNext = showCreateBookingWarning;
                        if (message.length > 0) {
                            (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowUserMessage(title, message, true);
                            kendo.ui.progress($('body'), false);
                            return;
                        }
                    }
                    _this.Vehicle = vehicle1;
                    if (!_this.Vehicle.maintained || _this.Vehicle.maintained && _this.Vehicle.maintained.toUpperCase() != 'Y') {
                        $('#no-tyre-services-found-for-vehicle-message').show();
                        $('#ServicesHeader').hide();
                        kendo.ui.progress($('body'), false);
                    } else _this.GetVehicleServices(_this.Vehicle.registration).done(function(services) {
                        if (services.length === 0 || services.indexOf(serviceIdentifier) === -1) {
                            switch(subdomain){
                                case 'omodaandjaecoo':
                                case 'mg':
                                case 'hyundai':
                                case 'honda':
                                case 'byd':
                                    $('#no-tyre-services-found-for-vehicle-message').show();
                                    break;
                                default:
                                    $('#no-services-found-for-vehicle-message').show();
                                    break;
                            }
                            $('#ServicesHeader').hide();
                            kendo.ui.progress($('body'), false);
                        } else {
                            $('#ServicesHeader').show();
                            $('#no-services-found-for-vehicle-message').hide();
                            if (serviceIdentifier === 'TYRES') {
                                kendo.ui.progress($('body'), false);
                                $f90b7548d54d161a$export$86c665894cf791e.setVehicle(_this.Vehicle);
                                $f90b7548d54d161a$export$86c665894cf791e.initialiseVehicleModel();
                            }
                        }
                    });
                });
            } else {
                $('#PrivacyCheckBox').attr('checked', false);
                kendo.ui.progress($('body'), true);
                (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).HideUserMessage();
                $('#ServicesHeader').hide();
                $('#ServiceList').hide();
                _this.GetVehicle(registration, grecaptcharesponse).done(function(vehicles) {
                    if (!vehicle) {
                        (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowUserMessage('Vehicle Not Found', vehicleNotFoundMessage, true);
                        kendo.ui.progress($('body'), false);
                        return;
                    }
                    var selectedServiceUrl = $('#SelectedServiceUrl').val();
                    if (selectedServiceUrl !== '') {
                        window.location = selectedServiceUrl;
                        return;
                    }
                    _this.Vehicle = vehicles[0];
                    _this.GetVehicleServices(_this.Vehicle.registration).done(function(services) {
                        kendo.ui.progress($('body'), false);
                        $('.i247service').hide();
                        $('#SearchAgain').hide();
                        $('#ServiceList').hide();
                        $('#PrivacyStatement').hide();
                        if (services.length === 0) {
                            (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).ShowUserMessage('Unable to Proceed', `<p>We could not find any services associated with vehicle registration ${_this.Vehicle.registration}.</p><p>Please call your dedicated Driverline for assistance.</p>`, true);
                            return;
                        } else {
                            $('#PrivacyStatement').show();
                            $('#ServicesHeader').show();
                            $('#HeaderRegistration').text(registration.toUpperCase());
                            $('#HeaderVehicleMake').text(_this.Vehicle.manufacturer);
                            $('#HeaderVehicleDescription').text(_this.Vehicle.description);
                            $('#HeaderVehicleLeaseCompany').text(_this.Vehicle.customerName);
                            $('#HeaderVehicleDriverCompany').text(_this.Vehicle.driverCompanyName);
                            $('#SearchAgain').show();
                            $('#SearchForm').hide();
                        }
                        $.each(services, function(i, service) {
                            var selector = '#DIV' + service.toUpperCase();
                            $(selector).show();
                        });
                    });
                });
            }
        });
    }
    BindServiceButtons(ShowService) {
        $('.i247service .gobutton').unbind('click');
        if (ShowService) {
            $('#ServiceList').slideDown();
            $('.i247service .gobutton').click(function() {
                window.location = $(this).data('url');
            });
        } else {
            $('#ServiceList').slideUp();
            $('.i247service .gobutton').click(function() {
                if (!$('#PrivacyCheckBox').is(':checked')) $('#PrivacyCheckBox').kendoTooltip({
                    width: 240,
                    position: 'top',
                    animation: {
                        open: {
                            effects: 'zoom',
                            duration: 150
                        }
                    }
                }).data('kendoTooltip').show();
            });
        }
    }
}
// Google Captcha Callback (Needs to be in global scope)
function $f90b7548d54d161a$var$RecaptchaCallBack(result) {
    let validator = $('#VehicleSearchFormContainer').kendoValidator().data('kendoValidator');
    (0, $f736a2b71cdbd3b5$export$2e2bcd8739ae039).BindValidationStyles(validator);
    let recaptchaResponse = grecaptcha.getResponse();
    if (!validator.validate()) return;
    let registration = $('#Registration').val();
    if ($('#ServiceIdentifier').val()) registration = $('#vehicle-search-input').val();
    registration = registration.replace(' ', '');
    grecaptcha.reset();
    $f90b7548d54d161a$var$vehicleLookup.DoLookup(registration, recaptchaResponse);
}
$(function() {
    $f90b7548d54d161a$var$vehicleLookup = new $f90b7548d54d161a$export$2e2bcd8739ae039();
    window.grecaptcha.ready(()=>{
        grecaptcha.render('vehicle-search-button', {
            'sitekey': '6LecsgkbAAAAAB6gO3yIsno1RUQoGE3VXB3rEjX3',
            'callback': $f90b7548d54d161a$var$RecaptchaCallBack
        });
    });
});



})();
//# sourceMappingURL=app.bundle.js.map
